<template>
  <div class="pvt-root">
    <FirmaEntrega v-if="entrega.firmaVisible" :numero-envio="entrega.envio ? entrega.envio.no_envio : ''"
      :mensaje="entrega.mensaje" @cancelar="limpiarFirmaEntrega" @confirmar="confirmarFirmaEntrega" />
    <v-dialog v-model="firmaConsulta.visible" max-width="720">
      <v-card>
        <v-card-title>Firma de entrega</v-card-title>
        <v-card-text><img v-if="firmaConsulta.imagen" :src="firmaConsulta.imagen" alt="Firma guardada del destinatario" style="display: block; max-width: 100%; max-height: 360px; margin: auto;" /><p v-else>Este envio no tiene una firma de entrega disponible.</p></v-card-text>
        <v-card-actions><v-spacer /><v-btn text @click="firmaConsulta.visible = false">Cerrar</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
    <div class="pvt-topbar">
      <div><strong>Sucursal:</strong> {{ contexto.sucursal }}</div>
      <div><strong>Fecha:</strong> {{ fechaTrabajo }}</div>
      <div><strong>Cajero:</strong> {{ contexto.cajero }}</div>
      <div class="pvt-topbar-line">
        <span><strong>Caja:</strong> {{ contexto.cajaNombre }}</span>
        <span><strong>Cierre:</strong> {{ contexto.numeroCierre }}</span>
        <span><strong>e-CF:</strong> {{ contexto.facturacionElectronicaActiva ? 'Activo' : 'No activo' }}</span>
        <button type="button" class="pvt-link-btn" :disabled="guardando || entrega.guardando || entrega.firmaVisible || lectura.leyendo || !!ecf.procesando" @click="cambiarConfiguracionCaja">Cambiar caja</button>
        <button v-if="contexto.facturacionElectronicaActiva" type="button" class="pvt-link-btn" @click="abrirComprobantesElectronicos"><i class="fa fa-list" aria-hidden="true"></i> Comprobantes e-CF</button>
      </div>
    </div>
    <div v-if="capacidadEdicion.visible" class="pvt-setup-overlay">
      <form class="pvt-setup pvt-panel" role="dialog" aria-label="Capacidad del vehiculo" aria-modal="true" @submit.prevent="guardarCapacidad">
        <h3>Capacidad de la ficha {{ turno.ficha }}</h3>
        <label>Asientos<input ref="capacidadAsientos" v-model.number="capacidadEdicion.valor" type="number" min="0" step="1" required :disabled="capacidadEdicion.guardando"></label>
        <div v-if="capacidadEdicion.error" class="pvt-message error" role="alert">{{ capacidadEdicion.error }}</div>
        <div class="pvt-dialog-actions">
          <button type="button" class="pvt-action" :disabled="capacidadEdicion.guardando" @click="capacidadEdicion.visible = false">Cancelar</button>
          <button type="submit" class="pvt-action" :disabled="capacidadEdicion.guardando"><i class="fa fa-save" aria-hidden="true"></i> Guardar</button>
        </div>
      </form>
    </div>
    <div v-if="ecf.visible" class="pvt-setup-overlay">
      <div class="pvt-consulta-viajes pvt-panel pvt-ecf-dialog" role="dialog" aria-label="Comprobantes electronicos de la caja" aria-modal="true">
        <h3>Comprobantes electronicos de la caja</h3>
        <div class="pvt-dialog-actions">
          <button type="button" class="pvt-action" :disabled="ecf.cargando || !!ecf.procesando" @click="cargarComprobantesElectronicos(ecf.pagina)"><i class="fa fa-refresh" aria-hidden="true"></i> Actualizar</button>
          <button type="button" class="pvt-action" title="Pagina anterior" aria-label="Pagina anterior" :disabled="ecf.cargando || !!ecf.procesando || ecf.pagina === 0" @click="cargarComprobantesElectronicos(ecf.pagina - 1)"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
          <span>Pagina {{ ecf.pagina + 1 }}</span>
          <button type="button" class="pvt-action" title="Pagina siguiente" aria-label="Pagina siguiente" :disabled="ecf.cargando || !!ecf.procesando || ecf.facturas.length < 100" @click="cargarComprobantesElectronicos(ecf.pagina + 1)"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
          <button type="button" class="pvt-action" @click="ecf.visible = false">Regresar</button>
          <form class="pvt-ecf-search" @submit.prevent="buscarComprobantesElectronicos">
            <label for="pvt-ecf-ncf">NCF</label>
            <input id="pvt-ecf-ncf" v-model.trim="ecf.busquedaNcf" type="search" maxlength="13" autocomplete="off" placeholder="Buscar NCF" :disabled="ecf.cargando || !!ecf.procesando">
            <button type="submit" class="pvt-action" title="Buscar NCF" aria-label="Buscar NCF" :disabled="ecf.cargando || !!ecf.procesando"><i class="fa fa-search" aria-hidden="true"></i></button>
            <button v-if="ecf.busquedaNcf || ecf.ncfFiltro" type="button" class="pvt-action" title="Limpiar busqueda" aria-label="Limpiar busqueda" :disabled="ecf.cargando || !!ecf.procesando" @click="limpiarBusquedaComprobantes"><i class="fa fa-times" aria-hidden="true"></i></button>
          </form>
        </div>
        <div v-if="ecf.error" class="pvt-message error" role="alert">{{ ecf.error }}</div>
        <div class="pvt-table-wrap pvt-consulta-table">
          <table class="pvt-table">
            <thead><tr><th>e-NCF</th><th>Estado</th><th>Resultado</th><th></th></tr></thead>
            <tbody>
              <tr v-for="f in ecf.facturas" :key="claveFactura(f)">
                <td>{{ f.ncf }}</td><td>{{ f.estado }}</td><td class="pvt-ecf-result">{{ f.mensaje }}</td>
                <td class="pvt-ecf-actions">
                  <button v-if="f.aceptada" type="button" class="pvt-action" :disabled="ecf.cargando || !!ecf.procesando" @click="reimprimirComprobanteElectronico(f)"><i class="fa fa-print" aria-hidden="true"></i> Reimprimir</button>
                  <button v-else-if="f.estado !== 'RECHAZADO'" type="button" class="pvt-action" :disabled="ecf.cargando || !!ecf.procesando" @click="reintentarComprobanteElectronico(f)"><i class="fa fa-refresh" aria-hidden="true"></i> {{ f.estado === 'PENDIENTE_ENVIO' ? 'Reintentar' : 'Consultar' }}</button>
                  <button type="button" class="pvt-action" title="Descargar XML completo firmado" aria-label="Descargar XML completo firmado" :disabled="ecf.cargando || !!ecf.procesando || f.tieneXmlCompleto === false" @click="descargarXmlElectronico(f, 'completo')"><i class="fa fa-download" aria-hidden="true"></i> XML completo</button>
                  <button type="button" class="pvt-action" title="Descarga de XML de envio deshabilitada" aria-label="Descarga de XML de envio deshabilitada" disabled><i class="fa fa-download" aria-hidden="true"></i> XML envio</button>
                </td>
              </tr>
              <tr v-if="!ecf.facturas.length"><td colspan="4">{{ ecf.cargando ? 'Cargando...' : ecf.ncfFiltro ? 'No hay comprobantes para ese NCF en esta caja.' : 'No hay comprobantes electronicos recientes.' }}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="cortesia.visible" class="pvt-setup-overlay">
      <form class="pvt-setup pvt-panel" role="dialog" aria-modal="true" aria-labelledby="pvt-cortesia-titulo"
        @submit.prevent="buscarCortesia" @keydown.esc.prevent="cerrarCortesia">
        <h3 id="pvt-cortesia-titulo"><i class="fa fa-barcode" aria-hidden="true"></i> Cortesia por cedula</h3>
        <label>Cedula / codigo de barras
          <input ref="cedulaCortesia" v-model.trim="cortesia.identificacion" autocomplete="off" maxlength="256"
            @keydown.enter.stop.prevent="buscarCortesia"
            :disabled="cortesia.cargando || guardando" aria-label="Cedula o codigo de barras del beneficiario">
        </label>
        <div v-if="cortesia.error" class="pvt-message error" role="alert">{{ cortesia.error }}</div>
        <div class="pvt-dialog-actions">
          <button type="button" class="pvt-action" :disabled="guardando" @click="cerrarCortesia"><i class="fa fa-arrow-left" aria-hidden="true"></i> Regresar</button>
          <button type="submit" class="pvt-action" :disabled="cortesia.cargando || guardando || !cortesia.identificacion">
            <i class="fa fa-check" aria-hidden="true"></i> {{ cortesia.cargando ? 'Consultando...' : 'Aceptar' }}
          </button>
        </div>
      </form>
    </div>

    <div v-if="configuracionCaja.visible" class="pvt-setup-overlay">
      <div class="pvt-setup pvt-panel">
        <h3>Asignar caja de venta</h3>
        <div class="pvt-dialog-grid">
          <label>Sucursal
            <select v-model.number="configuracionCaja.sucursalId" @change="seleccionarSucursalConfiguracion">
              <option :value="null">Seleccione sucursal</option>
              <option v-for="sucursal in sucursalesDisponibles" :key="sucursal.codigo" :value="Number(sucursal.codigo)">
                {{ nombreSucursalConfiguracion(sucursal) }}
              </option>
            </select>
          </label>
          <label>Caja
            <select v-model.number="configuracionCaja.cajaId" @change="seleccionarCajaConfiguracion">
              <option :value="null">Seleccione caja</option>
              <option v-for="caja in cajasFiltradasConfiguracion" :key="caja.codigo" :value="Number(caja.codigo)">
                {{ nombreCajaConfiguracion(caja) }}
              </option>
            </select>
          </label>
          <label>Nombre de caja<input v-model="configuracionCaja.cajaNombre" autocomplete="off" readonly></label>
          <label>Impresora tickets
            <select v-model="configuracionCaja.impresoraTickets" :disabled="configuracionCaja.vistaPreviaPdf" @focus="cargarImpresorasLocales">
              <option value="">Seleccione impresora</option>
              <option v-for="impresora in impresorasLocales" :key="impresora.nombre" :value="impresora.nombre">
                {{ impresora.nombre }}
              </option>
            </select>
          </label>
        </div>
        <label class="pvt-check"><input type="checkbox" v-model="configuracionCaja.vistaPreviaPdf" @change="cargarImpresorasLocales" /> Vista previa PDF de boletos y envios en este dispositivo (sin programa de impresora)</label>
        <div class="pvt-dialog-actions">
          <button v-if="contexto.caja" type="button" class="pvt-action" @click="configuracionCaja.visible = false">Cancelar</button>
          <button type="button" class="pvt-action" @click="guardarConfiguracionCaja">Aceptar</button>
        </div>
        <div v-if="mensaje" class="pvt-message" :class="mensajeTipo">
          <span>{{ mensaje }}</span>
          <button v-if="reimpresionPendiente" type="button" class="pvt-message-action" :disabled="reimpresionPendiente.imprimiendo" @click="reimprimirPendiente">
            Reimprimir {{ reimpresionPendiente.referencia }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="consultaViajes.visible" class="pvt-setup-overlay">
      <div class="pvt-consulta-viajes pvt-panel">
        <h3>Consulta de cierres de viaje</h3>
        <div class="pvt-dialog-grid">
          <label>Fecha<input v-model="consultaViajes.fecha" type="date" @change="cargarConsultaViajesCierre"></label>
          <label>Sentido
            <select v-model="consultaViajes.sentido" @change="cargarConsultaViajesCierre">
              <option value="">Todos</option>
              <option value="I">Ida</option>
              <option value="V">Vuelta</option>
            </select>
          </label>
          <label>Estado
            <select v-model="consultaViajes.estado" @change="cargarConsultaViajesCierre">
              <option value="">Todos</option>
              <option value="abierto">Abierto</option>
              <option value="cerrado">Cerrado</option>
            </select>
          </label>
          <label>Busqueda<input v-model.trim="consultaViajes.busqueda" autocomplete="off" placeholder="Cierre, viaje, ficha o chofer"></label>
        </div>
        <div v-if="consultaViajes.error" class="pvt-message error" role="alert">{{ consultaViajes.error }}</div>
        <div class="pvt-table-wrap pvt-consulta-table">
          <table class="pvt-table">
            <thead>
              <tr>
                <th># Viaje</th>
                <th># Cierre</th>
                <th>Estado</th>
                <th>Hora</th>
                <th>Turno</th>
                <th>Ficha</th>
                <th>Chofer</th>
                <th>Boletos</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="viaje in viajesConsultaFiltrados" :key="viaje.cierre_id ? 'c-' + viaje.cierre_id : 'v-' + viaje.turno_detalle" tabindex="0" @click="seleccionarViajeCierre(viaje)" @keydown.enter.prevent="seleccionarViajeCierre(viaje)">
                <td>{{ viaje.numero_viaje }}</td>
                <td>{{ viaje.cierre_id || '-' }}</td>
                <td><span class="pvt-cierre-estado" :class="viaje.cerrado ? 'cerrado' : 'abierto'">{{ viaje.cerrado ? 'Cerrado' : 'Abierto' }}</span></td>
                <td>{{ viaje.hora }}</td>
                <td>{{ viaje.numero_turno }}</td>
                <td>{{ viaje.ficha }}</td>
                <td>{{ viaje.conductor_nombre }}</td>
                <td>{{ viaje.cantidad_boletos }}</td>
              </tr>
              <tr v-if="consultaViajes.cargando"><td colspan="8">Cargando cierres y viajes...</td></tr>
              <tr v-if="!consultaViajes.cargando && !consultaViajes.error && viajesConsultaFiltrados.length === 0"><td colspan="8">No hay cierres o viajes para esta caja con los filtros indicados.</td></tr>
            </tbody>
          </table>
        </div>
        <div class="pvt-dialog-actions">
          <button type="button" class="pvt-action" :disabled="consultaViajes.cargando" @click="cargarConsultaViajesCierre">Buscar</button>
          <button type="button" class="pvt-action" @click="consultaViajes.visible = false">Regresar</button>
        </div>
      </div>
    </div>

    <div class="pvt-tabs">
      <button v-for="tab in tabs" :key="tab.value" type="button" class="pvt-tab"
        :class="{ active: pantalla === tab.value }" @click="seleccionarPantalla(tab.value)">
        <i :class="['fa', tab.icono]" aria-hidden="true"></i>
        <span>{{ tab.text }}</span>
      </button>
    </div>

    <section v-if="pantalla === 'venta'" class="pvt-screen">
      <div class="pvt-grid-main">
        <div class="pvt-panel">
          <div class="pvt-actions">
            <button type="button" class="pvt-action" :disabled="creandoTurno" @click="limpiarVenta"><i class="fa fa-times-circle" aria-hidden="true"></i><span>Cancelar</span></button>
            <button v-if="puedeCrearTurno" type="button" class="pvt-action" :disabled="creandoTurno || guardando" @click="crearNuevoTurno"><i class="fa fa-plus-circle" aria-hidden="true"></i><span>{{ creandoTurno ? 'Creando...' : 'Nuevo Turno' }}</span></button>
          </div>

          <div class="pvt-trip-box">
            <label># Viaje
              <select class="pvt-trip-select" :value="turno.id || ''" :disabled="guardando || creandoTurno || cargandoContexto"
                @focus="actualizarTurnosFacturacion()" @change="seleccionarViajeFacturacion($event.target.value, $event.target)">
                <option value="" disabled>{{ turnosDisponiblesDelDia.length ? 'Seleccione viaje' : 'No hay viajes abiertos para hoy' }}</option>
                <option v-for="viaje in turnosDisponiblesDelDia" :key="'venta-viaje-' + viaje.id" :value="viaje.id">
                  {{ numeroViajeTurno(viaje) }}
                </option>
              </select>
            </label>
            <label>Ficha
              <select v-model="turno.ficha" :disabled="guardando" @change="seleccionarFichaTurno">
                <option value="">Seleccione ficha</option>
                <option v-if="turno.ficha && !existeFichaTurno(turno.ficha)" :value="turno.ficha">{{ turno.ficha }}</option>
                <option v-for="(vehiculo, indice) in fichasDisponibles" :key="'venta-ficha-' + indice" :value="valorFichaTurno(vehiculo)">
                  {{ textoFichaTurno(vehiculo) }}
                </option>
              </select>
            </label>
            <label>Chofer
              <select v-model="turno.chofer" :disabled="guardando">
                <option value="">Seleccione chofer</option>
                <option v-if="turno.chofer && !existeChoferTurno(turno.chofer)" :value="turno.chofer">{{ turno.chofer }}</option>
                <option v-for="(chofer, indice) in choferesDisponibles" :key="'venta-chofer-' + indice" :value="valorChoferTurno(chofer)">
                  {{ textoChoferTurno(chofer) }}
                </option>
              </select>
            </label>
            <label>Control
              <select ref="ventaControl" v-model="turno.control" :disabled="guardando" required>
                <option value="">Seleccione control</option>
                <option v-for="(control, indice) in controlesDisponibles" :key="'venta-control-' + indice" :value="valorControlTurno(control)">
                  {{ textoControlTurno(control) }}
                </option>
              </select>
            </label>
            <div><span>Capacidad <button v-if="puedeModificarCapacidad" type="button" class="pvt-mini-btn" title="Modificar capacidad" aria-label="Modificar capacidad" :disabled="guardando || actualizandoTurnos || !turno.id" @click="abrirCapacidad"><i class="fa fa-pencil" aria-hidden="true"></i></button></span><strong>{{ actualizandoTurnos ? '...' : turno.capacidad }}</strong></div>
            <div><span>Vendidos</span><strong>{{ actualizandoTurnos ? '...' : turno.vendidos }}</strong><small v-if="!actualizandoTurnos && turno.pendientes" class="pvt-pending-seats">Pendientes: {{ turno.pendientes }}</small></div>
            <div><span>Se quedan</span><strong>{{ actualizandoTurnos ? '...' : turno.seQuedan }}</strong></div>
            <div><span>Disponibles</span><strong>{{ actualizandoTurnos ? '...' : turno.disponibles }}</strong></div>
          </div>

          <div class="pvt-search">
            <button type="button" class="pvt-search-btn">Buscar</button>
            <input v-model="busquedaRuta" placeholder="Buscar viaje o ruta" autocomplete="off">
          </div>

          <div class="pvt-route-list">
            <button v-for="ruta in rutasFiltradas" :key="ruta.id" type="button" class="pvt-route"
              :class="{ selected: rutaSeleccionada && rutaSeleccionada.id === ruta.id }" @click="seleccionarRuta(ruta)">
              <span>{{ nombreRuta(ruta) }}</span>
              <strong>{{ moneda(precioRuta(ruta)) }}</strong>
            </button>
          </div>

          <div class="pvt-ticket">
            <div>
              <h2>BOLETO URBANO</h2>
              <p>Hora del viaje a vender: <strong>{{ turno.hora }}</strong></p>
              <label class="pvt-ticket-quantity">Cantidad de boletos
                <input ref="boletoCantidad" class="pvt-ticket-step" v-model.number="venta.cantidad" type="number" min="1" step="1" :max="turno.disponibles"
                  @keydown.enter.stop.prevent="confirmarCantidadBoletos($event)">
              </label>
            </div>
            <div>
              <div class="pvt-total-line"><span>SubTotal</span><strong>{{ moneda(subtotal) }}</strong></div>
              <div class="pvt-total-line"><span>Desc</span><strong>{{ moneda(venta.descuento) }}</strong></div>
              <div class="pvt-total-line"><span>Recargo</span><strong>{{ moneda(venta.recargo) }}</strong></div>
              <div class="pvt-total-line"><span>Itbis</span><strong>{{ moneda(0) }}</strong></div>
              <div class="pvt-total-line total"><span>Total</span><strong>{{ moneda(total) }}</strong></div>
            </div>
            <fieldset class="pvt-baggage">
              <legend>Información de maletas/dueño</legend>
              <div class="pvt-baggage-fields">
                <label>Cantidad<input v-model.number="venta.numeroMaleta" type="number" min="0" max="20" step="1"></label>
                <label>Nombre<input v-model="venta.nombre" type="text" autocomplete="off"></label>
                <label>Teléfono<input v-model="venta.telefono" v-mask="'(###)-###-####'" type="tel" inputmode="numeric" autocomplete="off"></label>
              </div>
            </fieldset>
          </div>
        </div>

        <div class="pvt-panel">
          <div class="pvt-selected">
            Ruta seleccionada: {{ rutaSeleccionada ? nombreRuta(rutaSeleccionada) : 'Seleccione ruta' }} |
            Boleto {{ moneda(precioSeleccionado) }}
          </div>

          <div class="pvt-fiscal">
            <select v-model="comprobante.tipo" @change="editarFiscal = comprobante.tipo === 'fiscal'">
              <option value="consumidor">Comprobante consumidor final</option>
              <option value="fiscal">Comprobante fiscal</option>
            </select>
            <button type="button" class="pvt-action" @click="editarFiscal = !editarFiscal">Editar datos fiscales</button>
          </div>

          <div v-if="editarFiscal" class="pvt-fiscal-data">
            <label>RNC/Cedula<input ref="fiscalRnc" v-model.trim="comprobante.rnc" :required="comprobante.tipo === 'fiscal'" autocomplete="off" @input="programarBusquedaFiscal" @blur="buscarDatosFiscales" @keydown.enter.prevent="buscarDatosFiscales"></label>
            <label>Nombre fiscal<input ref="fiscalNombre" v-model.trim="comprobante.nombre" :required="comprobante.tipo === 'fiscal'" :maxlength="comprobante.tipo === 'fiscal' ? 250 : null" autocomplete="off"></label>
            <label class="pvt-fiscal-address">Direccion<input ref="fiscalDireccion" v-model.trim="comprobante.direccion" :required="comprobante.tipo === 'fiscal'" :maxlength="comprobante.tipo === 'fiscal' ? 150 : null" autocomplete="off"></label>
            <div v-if="consultaFiscal.mensaje" class="pvt-fiscal-status" :class="consultaFiscal.tipo" role="status" aria-live="polite">{{ consultaFiscal.mensaje }}</div>
          </div>

          <div class="pvt-pay">
            <label>Efectivo<input ref="boletoEfectivo" class="pvt-ticket-step" v-model.number="pagos.efectivo" type="number" min="0" placeholder="0.00"
              @keydown.enter.stop.prevent="confirmarEfectivoBoletos($event)"></label>
            <label>Credito<input v-model.number="pagos.credito" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('credito', $event)" @click="autocompletarFormaPago('credito', $event)" @keyup.enter.prevent="autocompletarFormaPago('credito', $event)"></label>
            <label>Tarjeta<input v-model.number="pagos.tarjeta" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('tarjeta', $event)" @click="autocompletarFormaPago('tarjeta', $event)" @keyup.enter.prevent="autocompletarFormaPago('tarjeta', $event)"></label>
            <label>Pago en destino<input v-model.number="pagos.pagoDestino" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('pagoDestino', $event)" @click="autocompletarFormaPago('pagoDestino', $event)" @keyup.enter.prevent="autocompletarFormaPago('pagoDestino', $event)"></label>
            <label>Cheque<input v-model.number="pagos.cheque" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('cheque', $event)" @click="autocompletarFormaPago('cheque', $event)" @keyup.enter.prevent="autocompletarFormaPago('cheque', $event)"></label>
            <label>Valor cortesia<input :value="pagos.valorCortesia" type="number" readonly aria-haspopup="dialog"
              :disabled="guardando || creandoTurno" @click="abrirCortesia" @keydown.enter.prevent="abrirCortesia" @keydown.space.prevent="abrirCortesia"></label>
            <label>Nota de credito<input v-model.number="pagos.notadecredito" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('notadecredito', $event)" @click="autocompletarFormaPago('notadecredito', $event)" @keyup.enter.prevent="autocompletarFormaPago('notadecredito', $event)"></label>
            <label>Transferencia<input v-model.number="pagos.transferencia" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('transferencia', $event)" @click="autocompletarFormaPago('transferencia', $event)" @keyup.enter.prevent="autocompletarFormaPago('transferencia', $event)"></label>
          </div>

          <div class="pvt-print-options boletos">
            <label>Copias<input v-model.number="impresion.copias" type="number" min="0" disabled></label>
            <label>Copias boleto pequeno<input v-model.number="impresion.copiasPequeno" type="number" min="0" disabled></label>
          </div>

          <div class="pvt-change">Devuelta {{ moneda(devuelta) }}</div>
          <div v-if="cantidadFormasPago() > 2" class="pvt-message error" role="alert">Debe digitar correctamente la forma de pago</div>
      <button ref="finVenta" type="button" class="pvt-finish" :disabled="guardando || creandoTurno || cargandoContexto || errorContexto || actualizandoTurnos || !rutaSeleccionada || cantidadFormasPago() > 2" @click="finalizarVenta">
            FIN
          </button>
          <div v-if="mensaje" class="pvt-message" :class="mensajeTipo">
            <span>{{ mensaje }}</span>
            <button v-if="reimpresionPendiente" type="button" class="pvt-message-action" :disabled="reimpresionPendiente.imprimiendo" @click="reimprimirPendiente">
              Reimprimir {{ reimpresionPendiente.referencia }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <section v-if="pantalla === 'envios'" class="pvt-screen pvt-envio-screen">
      <div class="pvt-grid-main pvt-grid-envios">
        <div class="pvt-panel">
          <div class="pvt-envio-trip-head">
            <div class="pvt-actions pvt-envio-actions">
              <button type="button" class="pvt-action" @click="limpiarEnvio"><i class="fa fa-eraser" aria-hidden="true"></i><span>Limpiar Datos</span></button>
            </div>

            <div class="pvt-trip-box pvt-envio-trip-primary">
              <label># Viaje
                <select class="pvt-trip-select" :value="turno.id || ''" :disabled="guardando || creandoTurno || cargandoContexto"
                  @focus="actualizarTurnosFacturacion()" @change="seleccionarViajeFacturacion($event.target.value, $event.target)">
                  <option value="" disabled>{{ turnosDisponiblesDelDia.length ? 'Seleccione viaje' : 'No hay viajes abiertos para hoy' }}</option>
                  <option v-for="viaje in turnosDisponiblesDelDia" :key="'envio-viaje-' + viaje.id" :value="viaje.id">
                    {{ numeroViajeTurno(viaje) }}
                  </option>
                </select>
              </label>
              <label>Ficha
                <select v-model="turno.ficha" :disabled="guardando" @change="seleccionarFichaTurno">
                  <option value="">Seleccione ficha</option>
                  <option v-if="turno.ficha && !existeFichaTurno(turno.ficha)" :value="turno.ficha">{{ turno.ficha }}</option>
                  <option v-for="(vehiculo, indice) in fichasDisponibles" :key="'envio-ficha-' + indice" :value="valorFichaTurno(vehiculo)">
                    {{ textoFichaTurno(vehiculo) }}
                  </option>
                </select>
              </label>
              <label>Fecha de viaje<input :value="fechaTrabajo" readonly></label>
              <label>Hora<input v-model="turno.hora" autocomplete="off"></label>
            </div>
          </div>

          <div class="pvt-trip-box pvt-envio-trip-secondary">
            <label>Chofer
              <select v-model="turno.chofer" :disabled="guardando">
                <option value="">Seleccione chofer</option>
                <option v-if="turno.chofer && !existeChoferTurno(turno.chofer)" :value="turno.chofer">{{ turno.chofer }}</option>
                <option v-for="(chofer, indice) in choferesDisponibles" :key="'envio-chofer-' + indice" :value="valorChoferTurno(chofer)">
                  {{ textoChoferTurno(chofer) }}
                </option>
              </select>
            </label>
            <label>Control
              <select ref="envioControl" v-model="turno.control" :disabled="guardando" required>
                <option value="">Seleccione control</option>
                <option v-for="(control, indice) in controlesDisponibles" :key="'envio-control-' + indice" :value="valorControlTurno(control)">
                  {{ textoControlTurno(control) }}
                </option>
              </select>
            </label>
            <button v-if="puedeCrearTurno" type="button" class="pvt-action pvt-envio-new-turn"
              :disabled="creandoTurno || guardando || cargandoContexto || actualizandoTurnos" @click="crearNuevoTurno">
              <i class="fa fa-plus-circle" aria-hidden="true"></i><span>{{ creandoTurno ? 'Creando...' : 'Nuevo turno' }}</span>
            </button>
          </div>

          <div class="pvt-client-grid">
            <div>
              <h4>Remitente</h4>
              <div class="pvt-client-fields">
                <label>Cedula<input ref="envioRemitenteCedula" v-model="envio.remitente.cedula" autocomplete="off" @blur="buscarPersonaEnvio('remitente', 'cedula')" @keyup.enter.prevent="buscarPersonaEnvio('remitente', 'cedula', 'envioRemitenteNombre')"></label>
                <label>Nombre<input ref="envioRemitenteNombre" v-model="envio.remitente.nombre" autocomplete="off" @keyup.enter.prevent="enfocarCampoEnvioPaquete('envioRemitenteTelefono')"></label>
                <label>Telefono<input ref="envioRemitenteTelefono" v-model="envio.remitente.telefono" v-mask="'(###)-###-####'" type="tel" inputmode="numeric" autocomplete="off" @blur="buscarPersonaEnvio('remitente', 'telefono')" @keyup.enter.prevent="buscarPersonaEnvio('remitente', 'telefono', 'envioRemitenteDireccion')"></label>
                <label>Direccion<input ref="envioRemitenteDireccion" v-model="envio.remitente.direccion" autocomplete="off" @keyup.enter.prevent="enfocarCampoEnvioPaquete('envioDestinatarioTelefono')"></label>
              </div>
            </div>
            <div>
              <h4>Destinatario</h4>
              <div class="pvt-client-fields">
                <label>Telefono<input ref="envioDestinatarioTelefono" v-model="envio.destinatario.telefono" v-mask="'(###)-###-####'" type="tel" inputmode="numeric" autocomplete="off" @blur="buscarPersonaEnvio('destinatario', 'telefono')" @keyup.enter.prevent="buscarPersonaEnvio('destinatario', 'telefono', 'envioDestinatarioNombre')"></label>
                <label>Nombre<input ref="envioDestinatarioNombre" v-model="envio.destinatario.nombre" autocomplete="off" @keyup.enter.prevent="enfocarCampoEnvioPaquete('envioDestinatarioDocumento')"></label>
                <label>Documento<input ref="envioDestinatarioDocumento" v-model="envio.destinatario.documento" autocomplete="off" @blur="buscarPersonaEnvio('destinatario', 'documento')" @keyup.enter.prevent="buscarPersonaEnvio('destinatario', 'documento', 'envioDestinatarioDireccion')"></label>
                <label>Direccion<input ref="envioDestinatarioDireccion" v-model="envio.destinatario.direccion" autocomplete="off" @keyup.enter.prevent="enfocarCampoEnvioPaquete('envioBuscarRuta')"></label>
              </div>
            </div>
          </div>

          <div class="pvt-envio-options">
            <div>
              <span>Tipo de envio</span>
              <div class="pvt-segment mini">
                <button type="button" :class="{ activo: envio.tipo === 'P' }" @click="seleccionarTipoEnvio('P')">Paquete</button>
                <button type="button" :class="{ activo: envio.tipo === 'D' }" @click="seleccionarTipoEnvio('D')">Dinero</button>
                <button type="button" :class="{ activo: envio.tipo === 'R' }" @click="seleccionarTipoEnvio('R')">Regalo</button>
              </div>
            </div>
            <div class="pvt-calc-price-group">
              <span>Tipo Calculo Precio</span>
              <div class="pvt-segment mini">
                <button type="button" :disabled="envio.tipo !== 'P'" :class="{ activo: envio.calculo === 'peso' }" @click="seleccionarCalculoEnvio('peso')">Peso</button>
                <button type="button" :class="{ activo: envio.calculo === 'valor' }" @click="seleccionarCalculoEnvio('valor')">Valor</button>
                <button type="button" :class="{ activo: envio.calculo === 'digitado' }" @click="seleccionarCalculoEnvio('digitado')">Digitado</button>
                <button type="button" :disabled="envio.tipo !== 'P'" :class="{ activo: envio.calculo === 'asiento' }" @click="seleccionarCalculoEnvio('asiento')">Asiento</button>
              </div>
            </div>
            <label class="pvt-check"><input v-model="envio.fragil" type="checkbox" @change="prepararPaqueteEnvio"> Paquete fragil</label>
          </div>

          <div class="pvt-route-picker">
            <div class="pvt-search">
              <button type="button" class="pvt-search-btn">Buscar</button>
              <input ref="envioBuscarRuta" v-model="envio.busquedaDestino" placeholder="Buscar destino o ruta" autocomplete="off">
            </div>
            <div class="pvt-route-list envio">
              <button v-for="ruta in destinosEnvioFiltrados" :key="ruta.id" type="button" class="pvt-route"
                :class="{ selected: destinoEnvioSeleccionado && destinoEnvioSeleccionado.id === ruta.id }"
                @click="seleccionarDestinoEnvio(ruta)">
                <span>{{ nombreRuta(ruta) }}</span>
                <strong>{{ moneda(precioRutaEnvio(ruta)) }} / lb</strong>
              </button>
            </div>
          </div>

          <div v-if="editandoPaqueteEnvio" class="pvt-package-edit-status" role="status">Editando paquete {{ envio.indiceEdicion + 1 }}</div>
          <div class="pvt-package-entry" @input="prepararPaqueteEnvio">
            <label class="pvt-package-route">Ruta seleccionada<input :value="destinoEnvioSeleccionado ? nombreRuta(destinoEnvioSeleccionado) : ''" readonly></label>
            <label>Precio envio<input ref="envioPrecio" v-model.number="envio.precio" type="number" min="0" :readonly="envio.calculo !== 'digitado'" @keyup.enter.prevent="enfocarCampoEnvioPaquete('envioCantidad')"></label>
            <label v-if="envio.calculo === 'asiento'">Asientos<input ref="envioCantidad" v-model.number="envio.cantidadAsientos" type="number" min="1" step="1" :max="turno.disponibles" @input="actualizarPrecioEnvioCalculado"></label>
            <label v-else>{{ envio.calculo === 'peso' ? 'Peso (Lb)' : 'Pies/Lb' }}<input ref="envioCantidad" v-model.number="envio.cantidadLbPies" type="number" min="0" @input="actualizarPrecioEnvioCalculado" @keyup.enter.prevent="enfocarCampoEnvioPaquete('envioValorDeclarado')"></label>
            <label>Valor declarado<input ref="envioValorDeclarado" v-model.number="envio.valorDeclarado" type="number" min="0" @input="actualizarPrecioEnvioCalculado" @keyup.enter.prevent="enfocarCampoEnvioPaquete('envioDescripcion')"></label>
            <label class="pvt-package-description">Descripcion<input ref="envioDescripcion" v-model="envio.descripcion" autocomplete="off" @keyup.enter.prevent="enfocarCampoEnvioPaquete('envioAgregar')"></label>
            <div class="pvt-package-entry-actions">
              <button ref="envioAgregar" type="button" class="pvt-action" :disabled="guardando || envio.entradaConfirmada" @click="agregarPaqueteEnvio" @keydown.enter.prevent="agregarPaqueteEnvio($event)">
                <i v-if="editandoPaqueteEnvio" class="fa fa-check" aria-hidden="true"></i> {{ editandoPaqueteEnvio ? 'Guardar' : 'Agregar' }}
              </button>
              <button v-if="editandoPaqueteEnvio" type="button" class="pvt-mini-btn pvt-package-icon" title="Cancelar edicion" aria-label="Cancelar edicion" :disabled="guardando" @click="cancelarEdicionPaqueteEnvio">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div class="pvt-envio-table-wrap">
            <table class="pvt-envio-table">
              <thead>
                <tr>
                  <th>Descripcion</th>
                  <th>Destino</th>
                  <th>Cant.</th>
                  <th>Valor decl.</th>
                  <th>Precio</th>
                  <th>Impuestos</th>
                  <th>Importe</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(paquete, index) in envio.paquetes" :key="index" :class="{ 'pvt-package-editing': envio.indiceEdicion === index }">
                  <td>{{ paquete.descripcion }}</td>
                  <td>{{ paquete.destinoNombre }}</td>
                  <td>{{ paquete.calculo === 'asiento' ? paquete.cantidadAsientos + ' asientos' : paquete.cantidadLbPies }}</td>
                  <td>{{ moneda(paquete.valorDeclarado) }}</td>
                  <td>{{ moneda(paquete.precio) }}</td>
                  <td>{{ moneda(paquete.impuestos) }}</td>
                  <td>{{ moneda(paquete.importe) }}</td>
                  <td>
                    <div class="pvt-package-row-actions">
                      <button type="button" class="pvt-mini-btn pvt-package-icon" :title="'Editar paquete ' + (index + 1)" :aria-label="'Editar paquete ' + (index + 1)" :disabled="guardando || editandoPaqueteEnvio" @click="editarPaqueteEnvio(index)">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </button>
                      <button type="button" class="pvt-mini-btn pvt-package-icon" :title="'Quitar paquete ' + (index + 1)" :aria-label="'Quitar paquete ' + (index + 1)" :disabled="guardando || editandoPaqueteEnvio" @click="removerPaqueteEnvio(index)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="!envio.paquetes.length">
                  <td colspan="8">Agregue al menos un paquete para facturar.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="pvt-envio-footer">
            <label class="pvt-check"><input v-model="envio.perecedero" type="checkbox" :disabled="editandoPaqueteEnvio" @change="prepararPaqueteEnvio"> Productos perecederos</label>
            <label class="pvt-check"><input v-model="envio.fragilesGlobal" type="checkbox" :disabled="editandoPaqueteEnvio" @change="prepararPaqueteEnvio"> Productos fragiles</label>
            <button type="button" class="pvt-action" :disabled="guardando || editandoPaqueteEnvio" @click="removerUltimoPaqueteEnvio">Remover articulo/paquete</button>
            <div class="pvt-print-options envio">
              <label>Copias etiqueta<input v-model.number="envio.copiasEtiqueta" type="number" min="0" disabled></label>
              <label>Copias factura<input v-model.number="envio.copiasFactura" type="number" min="0" disabled></label>
            </div>
          </div>
        </div>

        <div class="pvt-panel">
          <div class="pvt-fiscal envio">
            <select v-model="comprobante.tipo" @change="editarFiscal = comprobante.tipo === 'fiscal'">
              <option value="consumidor">Comprobante consumidor final</option>
              <option value="fiscal">Comprobante fiscal</option>
            </select>
            <button type="button" class="pvt-action" @click="editarFiscal = !editarFiscal">Editar datos fiscales</button>
          </div>

          <div v-if="editarFiscal" class="pvt-fiscal-data">
            <label>RNC/Cedula<input ref="fiscalRnc" v-model.trim="comprobante.rnc" :required="comprobante.tipo === 'fiscal'" autocomplete="off" @input="programarBusquedaFiscal" @blur="buscarDatosFiscales" @keydown.enter.prevent="buscarDatosFiscales"></label>
            <label>Nombre fiscal<input ref="fiscalNombre" v-model.trim="comprobante.nombre" :required="comprobante.tipo === 'fiscal'" :maxlength="comprobante.tipo === 'fiscal' ? 250 : null" autocomplete="off"></label>
            <label class="pvt-fiscal-address">Direccion<input ref="fiscalDireccion" v-model.trim="comprobante.direccion" :required="comprobante.tipo === 'fiscal'" :maxlength="comprobante.tipo === 'fiscal' ? 150 : null" autocomplete="off"></label>
            <div v-if="consultaFiscal.mensaje" class="pvt-fiscal-status" :class="consultaFiscal.tipo" role="status" aria-live="polite">{{ consultaFiscal.mensaje }}</div>
          </div>

          <div class="pvt-pay">
            <label>Efectivo<input v-model.number="pagos.efectivo" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('efectivo', $event)" @click="autocompletarFormaPago('efectivo', $event)" @keyup.enter.prevent="autocompletarFormaPago('efectivo', $event)"></label>
            <label>Credito<input v-model.number="pagos.credito" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('credito', $event)" @click="autocompletarFormaPago('credito', $event)" @keyup.enter.prevent="autocompletarFormaPago('credito', $event)"></label>
            <label>Tarjeta<input v-model.number="pagos.tarjeta" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('tarjeta', $event)" @click="autocompletarFormaPago('tarjeta', $event)" @keyup.enter.prevent="autocompletarFormaPago('tarjeta', $event)"></label>
            <label>Pago en destino<input v-model.number="pagos.pagoDestino" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('pagoDestino', $event)" @click="autocompletarFormaPago('pagoDestino', $event)" @keyup.enter.prevent="autocompletarFormaPago('pagoDestino', $event)"></label>
            <label>Cheque<input v-model.number="pagos.cheque" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('cheque', $event)" @click="autocompletarFormaPago('cheque', $event)" @keyup.enter.prevent="autocompletarFormaPago('cheque', $event)"></label>
            <label>Valor cortesia<input v-model.number="pagos.valorCortesia" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('valorCortesia', $event)" @click="autocompletarFormaPago('valorCortesia', $event)" @keyup.enter.prevent="autocompletarFormaPago('valorCortesia', $event)"></label>
            <label>Nota de credito<input v-model.number="pagos.notadecredito" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('notadecredito', $event)" @click="autocompletarFormaPago('notadecredito', $event)" @keyup.enter.prevent="autocompletarFormaPago('notadecredito', $event)"></label>
            <label>Transferencia<input v-model.number="pagos.transferencia" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('transferencia', $event)" @click="autocompletarFormaPago('transferencia', $event)" @keyup.enter.prevent="autocompletarFormaPago('transferencia', $event)"></label>
          </div>

          <div class="pvt-envio-totals">
            <div><span>SubTotal</span><strong>{{ moneda(subtotalEnvio) }}</strong></div>
            <div><span>Desc</span><strong>{{ moneda(venta.descuento) }}</strong></div>
            <div><span>Recargo</span><strong>{{ moneda(venta.recargo) }}</strong></div>
            <div><span>Itbis</span><strong>{{ moneda(impuestosEnvio) }}</strong></div>
            <div v-if="asientosEnvio"><span>Boletos ({{ asientosEnvio }} asientos)</span><strong>{{ moneda(totalBoletosEnvio) }}</strong></div>
            <div class="total"><span>Total</span><strong>{{ moneda(totalEnvio) }}</strong></div>
          </div>

          <div class="pvt-change">Devuelta {{ moneda(devueltaEnvio) }}</div>
          <div v-if="cantidadFormasPago() > 2" class="pvt-message error" role="alert">Debe digitar correctamente la forma de pago</div>
          <button ref="finEnvio" type="button" class="pvt-finish" :disabled="guardando || cargandoContexto || errorContexto || actualizandoTurnos || editandoPaqueteEnvio || !envio.paquetes.length || cantidadFormasPago() > 2" @click="finalizarEnvio">
            FIN
          </button>
          <label v-if="!contexto.vistaPreviaPdf" class="pvt-check"><input v-model="impresion.enviarDirecto" type="checkbox" :disabled="guardando"> Enviar directo a la impresora</label>
          <div v-if="mensaje" class="pvt-message" :class="mensajeTipo">
            <span>{{ mensaje }}</span>
            <button v-if="reimpresionPendiente" type="button" class="pvt-message-action" :disabled="reimpresionPendiente.imprimiendo" @click="reimprimirPendiente">
              Reimprimir {{ reimpresionPendiente.referencia }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <section v-if="pantalla === 'recargo'" class="pvt-screen pvt-panel">
      <h3>Registrar Recargo</h3>
      <div v-if="mensaje" class="pvt-message" :class="mensajeTipo">{{ mensaje }}</div>
      <div class="pvt-recargo-layout">
        <div class="pvt-dialog-grid">
          <label>Motivo del recargo<input v-model="recargo.motivo" :readonly="!recargo.precioEditable"></label>
          <label>Valor del recargo<input v-model.number="recargo.valor" :readonly="!recargo.precioEditable" type="number" min="0"></label>
          <label v-if="recargoOrigen !== 'entrega'">Cantidad<input v-model.number="recargo.cantidad" type="number" min="1"></label>
        </div>
        <div v-if="recargoOrigen !== 'entrega'" class="pvt-stepper">
          <button type="button" class="pvt-action" @click="recargo.cantidad = Number(recargo.cantidad || 1) + 1">+</button>
          <button type="button" class="pvt-action" @click="recargo.cantidad = Math.max(1, Number(recargo.cantidad || 1) - 1)">-</button>
        </div>
      </div>
      <label class="pvt-search-line">Busqueda<input v-model="recargo.busqueda" @keyup.enter="cargarRecargos"></label>
      <div class="pvt-list pvt-list-compact">
        <button v-for="item in recargo.catalogo" :key="item.id" type="button" class="pvt-list-item" @click="seleccionarRecargo(item)">
          <span>{{ item.descripcion }}</span>
          <strong>{{ moneda(item.precio) }}</strong>
        </button>
        <div v-if="!recargo.catalogo.length" class="pvt-empty">No hay recargos disponibles.</div>
      </div>
      <div class="pvt-dialog-actions">
        <button type="button" class="pvt-action" @click="aplicarRecargo">Aceptar</button>
        <button type="button" class="pvt-action" @click="pantalla = recargoOrigen">Regresar</button>
      </div>
    </section>

    <section v-if="pantalla === 'descuento'" class="pvt-screen pvt-panel">
      <h3>Verificar Descuento</h3>
      <div class="pvt-segment">
        <button type="button" :class="{ activo: descuento.tipo === 'identificacion' }" @click="descuento.tipo = 'identificacion'">Identificacion</button>
        <button type="button" :class="{ activo: descuento.tipo === 'pin' }" @click="descuento.tipo = 'pin'">PIN</button>
      </div>
      <div class="pvt-dialog-grid">
        <label v-if="descuento.tipo === 'identificacion'">Identificacion<input v-model="descuento.identificacion" @keyup.enter="aplicarDescuento"></label>
        <label v-if="descuento.tipo === 'pin'">PIN<input v-model="descuento.pin" type="password" @keyup.enter="aplicarDescuento"></label>
        <label>Porcentaje<input :value="descuento.porcentaje + ' %'" readonly></label>
        <label>Monto descuento<input :value="moneda(venta.descuento)" readonly></label>
      </div>
      <div v-if="mensaje" class="pvt-message" :class="mensajeTipo">
        <span>{{ mensaje }}</span>
        <button v-if="reimpresionPendiente" type="button" class="pvt-message-action" :disabled="reimpresionPendiente.imprimiendo" @click="reimprimirPendiente">
          Reimprimir {{ reimpresionPendiente.referencia }}
        </button>
      </div>
      <div class="pvt-dialog-actions">
        <button type="button" class="pvt-action" :disabled="descuento.cargando" @click="aplicarDescuento">Aceptar</button>
        <button type="button" class="pvt-action" @click="limpiarDescuento">Quitar</button>
        <button type="button" class="pvt-action" @click="pantalla = 'venta'">Regresar</button>
      </div>
    </section>

    <section v-if="pantalla === 'recepcion'" class="pvt-screen pvt-panel">
      <h3>Recepcion de paquetes</h3>
      <div class="pvt-boarding-head">
        <label>No. envio<input ref="recepcionNoEnvio" v-model.trim="recepcion.noEnvio" :disabled="recepcion.cargando" autocomplete="off" placeholder="Escanear o digitar envio" @keyup.enter="recibirPaquete"></label>
        <label>Sucursal<input :value="contexto.sucursal" readonly></label>
        <label>Cajero<input :value="contexto.cajero" readonly></label>
        <button type="button" class="pvt-action" :disabled="recepcion.cargando" @click="recibirPaquete">Aceptar</button>
        <button type="button" class="pvt-action" @click="seleccionarPantalla('envios')">Regresar</button>
      </div>
      <div v-if="recepcion.mensaje" class="pvt-message" :class="recepcion.tipoMensaje">{{ recepcion.mensaje }}</div>
      <div v-if="recepcion.envio" class="pvt-recepcion-card">
        <div><span>No. envio</span><strong>{{ recepcion.envio.no_envio }}</strong></div>
        <div><span>Estado</span><strong>{{ recepcionEstadoTexto }}</strong></div>
        <div><span>Origen</span><strong>{{ recepcion.envio.sucursal_origen }}</strong></div>
        <div><span>Destino</span><strong>{{ recepcion.envio.sucursal_destino }}</strong></div>
        <div><span>Remitente</span><strong>{{ recepcion.envio.nombre_remitente }}</strong></div>
        <div><span>Tel. remitente</span><strong>{{ recepcion.envio.telefono_remitente }}</strong></div>
        <div><span>Destinatario</span><strong>{{ recepcion.envio.nombre_destinatario }}</strong></div>
        <div><span>Tel. destinatario</span><strong>{{ recepcion.envio.telefono_destinatario }}</strong></div>
        <div><span>Tipo envio</span><strong>{{ recepcionTipoEnvio }}</strong></div>
        <div><span>Valor declarado</span><strong>{{ moneda(recepcion.envio.valor_declarado) }}</strong></div>
        <div class="wide"><span>Descripcion</span><strong>{{ recepcion.envio.descripcion }}</strong></div>
      </div>
    </section>

    <section v-if="pantalla === 'entrega'" class="pvt-screen pvt-panel pvt-entrega-screen">
      <h3>Entrega de paquetes</h3>
      <div class="pvt-boarding-head pvt-entrega-head">
        <label>No. envio<input v-model.trim="entrega.filtros.noEnvio" autocomplete="off" placeholder="Escanear o digitar envio" @keyup.enter="cargarListadoEntrega"></label>
        <label class="pvt-entrega-desde">Desde<input v-model="entrega.filtros.fechaDesde" type="date"></label>
        <label class="pvt-entrega-hasta">Hasta<input v-model="entrega.filtros.fechaHasta" type="date"></label>
        <label>Nombre<input v-model.trim="entrega.filtros.nombre" autocomplete="off" @keyup.enter="cargarListadoEntrega"></label>
        <label>Telefono<input v-model.trim="entrega.filtros.telefono" autocomplete="off" @keyup.enter="cargarListadoEntrega"></label>
        <button type="button" class="pvt-action" :disabled="entrega.cargando" @click="cargarListadoEntrega">Buscar</button>
        <button type="button" class="pvt-action pvt-entrega-back" @click="seleccionarPantalla('envios')">Regresar</button>
      </div>
      <div v-if="entrega.mensaje" class="pvt-message" :class="entrega.tipoMensaje">{{ entrega.mensaje }}</div>
      <div class="pvt-entrega-grid">
        <div>
          <div class="pvt-close-table pvt-entrega-table">
            <table>
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th># Envio</th>
                  <th>Cliente envia</th>
                  <th>Cliente recibe</th>
                  <th>Ficha</th>
                  <th>Viaje</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in entrega.listado" :key="item.no_envio" :class="{ selected: entrega.envio && entrega.envio.no_envio === item.no_envio }" @click="seleccionarEntrega(item)">
                  <td>{{ item.fecha }}</td>
                  <td>{{ item.no_envio }}</td>
                  <td>{{ item.nombre_remitente }}</td>
                  <td>{{ item.nombre_destinatario }}</td>
                  <td>{{ item.ficha }}</td>
                  <td>{{ item.no_viaje }}</td>
                  <td>{{ item.is_recibido ? 'Recibido' : 'No recibido' }}</td>
                </tr>
                <tr v-if="!entrega.listado.length"><td colspan="7">No hay paquetes pendientes de entrega para los filtros indicados.</td></tr>
              </tbody>
            </table>
          </div>

          <div class="pvt-entrega-detail">
            <h4>Datos de entrega</h4>
            <div class="pvt-entrega-info">
              <div><span>Remitente</span><strong>{{ entrega.envio ? entrega.envio.nombre_remitente : '' }}</strong></div>
              <div><span>Destinatario</span><strong>{{ entrega.envio ? entrega.envio.nombre_destinatario : '' }}</strong></div>
              <div><span>Telefono remitente</span><strong>{{ entrega.envio ? entrega.envio.telefono_remitente : '' }}</strong></div>
              <div><span>Telefono destinatario</span><strong>{{ entrega.envio ? entrega.envio.telefono_destinatario : '' }}</strong></div>
              <div><span>Tipo envio</span><strong>{{ entregaTipoEnvio }}</strong></div>
              <div><span>Destino</span><strong>{{ entrega.envio ? entrega.envio.ruta_destino : '' }}</strong></div>
              <div><span>Valor declarado</span><strong>{{ moneda(entrega.envio ? entrega.envio.valor_declarado : 0) }}</strong></div>
              <div><span>Hora factura / Chofer</span><strong>{{ entregaHoraChofer }}</strong></div>
              <div class="wide"><span>Descripcion</span><strong>{{ entrega.envio ? entrega.envio.descripcion : '' }}</strong></div>
              <div v-if="pagoDestinoEntrega > 0" class="wide pago-destino"><span>Pago en destino</span><strong>{{ moneda(pagoDestinoEntrega) }}</strong></div>
              <div v-if="entrega.recargo" class="wide"><span>Recargo: {{ entrega.recargo.descripcion }}</span><strong>{{ moneda(entrega.recargo.precio) }}</strong>
                <button type="button" class="pvt-link-btn" title="Quitar recargo de entrega" :disabled="entrega.guardando" @click="quitarRecargoEntrega"><i class="fa fa-times" aria-hidden="true"></i></button>
              </div>
            </div>
            <div class="pvt-entrega-actions">
              <label>Cedula destinatario<input ref="cedulaEntrega" v-model.trim="entrega.cedulaEntrega" autocomplete="off" maxlength="30" :aria-invalid="entrega.cedulaRequerida ? 'true' : 'false'" :aria-describedby="entrega.cedulaRequerida ? 'pvt-cedula-entrega-aviso' : null" @input="limpiarAdvertenciaCedulaEntrega"></label>
              <button type="button" class="pvt-action" :disabled="entrega.guardando || !entrega.envio" @click="entregarPaquete">Entregar paquete</button>
              <div v-if="entrega.cedulaRequerida" id="pvt-cedula-entrega-aviso" class="pvt-message warning pvt-cedula-aviso" role="alert">Debe digitar la cédula del destinatario para entregar e imprimir el paquete.</div>
            </div>
          </div>
        </div>

        <div>
          <div class="pvt-pay">
            <label>Efectivo<input v-model.number="pagos.efectivo" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('efectivo', $event)" @click="autocompletarFormaPago('efectivo', $event)" @keyup.enter.prevent="autocompletarFormaPago('efectivo', $event)"></label>
            <label>Credito<input v-model.number="pagos.credito" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('credito', $event)" @click="autocompletarFormaPago('credito', $event)" @keyup.enter.prevent="autocompletarFormaPago('credito', $event)"></label>
            <label>Tarjeta<input v-model.number="pagos.tarjeta" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('tarjeta', $event)" @click="autocompletarFormaPago('tarjeta', $event)" @keyup.enter.prevent="autocompletarFormaPago('tarjeta', $event)"></label>
            <label>Pago en destino<input v-model.number="pagos.pagoDestino" type="number" min="0" placeholder="0.00" readonly></label>
            <label>Cheque<input v-model.number="pagos.cheque" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('cheque', $event)" @click="autocompletarFormaPago('cheque', $event)" @keyup.enter.prevent="autocompletarFormaPago('cheque', $event)"></label>
            <label>Valor cortesia<input v-model.number="pagos.valorCortesia" type="number" min="0" placeholder="0.00" readonly></label>
            <label>Nota de credito<input v-model.number="pagos.notadecredito" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('notadecredito', $event)" @click="autocompletarFormaPago('notadecredito', $event)" @keyup.enter.prevent="autocompletarFormaPago('notadecredito', $event)"></label>
            <label>Transferencia<input v-model.number="pagos.transferencia" type="number" min="0" placeholder="0.00" @focus="autocompletarFormaPago('transferencia', $event)" @click="autocompletarFormaPago('transferencia', $event)" @keyup.enter.prevent="autocompletarFormaPago('transferencia', $event)"></label>
          </div>
          <div class="pvt-envio-totals">
            <div><span>Pago en destino</span><strong>{{ moneda(pagoDestinoEntrega) }}</strong></div>
            <div v-if="entrega.recargo"><span>Recargo de entrega</span><strong>{{ moneda(entrega.recargo.precio) }}</strong></div>
            <div><span>Total a cobrar</span><strong>{{ moneda(totalCobrarEntrega) }}</strong></div>
            <div><span>Total pagado</span><strong>{{ moneda(totalPagadoEntrega) }}</strong></div>
            <div class="total"><span>Devuelta</span><strong>{{ moneda(devueltaEntrega) }}</strong></div>
          </div>
          <button type="button" class="pvt-finish" :disabled="entrega.guardando || !entrega.envio" @click="entregarPaquete">
            FIN
          </button>
          <label class="pvt-check pvt-entrega-print"><input v-model="impresion.enviarDirecto" type="checkbox"> Enviar directo a la impresora</label>
        </div>
      </div>
    </section>

    <section v-if="pantalla === 'fin-envios'" class="pvt-screen pvt-panel pvt-fin-envios-screen">
      <h3>Fin envios</h3>
      <div class="pvt-close-head">
        <label># Viaje<input v-model="finEnvios.numeroViaje" autocomplete="off"></label>
        <label>Ficha<input v-model="finEnvios.ficha" autocomplete="off"></label>
        <label>Chofer<input v-model="finEnvios.chofer" autocomplete="off"></label>
        <label>Fecha<input :value="fechaTrabajo" readonly></label>
        <button type="button" class="pvt-action" :disabled="finEnvios.cargando || finEnvios.imprimiendo" @click="cargarFinEnvios">Buscar</button>
        <button type="button" class="pvt-action" :disabled="finEnvios.imprimiendo || finEnvios.cargando || !finEnvios.numeroViaje.trim()" @click="imprimirFinEnvios('paquetesEntregadoAChofer')">Paquetes al chofer</button>
        <button type="button" class="pvt-action" :disabled="finEnvios.imprimiendo || finEnvios.cargando || !finEnvios.numeroViaje.trim()" @click="imprimirFinEnvios('EnviosEntregadosEnDestino')">Entregados destino</button>
        <button type="button" class="pvt-action" @click="seleccionarPantalla('envios')">Regresar</button>
      </div>
      <div v-if="finEnvios.mensaje" class="pvt-message" :class="finEnvios.tipoMensaje">{{ finEnvios.mensaje }}</div>
      <div class="pvt-close-table pvt-fin-envios-table">
        <table>
          <thead>
            <tr>
              <th># Envio</th>
              <th>Descripcion</th>
              <th>Destino</th>
              <th>Valor declarado</th>
              <th>Ficha</th>
              <th>Conductor</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="envioFin in finEnvios.envios" :key="envioFin.no_envio">
              <td>{{ envioFin.no_envio }}</td>
              <td>{{ envioFin.descripcion }}</td>
              <td>{{ envioFin.destino }}</td>
              <td>{{ moneda(envioFin.valor_declarado) }}</td>
              <td>{{ envioFin.ficha }}</td>
              <td>{{ envioFin.conductor }}</td>
              <td>{{ envioFin.is_recogido ? 'Entregado' : (envioFin.is_recibido ? 'Recibido' : 'No recibido') }}</td>
            </tr>
            <tr v-if="!finEnvios.envios.length"><td colspan="7">No hay envios cargados para este viaje.</td></tr>
          </tbody>
        </table>
      </div>
    </section>

    <section v-if="pantalla === 'cancelar-envios'" class="pvt-screen pvt-panel pvt-cancel-screen">
      <h3>Cancelacion de envios</h3>
      <div class="pvt-cancel-toolbar">
        <div class="pvt-segment mini pvt-cancel-filter">
          <button type="button" :class="{ activo: cancelacionEnvios.opcionFiltrado === 1 }" @click="seleccionarFiltroCancelacion(1)">Solo activos</button>
          <button type="button" :class="{ activo: cancelacionEnvios.opcionFiltrado === 2 }" @click="seleccionarFiltroCancelacion(2)">Solo cancelados</button>
          <button type="button" :class="{ activo: cancelacionEnvios.opcionFiltrado === 3 }" @click="seleccionarFiltroCancelacion(3)">Todos</button>
        </div>
        <label>Numero de envio<input v-model.trim="cancelacionEnvios.noEnvio" autocomplete="off" @keyup.enter="cargarCancelacionEnvios"></label>
        <label class="pvt-cancel-date">Desde<input v-model="cancelacionEnvios.fechaDesde" type="date"></label>
        <label class="pvt-cancel-date">Hasta<input v-model="cancelacionEnvios.fechaHasta" type="date"></label>
        <label class="pvt-cancel-cashier">Cajero/usuario<input v-model.trim="cancelacionEnvios.cajero" autocomplete="off" @keyup.enter="cargarCancelacionEnvios"></label>
        <button type="button" class="pvt-action" :disabled="cancelacionEnvios.cargando" @click="cargarCancelacionEnvios">Buscar</button>
        <button type="button" class="pvt-action" @click="limpiarFiltroCancelacion">Limpiar</button>
        <label class="pvt-check"><input v-model="impresion.enviarDirecto" type="checkbox"> Enviar directo a la impresora</label>
      </div>
      <div v-if="cancelacionEnvios.mensaje" class="pvt-message" :class="cancelacionEnvios.tipoMensaje">{{ cancelacionEnvios.mensaje }}</div>
      <div class="pvt-close-table pvt-cancel-table">
        <table>
          <thead>
            <tr>
              <th>No. envio</th>
              <th>Fecha</th>
              <th>Cliente que envia</th>
              <th>Estado</th>
              <th>Num viaje</th>
              <th>Recepcion/Entrega</th>
              <th>NCF</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in cancelacionEnvios.listado" :key="item.no_envio" :class="{ selected: cancelacionEnvios.envio && cancelacionEnvios.envio.no_envio === item.no_envio }" @click="seleccionarCancelacionEnvio(item)">
              <td>{{ item.no_envio }}</td>
              <td>{{ item.fecha }}</td>
              <td>{{ item.nombre_remitente }}</td>
              <td>{{ item.activado ? 'ACTIVO' : 'CANCELADO' }}</td>
              <td>{{ item.no_viaje }}</td>
              <td>{{ estadoRecepcionEntrega(item) }}</td>
              <td>{{ item.ncf }}</td>
            </tr>
            <tr v-if="!cancelacionEnvios.listado.length"><td colspan="7">No hay envios para los filtros indicados.</td></tr>
          </tbody>
        </table>
      </div>
      <div class="pvt-cancel-actions">
        <button type="button" class="pvt-action pvt-cancel-action-btn" :disabled="!cancelacionEnvios.envio" @click="reimprimirEnvioCancelacion">Reimprimir</button>
        <button type="button" class="pvt-action pvt-cancel-action-btn" :disabled="!cancelacionEnvios.envio || !cancelacionEnvios.envio.is_recogido" @click="reimprimirEntregaCancelacion">R.R Entrega</button>
        <button type="button" class="pvt-action pvt-cancel-action-btn" :disabled="!cancelacionEnvios.envio || cancelacionEnvios.cargandoDetalle" @click="verFirmaEntrega"><i class="fa fa-pencil" aria-hidden="true"></i> Ver firma</button>
        <button type="button" class="pvt-action pvt-cancel-action-btn danger" :disabled="cancelacionEnvios.guardando || cancelacionEnvios.cargandoDetalle || !cancelacionEnvios.envio || cancelacionEnvios.envio.activado === false" @click="cancelarEnvioSeleccionado">{{ cancelacionEnvios.pendienteFiscal || cancelacionEnvios.incierta ? 'Reintentar cancelacion' : 'Cancelar envio' }}</button>
        <label class="pvt-cancel-reason">Motivo de cancelacion<textarea v-model.trim="cancelacionEnvios.motivo" maxlength="1000" :readonly="cancelacionEnvios.guardando || cancelacionEnvios.pendienteFiscal || cancelacionEnvios.incierta || (cancelacionEnvios.envio && cancelacionEnvios.envio.activado === false)"></textarea></label>
      </div>
      <div class="pvt-entrega-detail">
        <h4>Datos del envio</h4>
        <div class="pvt-entrega-info">
          <div><span>Remitente</span><strong>{{ cancelacionEnvios.envio ? cancelacionEnvios.envio.nombre_remitente : '' }}</strong></div>
          <div><span>Destinatario</span><strong>{{ cancelacionEnvios.envio ? cancelacionEnvios.envio.nombre_destinatario : '' }}</strong></div>
          <div><span>Telefono remitente</span><strong>{{ cancelacionEnvios.envio ? cancelacionEnvios.envio.telefono_remitente : '' }}</strong></div>
          <div><span>Telefono destinatario</span><strong>{{ cancelacionEnvios.envio ? cancelacionEnvios.envio.telefono_destinatario : '' }}</strong></div>
          <div><span>Tipo envio</span><strong>{{ cancelacionTipoEnvio }}</strong></div>
          <div><span>Destino</span><strong>{{ cancelacionEnvios.envio ? cancelacionEnvios.envio.ruta_destino : '' }}</strong></div>
          <div><span>Valor declarado</span><strong>{{ moneda(cancelacionEnvios.envio ? cancelacionEnvios.envio.valor_declarado : 0) }}</strong></div>
          <div><span>Hora factura / Chofer</span><strong>{{ cancelacionHoraChofer }}</strong></div>
          <div class="wide"><span>Descripcion</span><strong>{{ cancelacionEnvios.envio ? cancelacionEnvios.envio.descripcion : '' }}</strong></div>
          <div v-if="cancelacionPagoDestino > 0" class="wide pago-destino"><span>Pago en destino</span><strong>{{ moneda(cancelacionPagoDestino) }}</strong></div>
        </div>
      </div>
      <div class="pvt-dialog-actions">
        <button type="button" class="pvt-action" @click="seleccionarPantalla('envios')">Regresar</button>
      </div>
    </section>

    <section v-if="pantalla === 'lectura'" class="pvt-screen pvt-panel pvt-lectura-screen">
      <h3>Lectura de tickets</h3>
      <div class="pvt-boarding-head">
        <label>Viaje a abordar<input v-model="lectura.viaje" :disabled="lectura.leyendo" autocomplete="off"></label>
        <label>Ficha<input v-model="lectura.ficha" :disabled="lectura.leyendo" autocomplete="off"></label>
        <label>Chofer<input v-model="lectura.chofer" :disabled="lectura.leyendo" autocomplete="off"></label>
        <label>Num ticket<input ref="lecturaTicket" v-model="lectura.ticket" :disabled="lectura.leyendo" autocomplete="off" @keyup.enter="leerTicket"></label>
        <button type="button" class="pvt-action" :disabled="lectura.leyendo" @click="leerTicket">Aceptar</button>
        <button type="button" class="pvt-action" :disabled="lectura.leyendo" @click="seleccionarPantalla('venta')">Regresar</button>
      </div>
      <div class="pvt-boarding-summary">
        <div><span>Ultimo ticket</span><strong>{{ lectura.ultimo.boleto || '-' }}</strong></div>
        <div><span>Origen</span><strong>{{ lectura.ultimo.origen || '-' }}</strong></div>
        <div><span>Destino</span><strong>{{ lectura.ultimo.destino || '-' }}</strong></div>
        <div><span>Total leido</span><strong>{{ moneda(totalLectura) }}</strong></div>
      </div>
      <div v-if="mensaje" class="pvt-message" :class="mensajeTipo">
        <span>{{ mensaje }}</span>
        <button v-if="reimpresionPendiente" type="button" class="pvt-message-action" :disabled="reimpresionPendiente.imprimiendo" @click="reimprimirPendiente">
          Reimprimir {{ reimpresionPendiente.referencia }}
        </button>
      </div>
      <div class="pvt-boarding-tables">
        <div>
          <h4>Tickets abordados ahora</h4>
          <table>
            <thead>
              <tr>
                <th># Ticket</th>
                <th>Turno</th>
                <th>Fecha</th>
                <th>Precio</th>
                <th>Usuario</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="ticket in lectura.abordadosAhora" :key="'a-' + ticket.boleto" class="abordado">
                <td>{{ ticket.boleto }}</td>
                <td>{{ ticket.turno }}</td>
                <td>{{ ticket.fecha }}</td>
                <td>{{ moneda(ticket.precio) }}</td>
                <td>{{ ticket.usuario }}</td>
              </tr>
              <tr v-if="lectura.abordadosAhora.length === 0"><td colspan="5">Sin tickets leidos en esta sesion.</td></tr>
            </tbody>
          </table>
        </div>
        <div>
          <h4>Tickets que ya estaban abordados</h4>
          <table>
            <thead>
              <tr>
                <th># Ticket</th>
                <th>Usuario</th>
                <th>Fecha lectura</th>
                <th>Precio</th>
                <th>Turno</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="ticket in lectura.yaAbordados" :key="'y-' + ticket.boleto" class="ya-abordado">
                <td>{{ ticket.boleto }}</td>
                <td>{{ ticket.usuario }}</td>
                <td>{{ ticket.fechaLectura }}</td>
                <td>{{ moneda(ticket.precio) }}</td>
                <td>{{ ticket.turno }}</td>
              </tr>
              <tr v-if="lectura.yaAbordados.length === 0"><td colspan="5">No hay tickets repetidos.</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <section v-if="pantalla === 'cierre-viaje'" class="pvt-screen pvt-panel pvt-trip-close-screen">
      <h3>Cierre de Viaje</h3>
      <div class="pvt-close-head">
        <label># Viaje<input v-model="turno.numeroViaje" :disabled="cierreViaje.cerrado || cierreViaje.cargando || cierreViaje.guardando" autocomplete="off" @input="cierreViaje.detalleCargado = false" @keyup.enter="buscarCierreViajeManual"></label>
        <label>Ficha
          <select v-model="turno.ficha" :disabled="cierreViajeBloqueado" @change="seleccionarFichaTurno">
            <option value="">Seleccione ficha</option>
            <option v-if="turno.ficha && !existeFichaTurno(turno.ficha)" :value="turno.ficha">{{ turno.ficha }}</option>
            <option v-for="(vehiculo, indice) in fichasDisponibles" :key="'cierre-ficha-' + indice" :value="valorFichaTurno(vehiculo)">
              {{ textoFichaTurno(vehiculo) }}
            </option>
          </select>
        </label>
        <label>Fecha<input :value="cierreViaje.resumen.fechaCierre || fechaTrabajo" disabled></label>
        <label>Chofer
          <select v-model="turno.chofer" :disabled="cierreViajeBloqueado">
            <option value="">Seleccione chofer</option>
            <option v-if="turno.chofer && !existeChoferTurno(turno.chofer)" :value="turno.chofer">{{ turno.chofer }}</option>
            <option v-for="(chofer, indice) in choferesDisponibles" :key="'cierre-chofer-' + indice" :value="valorChoferTurno(chofer)">
              {{ textoChoferTurno(chofer) }}
            </option>
          </select>
        </label>
        <button type="button" class="pvt-action" :disabled="cargandoContexto || cierreViaje.cargando || cierreViaje.guardando" @click="abrirConsultaViajesCierre">Buscar</button>
        <button type="button" class="pvt-action" :disabled="cierreViajeBloqueado" @click="guardarCierreViaje">Guardar</button>
        <button type="button" class="pvt-action" :disabled="cargandoContexto || cierreViaje.cargando || cierreViaje.guardando || cierreViaje.imprimiendo || !cierreViaje.detalleCargado || !cierreViaje.cerrado" @click="imprimirCierreViaje">Reimprimir</button>
      </div>
      <div v-if="cierreViaje.cerrado" class="pvt-message error">VIAJE CERRADO: {{ cierreViaje.cierre && cierreViaje.cierre.id ? 'cierre #' + cierreViaje.cierre.id : '' }}</div>
      <div v-if="mensaje" class="pvt-message" :class="mensajeTipo">
        <span>{{ mensaje }}</span>
        <button v-if="reimpresionPendiente" type="button" class="pvt-message-action" :disabled="reimpresionPendiente.imprimiendo" @click="reimprimirPendiente">
          Reimprimir {{ reimpresionPendiente.referencia }}
        </button>
      </div>
      <div class="pvt-close-stats">
        <div><span>Capacidad</span><strong>{{ cierreViaje.resumen.capacidad || turno.capacidad }}</strong></div>
        <div><span>Ocupados</span><strong>{{ cierreViaje.resumen.cantidadVendida || 0 }}</strong></div>
        <div><span>Se quedan</span><strong>{{ cierreViaje.resumen.cantidadNoAbordados || 0 }}</strong></div>
        <div><span>Disponibles</span><strong>{{ disponiblesCierreViaje }}</strong></div>
        <div><span>Abordados</span><strong>{{ cierreViaje.resumen.cantidadAbordados || 0 }}</strong></div>
        <div><span>No abordados</span><strong>{{ cierreViaje.resumen.cantidadNoAbordados || 0 }}</strong></div>
      </div>
      <div class="pvt-close-grid">
        <div class="pvt-close-table">
          <table>
            <thead>
              <tr>
                <th># Boleto</th>
                <th>Ruta</th>
                <th>Valor</th>
                <th>Desc.</th>
                <th>Recargo</th>
                <th>Cortesia</th>
                <th>Importe</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="boleto in cierreViaje.boletos" :key="'cv-' + boleto.numero_boleto" :class="statusCierreClase(boleto)">
                <td>{{ boleto.numero_boleto }}</td>
                <td>{{ boleto.ruta || ((boleto.origen || '') + ' -> ' + (boleto.destino || '')) }}</td>
                <td>{{ moneda(boleto.precio) }}</td>
                <td>{{ moneda(boleto.descuento) }}</td>
                <td>{{ moneda(boleto.recargo) }}</td>
                <td>{{ moneda(boleto.valor_cortesia) }}</td>
                <td>{{ moneda(boleto.importe) }}</td>
                <td>{{ boleto.status }}</td>
              </tr>
              <tr v-if="cierreViaje.boletos.length === 0"><td colspan="8">{{ cargandoContexto || cierreViaje.cargando ? 'Cargando detalle del viaje...' : 'No hay boletos para este viaje.' }}</td></tr>
            </tbody>
          </table>
        </div>
        <div class="pvt-close-side">
          <div class="pvt-close-totals">
            <div><span>Total no abordado</span><strong>{{ cierreViaje.resumen.cantidadNoAbordados || 0 }} / {{ moneda(cierreViaje.resumen.valorNoAbordados) }}</strong></div>
            <div><span>Total abordados</span><strong>{{ cierreViaje.resumen.cantidadAbordados || 0 }} / {{ moneda(cierreViaje.resumen.valorAbordados) }}</strong></div>
            <div><span>- Boletos de cortesia</span><strong>{{ cierreViaje.resumen.cantidadCortesia || 0 }} / {{ moneda(cierreViaje.resumen.valorCortesia) }}</strong></div>
            <div><span>- Boletos con descuento</span><strong>{{ cierreViaje.resumen.cantidadDescuento || 0 }} / {{ moneda(cierreViaje.resumen.valorDescuento) }}</strong></div>
            <div><span>+ Boletos con recargos</span><strong>{{ cierreViaje.resumen.cantidadRecargos || 0 }} / {{ moneda(cierreViaje.resumen.valorRecargos) }}</strong></div>
            <div><span>- Comision boletos</span><strong>{{ moneda(cierreViaje.resumen.comisionDescontar) }}</strong></div>
          </div>
        </div>
      </div>
      <div class="pvt-close-bottom">
        <div class="pvt-close-deductions">
          <h4>Deducciones</h4>
          <div class="pvt-close-deduction-grid">
            <label>Dieta<input v-model.number="cierreViaje.dieta" :disabled="cierreViajeBloqueado" type="number" min="0"></label>
            <label>Otras<input v-model.number="cierreViaje.otrasDeducciones" :disabled="cierreViajeBloqueado" type="number" min="0"></label>
            <label>Copias<input v-model.number="impresion.copias" type="number" min="0"></label>
            <label class="pvt-check"><input v-model="impresion.enviarDirecto" type="checkbox"> Enviar directo a la impresora</label>
            <label class="wide">Descripcion<textarea v-model="cierreViaje.conceptoOtrasDeducciones" :disabled="cierreViajeBloqueado"></textarea></label>
          </div>
        </div>
        <div class="pvt-close-deliver">
          <span>Total entregar</span>
          <strong>{{ moneda(totalCierreViaje) }}</strong>
        </div>
      </div>
    </section>

    <section v-if="pantalla === 'cierre-caja'" class="pvt-screen pvt-panel pvt-cash-screen">
      <div class="pvt-cash-title-row">
        <h3>Cierre de caja</h3>
        <span class="pvt-cash-close-number"># Cierre: {{ numeroCierreCajaTrabajo }}</span>
      </div>
      <div class="pvt-cash-head">
        <div class="pvt-cash-head-fields">
          <label>Fecha<input :value="fechaTrabajo" disabled></label>
          <label>Caja<input :value="contexto.cajaNombre" disabled></label>
          <label>Cajero<input :value="contexto.cajero" disabled></label>
        </div>
        <div class="pvt-cash-head-actions">
          <button type="button" class="pvt-action" :disabled="cierreCaja.cargando || cierreCaja.guardando" @click="cargarCierreCajaDetalle">{{ cierreCaja.cargando ? "Cargando..." : "Actualizar" }}</button>
          <button type="button" class="pvt-action" :disabled="cierreCaja.cargando || cierreCaja.guardando" @click="guardarCierreCaja">Guardar</button>
          <button type="button" class="pvt-action" :disabled="cierreCaja.cargando || cierreCaja.guardando || !contexto.caja" @click="reimprimirUltimoCierreCaja">Reimprimir</button>
        </div>
      </div>
      <div v-if="mensaje" class="pvt-message" :class="mensajeTipo">
        <span>{{ mensaje }}</span>
        <button v-if="reimpresionPendiente" type="button" class="pvt-message-action" :disabled="reimpresionPendiente.imprimiendo" @click="reimprimirPendiente">
          Reimprimir {{ reimpresionPendiente.referencia }}
        </button>
      </div>
      <div class="pvt-cash-grid">
        <div class="pvt-cash-count">
          <h4>Conteo de caja</h4>
          <label>Sobrante usuario anterior<input v-model.number="cierreCaja.sobranteUsuarioAnterior" type="number" @keydown.enter.prevent="focusSiguienteCampoCaja"></label>
          <div class="pvt-pay-row">
            <label>Cant. tarjeta<input v-model.number="cierreCaja.cantidadTarjeta" type="number" min="0" @keydown.enter.prevent="focusSiguienteCampoCaja"></label>
            <label>Valor tarjeta<input v-model.number="cierreCaja.tarjeta" type="number" min="0" @keydown.enter.prevent="focusSiguienteCampoCaja"></label>
            <label>Cant. cheque<input v-model.number="cierreCaja.cantidadCheques" type="number" min="0" @keydown.enter.prevent="focusSiguienteCampoCaja"></label>
            <label>Valor cheque<input v-model.number="cierreCaja.cheques" type="number" min="0" @keydown.enter.prevent="focusSiguienteCampoCaja"></label>
          </div>
          <div class="pvt-cash-section-title">Denominaciones</div>
          <div class="pvt-denominations">
            <label v-for="den in denominacionesCaja" :key="den">RD$ {{ den }}<input v-model.number="cierreCaja.denominaciones[den]" type="number" min="0" @keydown.enter.prevent="focusSiguienteCampoCaja"></label>
          </div>
          <div class="pvt-cash-total">{{ moneda(totalEfectivoCaja) }} EFECTIVO</div>
          <div class="pvt-print-options">
            <label class="pvt-check"><input v-model="impresion.enviarDirecto" type="checkbox"> Enviar directo a la impresora</label>
            <label>Copias<input v-model.number="impresion.copias" type="number" min="0" @keydown.enter.prevent="focusSiguienteCampoCaja"></label>
          </div>
        </div>
        <div class="pvt-cash-sales">
          <h4>Datos de ventas</h4>
          <div><span>(+) Ventas de boletos</span><strong>{{ moneda(cierreCaja.resumen.ventaBoletos) }}</strong></div>
          <div><span>(-) Compra de boletos/Comision</span><strong>{{ moneda(cierreCaja.resumen.compraBoletos) }}</strong></div>
          <div><span>(+) Ventas de envios</span><strong>{{ moneda(cierreCaja.resumen.ventaEnvios) }}</strong></div>
          <div class="pvt-cash-sub"><span>Envios cobrados aqui</span><strong>{{ moneda(cierreCaja.resumen.ventaEnviosOrigen) }}</strong></div>
          <div class="pvt-cash-sub"><span>Cobros pago destino</span><strong>{{ moneda(cierreCaja.resumen.cobrosEnviosDestino) }}</strong></div>
          <div class="pvt-cash-sub"><span>Por cobrar en destino</span><strong>{{ moneda(cierreCaja.resumen.enviosPorCobrarDestino) }}</strong></div>
          <div><span>(+) Deposito de caja</span><strong>{{ moneda(cierreCaja.resumen.deposito) }}</strong></div>
          <div><span>(+) Otras ventas</span><strong>{{ moneda(cierreCaja.resumen.otrasVentas) }}</strong></div>
          <div><span>(+) Pagos recibidos de otras sucursales</span><strong>{{ moneda(cierreCaja.resumen.pagosRecibidos) }}</strong></div>
          <div><span>(-) Pagos enviados a otras sucursales</span><strong>{{ moneda(cierreCaja.resumen.pagosEnviados) }}</strong></div>
          <div><span>Total que debe haber para cuadre</span><strong>{{ moneda(montoCuadreCaja) }}</strong></div>
        </div>
      </div>
      <div class="pvt-cash-diff" :class="claseDiferenciaCaja">
        <span>Diferencia</span>
        <strong>{{ moneda(Math.abs(diferenciaCaja)) }}</strong>
      </div>
    </section>

    <!---------------------  Panel Menu Opcion Botones ------------------------------->
    <section>
    <div style="max-height:300px;" class="overflow-x-auto" v-show="false">
          <!-- columna  ---------------------->
          <PvMenuOpcionBotones ref="RefPvMenuOpcionBotones" @DataRetornAccion="DataRetornMenuOpcBotonesPermisosPv"
            @DataRetornAccionPadre="DataRetornPadrePermisoPv" />
        </div>
    </section>
    <!--------------------- fin Panel Menu Opcion Botones ------------------------------->
    <TransportePdfPreview v-model="previewPdf.visible" :blob="previewPdf.blob" :cargando="previewPdf.cargando" :error="previewPdf.error" />

  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import { nuevoIdSolicitud } from "../Utilitario/catalogo";
import FirmaEntrega from "../Componentes/FirmaEntrega.vue";
import TransportePdfPreview from "../Componentes/TransportePdfPreview.vue";

import PvMenuOpcionBotones from "@/PuntodeVenta/UtilidadComponents/PvMenuOpcionBotones.vue"
export default {
  name: "PuntoVentaTransporte",
components: {
    PvMenuOpcionBotones, FirmaEntrega, TransportePdfPreview
    },
  data() {
    return {
      pantalla: "venta",
      previewPdf: { visible: false, blob: null, cargando: false, error: "" },
      tabs: [
        { text: "Boleteria", value: "venta", icono: "fa-ticket" },
        { text: "Envios", value: "envios", icono: "fa-truck" },
        { text: "Recargos", value: "recargo", icono: "fa-money" },
        { text: "Descuento", value: "descuento", icono: "fa-tags" },
        { text: "Recepcion", value: "recepcion", icono: "fa-flag" },
        { text: "Entrega", value: "entrega", icono: "fa-archive" },
        { text: "Cancelar envios", value: "cancelar-envios", icono: "fa-times-circle" },
        { text: "Fin envios", value: "fin-envios", icono: "fa-print" },
        { text: "Lectura", value: "lectura", icono: "fa-barcode" },
        { text: "Cierre viaje", value: "cierre-viaje", icono: "fa-bus" },
        { text: "Cierre caja", value: "cierre-caja", icono: "fa-archive" },
      ],
      denominacionesCaja: [2000, 1000, 500, 200, 100, 50, 25, 20, 10, 5, 1],
      contexto: {
        sucursal: "Sin asignar",
        sucursalId: null,
        cajero: "aetrauser",
        caja: null,
        cajaId: null,
        cajaNombre: "Seleccione caja",
        numeroCierre: "",
        facturacionElectronicaActiva: false,
        impresoraTickets: "",
        impresoraTicketsLocal: "",
        vistaPreviaPdf: false,
        impresoraEtiquetas: "",
        impresoraEtiquetasEnvio: "0",
        usaFirmaDigital: false,
        sucursalDireccion: "",
        sucursalTelefono: "",
        sucursalRnc: "",
      },
      rangosPesoEnvio: [],
      politicasImpresion: { boleto: "", envio: "" },
      firmaConsulta: { visible: false, imagen: "" },
      configuracionCaja: {
        vistaPreviaPdf: false,
        visible: false,
        sucursalId: null,
        cajaId: null,
        cajaNombre: "",
        impresoraTickets: "",
      },
      impresorasLocales: [],
      impresoraDefaultLocal: "",
      sucursalesDisponibles: [],
      cajasDisponibles: [],
      cargandoOpcionesCaja: false,
      cargandoContexto: false,
      errorContexto: false,
      solicitudContexto: 0,
      turnosDisponibles: [],
      diaTurnos: this.fechaActualTurnos(),
      temporizadorDiaTurnos: null,
      turnoFacturacion: null,
      actualizandoTurnos: false,
      puedeModificarCapacidad: false,
      capacidadEdicion: { visible: false, valor: 0, guardando: false, error: "" },
      solicitudTurnos: 0,
      fichasDisponibles: [],
      choferesDisponibles: [],
      controlesDisponibles: [],
      turno: {
        id: null,
        numeroViaje: "",
        ficha: "",
        chofer: "",
        control: "",
        hora: "",
        capacidad: 0,
        vendidos: 0,
        seQuedan: 0,
        pendientes: 0,
        disponibles: 0,
      },
      rutas: [],
      rutasEnvio: [],
      rutaSeleccionada: null,
      busquedaRuta: "",
      destinoEnvioSeleccionado: null,
      envio: this.nuevoEnvio(),
      ultimaBusquedaPersonaEnvio: "",
      venta: this.nuevaVenta(),
      pagos: this.nuevosPagos(),
      cortesia: { visible: false, identificacion: "", cargando: false, error: "", solicitud: 0, registro: null, clave: "" },
      comprobante: this.nuevoComprobante(),
      consultaFiscal: { solicitud: 0, temporizador: null, cargando: false, enCurso: "", consultada: "", rncDatos: "", identificacionValida: null, mensaje: "", tipo: "" },
      editarFiscal: false,
      guardando: false,
      ecf: { visible: false, cargando: false, procesando: "", error: "", facturas: [], pagina: 0, busquedaNcf: "", ncfFiltro: "" },
      creandoTurno: false,
      puedeCrearTurno: false,
      mensaje: "",
      mensajeTipo: "",
      reimpresionPendiente: null,
      recargoOrigen: "venta",
      peticionRecargo: 0,
      recargo: {
        id: null,
        motivo: "",
        valor: 0,
        cantidad: 1,
        busqueda: "",
        catalogo: [],
        precioEditable: true,
      },
      descuento: {
        tipo: "identificacion",
        identificacion: "",
        pin: "",
        porcentaje: 0,
        cargando: false,
        referencia: null,
      },
      lectura: {
        sesion: 0,
        claveSesion: "",
        viaje: "",
        ficha: "",
        chofer: "",
        ticket: "",
        leyendo: false,
        ultimo: {},
        abordadosAhora: [],
        yaAbordados: [],
      },
      recepcion: {
        noEnvio: "",
        cargando: false,
        estado: "",
        mensaje: "",
        tipoMensaje: "",
        envio: null,
      },
      entrega: {
        recargo: null,
        firmaVisible: false,
        fotoFirma: "",
        firmaContexto: "",
        peticionDetalle: 0,
        cargandoDetalle: false,
        filtros: {
          noEnvio: "",
          fechaDesde: new Date().toISOString().slice(0, 10),
          fechaHasta: new Date().toISOString().slice(0, 10),
          nombre: "",
          telefono: "",
        },
        cargando: false,
        guardando: false,
        listado: [],
        envio: null,
        cedulaEntrega: "",
        cedulaRequerida: false,
        mensaje: "",
        tipoMensaje: "",
      },
      finEnvios: {
        numeroViaje: "",
        ficha: "",
        chofer: "",
        cargando: false,
        imprimiendo: false,
        envios: [],
        mensaje: "",
        tipoMensaje: "",
      },
      cancelacionEnvios: {
        noEnvio: "",
        fechaDesde: new Date().toISOString().slice(0, 10),
        fechaHasta: new Date().toISOString().slice(0, 10),
        cajero: "",
        opcionFiltrado: 1,
        cargando: false,
        guardando: false,
        cargandoDetalle: false,
        peticionDetalle: 0,
        solicitud: null,
        pendienteFiscal: false,
        incierta: false,
        listado: [],
        envio: null,
        motivo: "",
        mensaje: "",
        tipoMensaje: "",
      },
      cierreViaje: {
        detalleCargado: false,
        cierreId: null,
        cargando: false,
        guardando: false,
        imprimiendo: false,
        cerrado: false,
        cierre: null,
        boletos: [],
        resumen: {},
        configuracion: {},
        dieta: 0,
        otrasDeducciones: 0,
        conceptoOtrasDeducciones: "",
      },
      consultaViajes: {
        visible: false,
        cargando: false,
        solicitud: 0,
        fecha: new Date().toISOString().slice(0, 10),
        sentido: "",
        estado: "",
        error: "",
        busqueda: "",
        viajes: [],
      },
      cierreCaja: {
        cargando: false,
        guardando: false,
        resumen: {},
        configuracion: {},
        denominaciones: {
          2000: 0,
          1000: 0,
          500: 0,
          200: 0,
          100: 0,
          50: 0,
          25: 0,
          20: 0,
          10: 0,
          5: 0,
          1: 0,
        },
        cantidadTarjeta: 0,
        tarjeta: 0,
        cantidadCheques: 0,
        cheques: 0,
        sobranteUsuarioAnterior: 0,
        cierre: null,
        detalleImpresion: [],
      },
      impresion: {
        enviarDirecto: true,
        copias: 0,
        copiasPequeno: 0,
        formato: "TicketViaje",
      },
      EjecutarPermisoPv:false,
    };
  },

  computed: {
    fechaTrabajo() {
      var partes = this.diaTurnos.split("-");
      return Number(partes[2]) + "/" + Number(partes[1]) + "/" + partes[0];
    },
    fechaTrabajoReporte() {
      return this.diaTurnos;
    },
    turnosDisponiblesDelDia() {
      return this.filtrarTurnosPorRuta(this.turnosDisponibles, this.diaTurnos);
    },
    rutasFiltradas() {
      var texto = (this.busquedaRuta || "").toLowerCase();
      return this.rutas.filter((ruta) => {
        return this.nombreRuta(ruta).toLowerCase().indexOf(texto) !== -1;
      }).slice(0, 12);
    },
    viajesConsultaFiltrados() {
      var texto = (this.consultaViajes.busqueda || "").toLowerCase();
      var viajes = Array.isArray(this.consultaViajes.viajes) ? this.consultaViajes.viajes : [];
      if (!texto) {
        return viajes;
      }
      return viajes.filter((viaje) => {
        return [
          viaje.numero_viaje,
          viaje.cierre_id,
          viaje.estado,
          viaje.numero_turno,
          viaje.ficha,
          viaje.conductor_nombre,
        ].join(" ").toLowerCase().indexOf(texto) !== -1;
      });
    },
    destinosEnvioFiltrados() {
      var texto = (this.envio.busquedaDestino || "").toLowerCase();
      return this.rutasEnvio.filter((ruta) => {
        return this.nombreRuta(ruta).toLowerCase().indexOf(texto) !== -1;
      }).slice(0, 8);
    },
    cajasFiltradasConfiguracion() {
      var sucursalId = Number(this.configuracionCaja.sucursalId || 0);
      if (!sucursalId) {
        return this.cajasDisponibles;
      }
      return this.cajasDisponibles.filter((caja) => {
        return Number(caja.sucursal && caja.sucursal.codigo ? caja.sucursal.codigo : 0) === sucursalId;
      });
    },
    precioSeleccionado() {
      return this.rutaSeleccionada ? this.precioRuta(this.rutaSeleccionada) : 0;
    },
    subtotal() {
      return this.precioSeleccionado * Number(this.venta.cantidad || 0);
    },
    total() {
      return Math.max(0, this.subtotal + Number(this.venta.recargo || 0) - Number(this.venta.descuento || 0) - Number(this.pagos.valorCortesia || 0));
    },
    totalPagado() {
      return Number(this.pagos.efectivo || 0) + Number(this.pagos.credito || 0) + Number(this.pagos.tarjeta || 0) +
        Number(this.pagos.pagoDestino || 0) + Number(this.pagos.cheque || 0) + Number(this.pagos.notadecredito || 0) +
        Number(this.pagos.transferencia || 0);
    },
    devuelta() {
      return Math.max(0, this.totalPagado - this.total);
    },
    editandoPaqueteEnvio() {
      return this.envio.indiceEdicion >= 0;
    },
    subtotalEnvio() {
      return this.envio.paquetes.reduce((total, paquete) => total + Number(paquete.precio || 0), 0);
    },
    impuestosEnvio() {
      return this.envio.paquetes.reduce((total, paquete) => total + Number(paquete.impuestos || 0), 0);
    },
    totalEnvio() {
      return Math.max(0, this.subtotalEnvio + this.impuestosEnvio + Number(this.venta.recargo || 0) - Number(this.venta.descuento || 0) - Number(this.pagos.valorCortesia || 0)) + this.totalBoletosEnvio;
    },
    asientosEnvio() {
      return this.envio.paquetes.reduce((total, p) => total + Number(p.cantidadAsientos || 0), 0);
    },
    totalBoletosEnvio() {
      return this.envio.paquetes.reduce((total, p) => total + Number(p.cantidadAsientos || 0) * Number(p.precioBoleto || 0), 0);
    },
    devueltaEnvio() {
      return Math.max(0, this.totalPagado - this.totalEnvio);
    },
    claveContextoLectura() {
      return JSON.stringify([this.claveConfiguracionCaja(), Number(this.contexto.caja || 0),
        Number(this.contexto.sucursalId || 0), this.contexto.cajero || ""]);
    },
    claveSesionLectura() {
      return JSON.stringify([this.claveContextoLectura, String(this.lectura.viaje || "").trim().toUpperCase()]);
    },
    totalLectura() {
      return this.lectura.abordadosAhora.reduce((total, ticket) => total + Number(ticket.precio || 0), 0);
    },
    recepcionEstadoTexto() {
      if (this.recepcion.estado === "recibido") {
        return "Recibido ahora";
      }
      if (this.recepcion.estado === "ya_recibido") {
        return "Ya recibido";
      }
      if (this.recepcion.estado === "sucursal_incorrecta") {
        return "Otra sucursal";
      }
      if (this.recepcion.estado === "no_encontrado") {
        return "No encontrado";
      }
      return "";
    },
    recepcionTipoEnvio() {
      var tipo = this.recepcion.envio && (this.recepcion.envio.tipo_envio || this.recepcion.envio.tipoEnvio);
      if (tipo === "D") {
        return "Dinero en efectivo";
      }
      if (tipo === "R") {
        return "Regalo";
      }
      return "Paquete";
    },
    entregaTipoEnvio() {
      var tipo = this.entrega.envio && (this.entrega.envio.tipo_envio || this.entrega.envio.tipoEnvio);
      if (tipo === "D") {
        return "Dinero";
      }
      if (tipo === "R") {
        return "Regalo";
      }
      return this.entrega.envio ? "Paquete" : "";
    },
    entregaHoraChofer() {
      if (!this.entrega.envio) {
        return "";
      }
      return [this.entrega.envio.hora_salida || this.entrega.envio.hora_registro || "", this.entrega.envio.nombre_chofer || this.entrega.envio.conductor || ""]
        .filter((valor) => String(valor || "").trim() !== "")
        .join(" ");
    },
    pagoDestinoEntrega() {
      return Number(this.entrega.envio && this.entrega.envio.pago_destino ? this.entrega.envio.pago_destino : 0);
    },
    totalCobrarEntrega() {
      return this.pagoDestinoEntrega + Number(this.entrega.recargo && this.entrega.recargo.precio || 0);
    },
    totalPagadoEntrega() {
      return Number(this.pagos.efectivo || 0) + Number(this.pagos.credito || 0) + Number(this.pagos.tarjeta || 0) +
        Number(this.pagos.cheque || 0) + Number(this.pagos.notadecredito || 0) + Number(this.pagos.transferencia || 0);
    },
    devueltaEntrega() {
      return Math.max(0, this.totalPagadoEntrega - this.totalCobrarEntrega);
    },
    cancelacionTipoEnvio() {
      var tipo = this.cancelacionEnvios.envio && (this.cancelacionEnvios.envio.tipo_envio || this.cancelacionEnvios.envio.tipoEnvio);
      if (tipo === "D") {
        return "Dinero";
      }
      if (tipo === "R") {
        return "Regalo";
      }
      return this.cancelacionEnvios.envio ? "Paquete" : "";
    },
    cancelacionHoraChofer() {
      if (!this.cancelacionEnvios.envio) {
        return "";
      }
      return [this.cancelacionEnvios.envio.hora_salida || this.cancelacionEnvios.envio.hora_registro || "", this.cancelacionEnvios.envio.nombre_chofer || this.cancelacionEnvios.envio.conductor || ""]
        .filter((valor) => String(valor || "").trim() !== "")
        .join(" ");
    },
    cancelacionPagoDestino() {
      return Number(this.cancelacionEnvios.envio && this.cancelacionEnvios.envio.pago_destino ? this.cancelacionEnvios.envio.pago_destino : 0);
    },
    cierreViajeBloqueado() {
      return this.cargandoContexto || this.cierreViaje.cargando || this.cierreViaje.guardando ||
        this.cierreViaje.cerrado || !this.cierreViaje.detalleCargado;
    },
    totalCierreViaje() {
      var resumen = this.cierreViaje.resumen || {};
      if (this.cierreViaje.cerrado && resumen.totalEntregar != null) {
        return Number(resumen.totalEntregar);
      }
      return Number(resumen.valorAbordados || 0) -
        Number(resumen.valorDescuento || 0) +
        Number(resumen.valorRecargos || 0) -
        Number(resumen.valorCortesia || 0) -
        Number(resumen.comisionDescontar || 0) -
        Number(this.cierreViaje.dieta || 0) -
        Number(this.cierreViaje.otrasDeducciones || 0);
    },
    disponiblesCierreViaje() {
      var capacidad = Number(this.cierreViaje.resumen.capacidad || this.turno.capacidad || 0);
      var vendidos = Number(this.cierreViaje.resumen.cantidadVendida || 0);
      return Math.max(0, capacidad - vendidos);
    },
    totalEfectivoCaja() {
      return this.denominacionesCaja.reduce((total, den) => {
        return total + (Number(this.cierreCaja.denominaciones[den] || 0) * Number(den));
      }, 0);
    },
    montoCuadreCaja() {
      var resumen = this.cierreCaja.resumen || {};
      return Number(resumen.ventaBoletos || 0) +
        Number(resumen.ventaEnvios || 0) -
        Number(resumen.compraBoletos || 0) +
        Number(resumen.deposito || 0) +
        Number(resumen.otrasVentas || 0) +
        Number(resumen.pagosRecibidos || 0) -
        Number(resumen.pagosEnviados || 0) +
        Number(this.cierreCaja.sobranteUsuarioAnterior || 0);
    },
    diferenciaCaja() {
      return this.montoCuadreCaja - this.totalEfectivoCaja;
    },
    numeroCierreCajaTrabajo() {
      var cierre = this.cierreCaja.cierre || {};
      return cierre.secuencia_por_caja || cierre.secuencia || this.contexto.numeroCierre || "Pendiente";
    },
    claseDiferenciaCaja() {
      if (this.diferenciaCaja > 0) {
        return "faltante";
      }
      if (this.diferenciaCaja < 0) {
        return "sobrante";
      }
      return "cuadrado";
    },
  },

  mounted() {
    EventBus.$emit("anularBotonesAccion", {
      titulo: "Punto Venta Transporte",
      descripcion: "Venta de boletos de transporte",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      vercuenta: false,
      Transp: true,
      btnBarraDi: false,
      accion: [],
    });
    this.cargarContexto();
    this.cargarImpresorasLocales();
    this.temporizadorDiaTurnos = setInterval(this.comprobarDiaTurnos, 30000);
    window.addEventListener("focus", this.comprobarDiaTurnos);
    window.addEventListener("keydown", this.cobrarConTeclaFin);
  },

  beforeDestroy() {
    this.reiniciarLectura();
    this.cancelarBusquedaFiscal();
    clearInterval(this.temporizadorDiaTurnos);
    window.removeEventListener("focus", this.comprobarDiaTurnos);
    window.removeEventListener("keydown", this.cobrarConTeclaFin);
  },

  watch: {
    claveContextoLectura() {
      this.reiniciarLectura();
    },
    claveSesionLectura() {
      if (this.lectura.claveSesion !== this.claveSesionLectura) this.limpiarResultadosLectura();
    },
    "comprobante.tipo"() {
      this.cancelarBusquedaFiscal();
      this.consultaFiscal.consultada = "";
      if (this.comprobante.tipo === "fiscal") this.programarBusquedaFiscal();
    },
    subtotal() {
      this.recalcularRecargoAplicado();
      this.recalcularDescuentoAplicado();
    },
  },

  methods: {
    cobrarConTeclaFin(event) {
      // End es el nombre que recibe el navegador, incluso en teclados rotulados Fin.
      if (!event || event.key !== "End" || event.defaultPrevented || event.repeat || event.isComposing
          || event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) return;
      if (this.pantalla !== "venta" && this.pantalla !== "envios") return;
      if (this.guardando || this.creandoTurno || this.ecf.procesando || this.ecf.visible
          || this.cortesia.visible || this.configuracionCaja.visible || this.consultaViajes.visible || this.capacidadEdicion.visible) return;
      if (!this.$el || (event.target !== document.body && !this.$el.contains(event.target))) return;
      var boton = this.$refs[this.pantalla === "venta" ? "finVenta" : "finEnvio"];
      if (!boton || boton.disabled) return;
      event.preventDefault();
      boton.click();
    },
    claveVentaCortesia() {
      return JSON.stringify([this.contexto.cajaId || this.contexto.caja, this.rutaSeleccionada && this.rutaSeleccionada.id,
        this.turno.id, this.turno.control, this.precioSeleccionado, this.venta.cantidad, this.venta.recargo, this.venta.descuento]);
    },
    abrirCortesia() {
      if (this.pantalla !== "venta" || this.guardando || this.creandoTurno || this.cortesia.visible) return;
      if (!this.rutaSeleccionada || !this.esImportePositivo(this.precioSeleccionado)) {
        this.mostrarMensaje("Debe seleccionar una ruta con precio antes de aplicar cortesia.", "error");
        return;
      }
      if (Number(this.venta.cantidad) !== 1) {
        this.mostrarMensaje("Solo puede facturar un boleto por operacion de cortesia.", "error");
        return;
      }
      if (!this.validarTurnoVenta() || !this.validarControlFacturacion()) return;
      if (this.contexto.facturacionElectronicaActiva) {
        this.mostrarMensaje("La cortesia completa no esta habilitada para cajas con e-CF; no se ha consumido el cupo.", "error");
        return;
      }
      this.cortesia.visible = true;
      this.cortesia.error = "";
      this.cortesia.identificacion = "";
      this.$nextTick(() => {
        if (this.$refs.cedulaCortesia) this.$refs.cedulaCortesia.focus();
      });
    },
    cerrarCortesia() {
      if (this.guardando) return;
      this.cortesia.visible = false;
      this.cortesia.cargando = false;
      this.cortesia.solicitud++;
    },
    limpiarCortesia() {
      this.cortesia.solicitud++;
      this.cortesia.visible = false;
      this.cortesia.cargando = false;
      this.cortesia.registro = null;
      this.cortesia.clave = "";
      this.cortesia.identificacion = "";
      this.cortesia.error = "";
    },
    async buscarCortesia() {
      if (!this.cortesia.visible || this.cortesia.cargando || this.guardando) return;
      var identificacion = String(this.cortesia.identificacion || "").trim();
      if (!identificacion) { this.cortesia.error = "Debe digitar o escanear la cedula del beneficiario."; return; }
      var solicitud = ++this.cortesia.solicitud;
      var clave = this.claveVentaCortesia();
      this.cortesia.cargando = true;
      this.cortesia.error = "";
      try {
        var res = await this.$axios.post(this.$hostname + this.$hName + "/transportepv/cortesia/verificar",
          { identificacion: identificacion }, { headers: this.headers(), timeout: 30000, params: {
            cajaId: this.contexto.cajaId || (this.contexto.caja && this.contexto.caja.codigo ? this.contexto.caja.codigo : this.contexto.caja),
          } });
        if (solicitud !== this.cortesia.solicitud || !this.cortesia.visible) return;
        if (clave !== this.claveVentaCortesia()) throw new Error("La venta cambio. Lea nuevamente la cedula.");
        var data = res.data || {};
        if (data.estatus !== "ok" || !data.cortesia || !data.cortesia.id || Number(data.cortesia.cantidad_restante) < 1) {
          throw new Error(data.mensaje || "No tiene ninguna cortesia disponible y vigente.");
        }
        var importe = this.subtotal + Number(this.venta.recargo || 0) - Number(this.venta.descuento || 0);
        if (!this.esImportePositivo(importe) || Number(this.venta.cantidad) !== 1) throw new Error("Revise el importe y la cantidad del boleto.");
        this.cortesia.registro = data.cortesia;
        this.cortesia.clave = clave;
        this.pagos = this.nuevosPagos();
        this.pagos.valorCortesia = Math.round(importe * 100) / 100;
        this.venta.nombre = data.cortesia.nombre || "";
        this.venta.telefono = data.cortesia.telefono || "";
        this.cortesia.visible = false;
        await this.finalizarVenta();
      } catch (error) {
        if (solicitud !== this.cortesia.solicitud) return;
        var respuesta = error && error.response && error.response.data;
        this.cortesia.error = typeof respuesta === "string" ? respuesta : (respuesta && (respuesta.message || respuesta.mensaje))
          || (error.code === "ECONNABORTED" ? "La consulta de cortesia tardo demasiado. Intente nuevamente." : error.message)
          || "No se pudo consultar la cortesia.";
        this.$nextTick(() => {
          if (this.$refs.cedulaCortesia) { this.$refs.cedulaCortesia.focus(); this.$refs.cedulaCortesia.select(); }
        });
      } finally {
        if (solicitud === this.cortesia.solicitud) this.cortesia.cargando = false;
      }
    },
    cortesiaCompletaValidada() {
      return this.cortesia.registro && this.cortesia.registro.id && Number(this.cortesia.registro.cantidad_restante) > 0
        && this.cortesia.clave === this.claveVentaCortesia() && Number(this.venta.cantidad) === 1
        && !this.contexto.facturacionElectronicaActiva && this.pagos.valorCortesia > 0
        && Math.round((this.subtotal + Number(this.venta.recargo || 0) - Number(this.venta.descuento || 0)
          - this.pagos.valorCortesia) * 100) === 0;
    },
    headers() {
      if (this.$store && this.$store.getters && this.$store.getters.GetheadersAxios) {
        return this.$store.getters.GetheadersAxios;
      }
      return {};
    },
    totalParaFormaPago() {
      if (this.pantalla === "envios") {
        return this.totalEnvio;
      }
      if (this.pantalla === "entrega") {
        return this.totalCobrarEntrega;
      }
      return this.total;
    },
    autocompletarFormaPago(campo, event) {
      if (campo === "valorCortesia" && this.pantalla === "venta") return this.abrirCortesia();
      var valor = Number(this.totalParaFormaPago() || 0);
      if (!isFinite(valor) || valor < 0) {
        valor = 0;
      }
      this.$set(this.pagos, campo, Math.round(valor * 100) / 100);
      this.$nextTick(function () {
        if (event && event.target && typeof event.target.select === "function") {
          event.target.select();
        }
      });
    },
    seleccionarPantalla(pantalla) {
      if (this.entrega.guardando || this.entrega.firmaVisible) return;
      this.limpiarFirmaEntrega();
      if (this.guardando || this.lectura.leyendo || this.cierreViaje.guardando || this.cierreViaje.cargando || this.actualizandoTurnos) return;
      var anterior = this.pantalla;
      if (pantalla === "recargo") return this.abrirRecargo();
      if (anterior !== pantalla && (anterior === "lectura" || pantalla === "lectura")) {
        this.reiniciarLectura();
        this.mensaje = "";
        this.mensajeTipo = "";
      }
      if (anterior === "venta" && pantalla !== "venta" && pantalla !== "recargo" && pantalla !== "descuento" && this.cortesia.registro) {
        this.limpiarCortesia();
        this.pagos.valorCortesia = 0;
      }
      if (pantalla === "cierre-viaje" && anterior !== pantalla) {
        this.turnoFacturacion = Object.assign({}, this.turno);
      } else if (anterior === "cierre-viaje" && pantalla !== anterior) {
        this.turno = Object.assign({}, this.turnoFacturacion || this.turnoVacio());
        if (pantalla === "venta" || pantalla === "envios") {
          Object.assign(this.turno, { vendidos: 0, seQuedan: 0, pendientes: 0, disponibles: 0 });
        }
        this.turnoFacturacion = null;
        this.mensaje = "";
        this.mensajeTipo = "";
      }
      this.pantalla = pantalla;
      if (pantalla === "venta") {
        this.impresion.enviarDirecto = true;
      }
      if (pantalla === "envios") {
        this.impresion.enviarDirecto = true;
      }
      if (pantalla === "lectura" && anterior !== pantalla) {
        this.sincronizarLecturaConTurno();
      }
      if (pantalla === "recepcion") {
        this.recepcion.mensaje = "";
        this.recepcion.tipoMensaje = "";
      }
      if (pantalla === "entrega") {
        this.cargarListadoEntrega();
      }
      if (pantalla === "fin-envios") {
        this.sincronizarFinEnviosConTurno();
        this.cargarFinEnvios();
      }
      if (pantalla === "cancelar-envios") {
        if (!this.cancelacionEnvios.cajero) {
          this.cancelacionEnvios.cajero = this.contexto.cajero || this.obtenerCajero();
        }
        this.cargarCancelacionEnvios();
      }
      if (pantalla === "cierre-viaje") {
        if (!this.cierreViaje.cargando && !this.cierreViaje.guardando) this.limpiarDetalleCierreViaje();
        this.cargarCierreViajeDetalle();
      }
      if (pantalla === "cierre-caja") {
        this.cargarCierreCajaDetalle();
      }
      if ((pantalla === "venta" || pantalla === "envios") && anterior !== pantalla && !this.cargandoContexto) {
        return this.actualizarTurnosFacturacion();
      }
    },
    focusSiguienteCampoCaja(event) {
      var actual = event && event.target ? event.target : null;
      if (!actual) {
        return;
      }
      var contenedor = actual.closest(".pvt-cash-count");
      if (!contenedor) {
        return;
      }
      var campos = Array.prototype.slice.call(contenedor.querySelectorAll("input, select, textarea"))
        .filter((campo) => !campo.disabled && campo.type !== "hidden" && campo.offsetParent !== null);
      var indice = campos.indexOf(actual);
      if (indice < 0 || indice >= campos.length - 1) {
        actual.blur();
        return;
      }
      var siguiente = campos[indice + 1];
      siguiente.focus();
      if (typeof siguiente.select === "function") {
        siguiente.select();
      }
    },
    configuracionGeneral() {
      if (this.$store && this.$store.getters && this.$store.getters.GetConfiguracionGeneral) {
        return this.$store.getters.GetConfiguracionGeneral || {};
      }
      return {};
    },
    obtenerCajero() {
      var usuario = this.$store && this.$store.getters ? this.$store.getters.GetdatosInfUsu : null;
      if (usuario && usuario.usuario) {
        usuario = usuario.usuario;
      }
      if (usuario && typeof usuario === "object") {
        return usuario.nombre || usuario.username || (typeof usuario.usuario === "string" ? usuario.usuario : "") || this.contexto.cajero;
      }
      return usuario || this.contexto.cajero;
    },
    cargarOpcionesConfiguracionCaja() {
      this.cargandoOpcionesCaja = true;
      Promise.all([
        this.$axios.get(this.$hostname + this.$hName + "/sucursal/findallActivos/", { headers: this.headers() }),
        this.$axios.get(this.$hostname + this.$hName + "/cajas/findAllActivos", { headers: this.headers() }),
      ])
        .then(([sucursales, cajas]) => {
          this.sucursalesDisponibles = Array.isArray(sucursales.data) ? sucursales.data : [];
          this.cajasDisponibles = Array.isArray(cajas.data) ? cajas.data : [];
          this.seleccionarCajaConfiguracion();
        })
        .catch(() => {
          this.mostrarMensaje("No fue posible cargar sucursales y cajas. Revise conexion/API.", "error");
        })
        .finally(() => {
          this.cargandoOpcionesCaja = false;
        });
    },
    cargarOpcionesTurno() {
      var opciones = { headers: this.headers() };
      Promise.all([
        this.$axios.get(this.$hostname + this.$hName + "/vehiculo/findallActivos/", opciones).catch(() => ({ data: [] })),
        this.$axios.get(this.$hostname + this.$hName + "/propietario/findallConductorActivos/", opciones).catch(() => ({ data: [] })),
      ])
        .then(([vehiculos, choferes]) => {
          this.fichasDisponibles = this.opcionesUnicas(Array.isArray(vehiculos.data) ? vehiculos.data : [], this.valorFichaTurno);
          this.choferesDisponibles = this.opcionesUnicas(Array.isArray(choferes.data) ? choferes.data : [], this.valorChoferTurno);
          this.agregarOpcionesDesdeTurnos(this.turnosDisponibles);
        });
    },
    normalizarOpcionTurno(valor) {
      if (valor === null || valor === undefined) {
        return "";
      }
      return String(valor).trim();
    },
    normalizarBusquedaTurno(valor) {
      return this.normalizarOpcionTurno(valor).toUpperCase();
    },
    valorFichaBusqueda(valor) {
      var texto = this.normalizarOpcionTurno(valor);
      return texto.indexOf(" - ") >= 0 ? texto.split(" - ")[0].trim() : texto;
    },
    valoresChoferBusqueda(valor) {
      var texto = this.normalizarOpcionTurno(valor);
      if (!texto) {
        return [];
      }
      var partes = texto.split(" - ").map((parte) => this.normalizarBusquedaTurno(parte)).filter((parte) => parte);
      partes.push(this.normalizarBusquedaTurno(texto));
      return partes.filter((parte, indice, lista) => lista.indexOf(parte) === indice);
    },
    opcionesUnicas(lista, valorFn) {
      var vistos = {};
      return lista.filter((item) => {
        var valor = this.normalizarOpcionTurno(valorFn(item));
        if (!valor || vistos[valor]) {
          return false;
        }
        vistos[valor] = true;
        return true;
      });
    },
    agregarOpcionTurno(lista, item, valorFn) {
      var valor = this.normalizarOpcionTurno(valorFn(item));
      if (!valor) {
        return lista;
      }
      var existe = lista.some((opcion) => this.normalizarOpcionTurno(valorFn(opcion)) === valor);
      if (!existe) {
        lista.push(item);
      }
      return lista;
    },
    agregarOpcionesDesdeTurnos(turnos) {
      if (!Array.isArray(turnos)) {
        return;
      }
      turnos.forEach((turnoDetalle, indice) => {
        if (turnoDetalle.ficha) {
          this.agregarOpcionTurno(this.fichasDisponibles, {
            id: "turno-" + indice,
            ficha: turnoDetalle.ficha,
            descripcion: turnoDetalle.vehiculo && turnoDetalle.vehiculo.descripcion ? turnoDetalle.vehiculo.descripcion : "",
            capacidad: turnoDetalle.capacidad || (turnoDetalle.vehiculo ? turnoDetalle.vehiculo.capacidad : null),
            conductor: turnoDetalle.idchofer || null,
          }, this.valorFichaTurno);
        }
        if (turnoDetalle.idchofer) {
          this.agregarOpcionTurno(this.choferesDisponibles, turnoDetalle.idchofer, this.valorChoferTurno);
        }
        if (turnoDetalle.controlTurno) {
          this.agregarOpcionTurno(this.controlesDisponibles, turnoDetalle.controlTurno, this.valorControlTurno);
        }
      });
    },
    valorFichaTurno(vehiculo) {
      return this.normalizarOpcionTurno(vehiculo && (vehiculo.ficha || vehiculo.descripcion || vehiculo.placa || vehiculo.id));
    },
    textoFichaTurno(vehiculo) {
      var ficha = this.valorFichaTurno(vehiculo);
      var descripcion = this.normalizarOpcionTurno(vehiculo && vehiculo.descripcion);
      return descripcion && descripcion !== ficha ? ficha + " - " + descripcion : ficha;
    },
    existeFichaTurno(ficha) {
      var valor = this.normalizarOpcionTurno(ficha);
      return this.fichasDisponibles.some((vehiculo) => this.valorFichaTurno(vehiculo) === valor);
    },
    valorChoferTurno(chofer) {
      return this.normalizarOpcionTurno(chofer && (chofer.nombre || chofer.descripcion || chofer.cedula || chofer.id));
    },
    textoChoferTurno(chofer) {
      var nombre = this.valorChoferTurno(chofer);
      var cedula = this.normalizarOpcionTurno(chofer && chofer.cedula);
      return cedula && cedula !== nombre ? nombre + " - " + cedula : nombre;
    },
    existeChoferTurno(chofer) {
      var valor = this.normalizarOpcionTurno(chofer);
      return this.choferesDisponibles.some((item) => this.valorChoferTurno(item) === valor);
    },
    valorControlTurno(control) {
      var id = Number(control && control.id);
      return Number.isInteger(id) && id > 0 ? String(id) : "";
    },
    textoControlTurno(control) {
      return this.normalizarOpcionTurno(control && ((control.persona && control.persona.nombre) || control.nombre)) || "Control sin nombre";
    },
    existeControlTurno(control) {
      var valor = this.normalizarOpcionTurno(control);
      return this.controlesDisponibles.some((item) => this.valorControlTurno(item) === valor);
    },
    controlTurnoSeleccionado() {
      var valor = this.normalizarOpcionTurno(this.turno.control);
      if (!valor) return null;
      return this.controlesDisponibles.find((item) => this.valorControlTurno(item) === valor) || null;
    },
    validarControlFacturacion() {
      if (this.controlTurnoSeleccionado()) return true;
      this.mostrarMensaje("Debe seleccionar el Control para facturar.", "error");
      this.$nextTick(() => {
        var campo = this.$refs[this.pantalla === "envios" ? "envioControl" : "ventaControl"];
        if (campo) campo.focus();
      });
      return false;
    },
    nombreControlSeleccionado() {
      var control = this.controlTurnoSeleccionado();
      return control ? this.textoControlTurno(control) : "";
    },
    seleccionarFichaTurno() {
      var ficha = this.fichasDisponibles.filter((vehiculo) => this.valorFichaTurno(vehiculo) === this.normalizarOpcionTurno(this.turno.ficha))[0];
      if (!ficha) {
        return;
      }
      if (ficha.capacidad != null) {
        this.turno.capacidad = Number(ficha.capacidad);
        this.recalcularDisponibles();
      }
      if (ficha.conductor) {
        this.agregarOpcionTurno(this.choferesDisponibles, ficha.conductor, this.valorChoferTurno);
        this.turno.chofer = this.valorChoferTurno(ficha.conductor) || this.turno.chofer;
      }
      this.sincronizarLecturaConTurno();
      this.sincronizarFinEnviosConTurno();
    },
    buscarTurnoActivo(criterios) {
      var numero = this.normalizarBusquedaTurno(criterios.numeroViaje);
      var ficha = this.normalizarBusquedaTurno(this.valorFichaBusqueda(criterios.ficha));
      var choferes = this.valoresChoferBusqueda(criterios.chofer);
      var candidatos = Array.isArray(this.turnosDisponibles) ? this.turnosDisponibles : [];

      if (numero) {
        return candidatos.filter((turnoDetalle) =>
          this.normalizarBusquedaTurno(turnoDetalle.numero_viaje || turnoDetalle.numeroViaje) === numero
        )[0] || null;
      }

      if (ficha) {
        candidatos = candidatos.filter((turnoDetalle) =>
          this.normalizarBusquedaTurno(turnoDetalle.ficha || (turnoDetalle.vehiculo && turnoDetalle.vehiculo.ficha)) === ficha
        );
      }

      if (choferes.length > 0) {
        candidatos = candidatos.filter((turnoDetalle) => {
          var conductor = turnoDetalle.idchofer || {};
          var nombre = this.normalizarBusquedaTurno(conductor.nombre || turnoDetalle.chofer || turnoDetalle.conductor);
          var cedula = this.normalizarBusquedaTurno(conductor.cedula);
          return choferes.indexOf(nombre) >= 0 || choferes.indexOf(cedula) >= 0;
        });
      }

      return candidatos.length > 0 ? candidatos[0] : null;
    },
    resolverTurnoCierreViaje() {
      var numeroVisible = this.normalizarOpcionTurno(this.turno.numeroViaje);
      if (this.turno.id) {
        return true;
      }
      if (numeroVisible) {
        if (/^\d+$/.test(numeroVisible)) {
          this.mostrarMensaje("Debe indicar el numero de viaje completo, por ejemplo I-17082026-2.", "error");
          return false;
        }
        this.turno.id = null;
        return true;
      }
      var turnoEncontrado = this.buscarTurnoActivo({
        numeroViaje: this.turno.numeroViaje,
        ficha: this.turno.ficha,
        chofer: this.turno.chofer,
      });
      if (turnoEncontrado) {
        this.aplicarTurno(turnoEncontrado);
        return true;
      }
      this.cierreViaje.boletos = [];
      this.cierreViaje.resumen = {};
      this.cierreViaje.cierre = null;
      this.cierreViaje.cerrado = false;
      this.mostrarMensaje("No se encontro un viaje activo con los datos indicados.", "error");
      return false;
    },
    nombreSucursalConfiguracion(sucursal) {
      if (!sucursal) {
        return "";
      }
      return sucursal.descripcion || sucursal.nombre || ("Sucursal " + sucursal.codigo);
    },
    nombreCajaConfiguracion(caja) {
      if (!caja) {
        return "";
      }
      var sucursal = caja.sucursal ? this.nombreSucursalConfiguracion(caja.sucursal) : "";
      var nombre = caja.descripcion || caja.nombre || ("Caja " + caja.codigo);
      return sucursal ? nombre + " - " + sucursal : nombre;
    },
    seleccionarSucursalConfiguracion() {
      var cajaActual = this.cajasDisponibles.filter((caja) => Number(caja.codigo || 0) === Number(this.configuracionCaja.cajaId || 0))[0];
      if (cajaActual && cajaActual.sucursal && Number(cajaActual.sucursal.codigo || 0) === Number(this.configuracionCaja.sucursalId || 0)) {
        this.seleccionarCajaConfiguracion();
        return;
      }
      this.configuracionCaja.cajaId = null;
      this.configuracionCaja.cajaNombre = "";
    },
    seleccionarCajaConfiguracion() {
      var caja = this.cajasDisponibles.filter((item) => Number(item.codigo || 0) === Number(this.configuracionCaja.cajaId || 0))[0];
      if (!caja) {
        return;
      }
      this.configuracionCaja.cajaNombre = caja.descripcion || caja.nombre || ("Caja " + caja.codigo);
      if (caja.sucursal && caja.sucursal.codigo) {
        this.configuracionCaja.sucursalId = Number(caja.sucursal.codigo);
      }
    },
    claveConfiguracionCaja() {
      var headers = this.headers();
      var nombre = Object.keys(headers).find((key) => key.toLowerCase() === "x-tenant-id");
      var schema = nombre && String(headers[nombre] || "").trim();
      return schema ? "pvt_configuracion_caja:" + encodeURIComponent(this.$hostname + this.$hName) + ":" + encodeURIComponent(schema) : null;
    },
    cargarConfiguracionCaja() {
      var config = null;
      try {
        var clave = this.claveConfiguracionCaja();
        config = clave ? JSON.parse(localStorage.getItem(clave)) : null;
      } catch (e) {
        config = null;
      }
      if (!config || !config.sucursalId || !config.cajaId) {
        this.limpiarDatosContexto();
        Object.assign(this.contexto, { caja: null, cajaId: null, cajaNombre: "Seleccione caja", sucursalId: null,
          sucursal: "Sin asignar", sucursalDireccion: "", sucursalTelefono: "", sucursalRnc: "", impresoraTickets: "", impresoraTicketsLocal: "", impresoraEtiquetas: "", impresoraEtiquetasEnvio: "0" });
        this.contexto.vistaPreviaPdf = false;
        this.configuracionCaja.vistaPreviaPdf = false;
        this.configuracionCaja.sucursalId = null;
        this.configuracionCaja.cajaId = null;
        this.configuracionCaja.cajaNombre = "";
        this.configuracionCaja.impresoraTickets = "";
        this.configuracionCaja.visible = true;
        return false;
      }
      this.contexto.sucursalId = Number(config.sucursalId);
      this.contexto.sucursal = config.sucursalNombre || ("Sucursal " + config.sucursalId);
      this.contexto.sucursalDireccion = config.sucursalDireccion || "";
      this.contexto.sucursalTelefono = config.sucursalTelefono || "";
      this.contexto.sucursalRnc = config.sucursalRnc || "";
      this.contexto.caja = Number(config.cajaId);
      this.contexto.cajaId = Number(config.cajaId);
      this.contexto.cajaNombre = config.cajaNombre || ("Caja " + config.cajaId);
      this.contexto.impresoraTicketsLocal = config.impresoraTickets || "";
      this.contexto.vistaPreviaPdf = config.vistaPreviaPdf === true;
      this.contexto.impresoraTickets = this.contexto.impresoraTicketsLocal;
      this.configuracionCaja = {
        vistaPreviaPdf: this.contexto.vistaPreviaPdf,
        visible: false,
        sucursalId: Number(config.sucursalId),
        cajaId: Number(config.cajaId),
        cajaNombre: this.contexto.cajaNombre,
        impresoraTickets: this.contexto.impresoraTickets,
      };
      this.validarImpresoraConfiguracion();
      return true;
    },
    guardarConfiguracionCaja() {
      if (this.lectura.leyendo) return;
      var clave = this.claveConfiguracionCaja();
      if (!clave) {
        this.mostrarMensaje("No se identifico la empresa de la sesion. Ingrese nuevamente.", "error");
        return;
      }
      if (!this.configuracionCaja.sucursalId || !this.configuracionCaja.cajaId) {
        this.mostrarMensaje("Debe seleccionar sucursal y caja.", "error");
        return;
      }
      this.seleccionarCajaConfiguracion();
      var sucursal = this.sucursalesDisponibles.filter((item) => Number(item.codigo || 0) === Number(this.configuracionCaja.sucursalId || 0))[0];
      var caja = this.cajasDisponibles.filter((item) => Number(item.codigo || 0) === Number(this.configuracionCaja.cajaId || 0))[0];
      if (!caja || !sucursal || !caja.sucursal || Number(caja.sucursal.codigo) !== Number(sucursal.codigo)) {
        this.mostrarMensaje("Seleccione una caja y sucursal vigentes de esta empresa.", "error");
        return;
      }
      var config = {
        vistaPreviaPdf: this.configuracionCaja.vistaPreviaPdf === true,
        sucursalId: Number(this.configuracionCaja.sucursalId),
        sucursalNombre: sucursal ? this.nombreSucursalConfiguracion(sucursal) : ("Sucursal " + this.configuracionCaja.sucursalId),
        sucursalDireccion: sucursal ? (sucursal.direccion || "") : "",
        sucursalTelefono: sucursal ? (sucursal.telefono || "") : "",
        sucursalRnc: sucursal ? (sucursal.rnc || "") : "",
        cajaId: Number(this.configuracionCaja.cajaId),
        cajaNombre: caja ? (caja.descripcion || caja.nombre || ("Caja " + caja.codigo)) : (this.configuracionCaja.cajaNombre || ("Caja " + this.configuracionCaja.cajaId)),
        impresoraTickets: this.configuracionCaja.impresoraTickets || "",
      };
      localStorage.setItem(clave, JSON.stringify(config));
      if (config.impresoraTickets && !config.vistaPreviaPdf) {
        localStorage.setItem("printerSelect", JSON.stringify({ codigo: 0, nombre: config.impresoraTickets }));
      }
      this.mensaje = "";
      this.mensajeTipo = "";
      this.reimpresionPendiente = null;
      this.reiniciarLectura();
      this.cargarConfiguracionCaja();
      this.rutaSeleccionada = null;
      this.busquedaRuta = "";
      this.rutas = [];
      this.rutasEnvio = [];
      this.turno.control = "";
      this.cargarContexto();
    },

    cambiarConfiguracionCaja() {
      if (this.entrega.guardando || this.entrega.firmaVisible) return;

      if (this.EjecutarPermisoPv == false) {
          this.funcionValidaPermisoPv('AccCambiarCajaTransporte')
          return;
        } 
    },
    continuarCambiarConfiguracionCaja(){
      if (this.lectura.leyendo) return;
      this.configuracionCaja.visible = true;
      this.configuracionCaja.vistaPreviaPdf = this.contexto.vistaPreviaPdf;
      this.configuracionCaja.sucursalId = this.contexto.sucursalId;
      this.configuracionCaja.cajaId = this.contexto.caja;
      this.configuracionCaja.cajaNombre = this.contexto.cajaNombre;
      this.configuracionCaja.impresoraTickets = this.contexto.impresoraTickets || this.impresoraSeleccionada() || "";
      this.cargarOpcionesConfiguracionCaja();
      this.cargarImpresorasLocales();
    },

    async cargarImpresorasLocales() {
      var urls = this.urlImpresoraLocal("/impresora/inicial/listaImpresora");
      for (const url of urls) {
        if (this.configuracionCaja.visible ? this.configuracionCaja.vistaPreviaPdf : this.contexto.vistaPreviaPdf) return;
        try {
          var res = await this.$axios.get(url, { timeout: 5000 });
          var terminal = Array.isArray(res.data) && res.data.length > 0 ? res.data[0] : null;
          this.impresorasLocales = terminal && Array.isArray(terminal.impresoras) ? terminal.impresoras : [];
          this.impresoraDefaultLocal = terminal && terminal.defaulPrinter ? terminal.defaulPrinter : "";
          this.validarImpresoraConfiguracion();
          return;
        } catch (error) {
          // Se intenta con la siguiente URL local.
        }
      }
      this.impresorasLocales = [];
      this.impresoraDefaultLocal = "";
    },
    validarImpresoraConfiguracion() {
      if (this.contexto.vistaPreviaPdf || this.configuracionCaja.vistaPreviaPdf) return;
      if (!this.impresorasLocales.length) {
        return;
      }
      var seleccionada = this.contexto.impresoraTickets || this.configuracionCaja.impresoraTickets || this.impresoraSeleccionada() || "";
      var existe = seleccionada
        ? this.impresorasLocales.filter((impresora) => impresora.nombre === seleccionada)[0]
        : null;
      if (existe) {
        this.configuracionCaja.impresoraTickets = existe.nombre;
        this.contexto.impresoraTickets = existe.nombre;
        localStorage.setItem("printerSelect", JSON.stringify({ codigo: existe.codigo || 0, nombre: existe.nombre }));
        return;
      }
      // El servicio local resuelve la impresora de caja o la predeterminada de Windows.
      if (seleccionada) return;
      var impresoraDefault = this.impresoraDefaultLocal
        ? this.impresorasLocales.filter((impresora) => impresora.nombre === this.impresoraDefaultLocal)[0]
        : null;
      var impresora = impresoraDefault;
      this.configuracionCaja.impresoraTickets = impresora ? impresora.nombre : "";
      this.contexto.impresoraTickets = impresora ? impresora.nombre : "";
      if (impresora) {
        localStorage.setItem("printerSelect", JSON.stringify({ codigo: impresora.codigo || 0, nombre: impresora.nombre }));
      }
    },
    cargarContexto(conservarRuta = false) {
      this.contexto.usaFirmaDigital = false;
      this.limpiarFirmaEntrega();
      this.entrega.peticionDetalle++;
      this.entrega.cargandoDetalle = false;
      this.entrega.envio = null;
      this.firmaConsulta = { visible: false, imagen: "" };
      this.entrega.recargo = null;
      this.politicasImpresion = { boleto: "", envio: "" };
      this.puedeModificarCapacidad = false;
      this.capacidadEdicion.visible = false;
      var solicitud = ++this.solicitudContexto;
      var clave = this.claveConfiguracionCaja();
      if (!this.cargarConfiguracionCaja()) {
        this.cargandoContexto = false;
        this.cargarOpcionesConfiguracionCaja();
        this.cargarOpcionesTurno();
        return;
      }
      this.contexto.cajero = this.obtenerCajero();
      if (!conservarRuta) {
        this.rutaSeleccionada = null;
        this.busquedaRuta = "";
      }
      var params = "?sucursalId=" + encodeURIComponent(this.contexto.sucursalId) + "&cajaId=" + encodeURIComponent(this.contexto.caja);
      this.cargandoContexto = true;
      this.errorContexto = false;
      this.puedeCrearTurno = false;
      var contextoCargado = false;
      return this.$axios.get(this.$hostname + this.$hName + "/transportepv/contexto" + params, { headers: this.headers() })
        .then((res) => {
          if (solicitud !== this.solicitudContexto || clave !== this.claveConfiguracionCaja()) return false;
          var data = res.data || {};
          this.puedeCrearTurno = data.puedeCrearTurno === true;
          var politicas = data.politicasImpresion || {};
          this.politicasImpresion = {
            boleto: typeof politicas.boleto === "string" ? politicas.boleto : "",
            envio: typeof politicas.envio === "string" ? politicas.envio : "",
          };
          this.puedeModificarCapacidad = data.puedeModificarCapacidad === true;
          this.rutas = Array.isArray(data.rutas) ? data.rutas : [];
          if (conservarRuta && this.rutaSeleccionada) {
            this.rutaSeleccionada = this.rutas.find((ruta) => Number(ruta.id) === Number(this.rutaSeleccionada.id)) || null;
          }
          this.rutasEnvio = Array.isArray(data.rutasEnvio) ? data.rutasEnvio : [];
          if (Array.isArray(data.rangosPesoEnvio)) {
            this.rangosPesoEnvio = data.rangosPesoEnvio;
          }
          if (Array.isArray(data.controles)) {
            this.controlesDisponibles = this.opcionesUnicas(data.controles, this.valorControlTurno);
            if (!this.existeControlTurno(this.turno.control)) {
              this.turno.control = "";
            }
          }
          if (data.caja) {
            this.contexto.cajaId = Number(data.caja.codigo || this.contexto.caja);
            this.contexto.caja = this.contexto.cajaId;
            this.contexto.cajaNombre = data.caja.descripcion || this.contexto.cajaNombre;
            this.contexto.facturacionElectronicaActiva = data.facturacionElectronicaActiva === true;
            // La seleccion de esta PC prevalece sobre el nombre configurado en el servidor.
            this.contexto.impresoraTickets = this.contexto.impresoraTicketsLocal || data.caja.impresoraTickets || this.contexto.impresoraTickets || "";
            this.configuracionCaja.impresoraTickets = this.contexto.impresoraTickets;
            this.contexto.impresoraEtiquetas = data.caja.impresoraEtiquetas || "";
            this.contexto.impresoraEtiquetasEnvio = data.caja.impresoraEtiquetasEnvio || "0";
            this.contexto.usaFirmaDigital = data.caja.usaFirmaDigital === true;
            if (data.caja.sucursal) {
              this.contexto.sucursal = data.caja.sucursal.descripcion || this.contexto.sucursal;
              this.contexto.sucursalId = Number(data.caja.sucursal.codigo || this.contexto.sucursalId);
              this.contexto.sucursalDireccion = data.caja.sucursal.direccion || this.contexto.sucursalDireccion || "";
              this.contexto.sucursalTelefono = data.caja.sucursal.telefono || this.contexto.sucursalTelefono || "";
              this.contexto.sucursalRnc = data.caja.sucursal.rnc || this.contexto.sucursalRnc || "";
            }
            if (clave) {
              localStorage.setItem(clave, JSON.stringify({ cajaId: this.contexto.cajaId, cajaNombre: this.contexto.cajaNombre,
                sucursalId: this.contexto.sucursalId, sucursalNombre: this.contexto.sucursal,
                sucursalDireccion: this.contexto.sucursalDireccion, sucursalTelefono: this.contexto.sucursalTelefono,
                sucursalRnc: this.contexto.sucursalRnc, impresoraTickets: this.contexto.impresoraTicketsLocal, vistaPreviaPdf: this.contexto.vistaPreviaPdf }));
            }
          } else {
            this.contexto.facturacionElectronicaActiva = false;
            this.contexto.impresoraTickets = "";
            this.contexto.impresoraEtiquetas = "";
            this.contexto.impresoraEtiquetasEnvio = "0";
          }
          this.diaTurnos = this.fechaActualTurnos();
          this.turnosDisponibles = this.filtrarTurnosDelDia(data.turnos);
          this.agregarOpcionesDesdeTurnos(this.turnosDisponibles);
          this.seleccionarTurnoFacturacion(this.sentidoFacturacion());
          if (this.pantalla === "cierre-viaje" && !this.turno.id && !this.turno.numeroViaje && this.turnoFacturacion) {
            this.turno = Object.assign({}, this.turnoFacturacion);
          }
          if (!Array.isArray(data.rangosPesoEnvio)) {
            this.cargarConfiguracionPesoEnvio();
          }
          contextoCargado = true;
          return true;
        })
        .catch(() => {
          if (solicitud !== this.solicitudContexto || clave !== this.claveConfiguracionCaja()) return false;
          this.limpiarDatosContexto();
          this.mostrarMensaje("No se pudo cargar la caja ni sus rutas. Revise conexion/API y seleccione una caja de esta empresa.", "error");
          return false;
        })
        .finally(() => {
          if (solicitud !== this.solicitudContexto || clave !== this.claveConfiguracionCaja()) return;
          this.cargandoContexto = false;
          this.cargarOpcionesConfiguracionCaja();
          this.cargarOpcionesTurno();
          if (this.pantalla === "cierre-viaje") {
            if (contextoCargado) {
              return this.cargarCierreViajeDetalle();
            }
            this.mostrarMensaje("No se pudieron cargar los datos del viaje. Revise conexion/API.", "error");
          }
        });
    },
    async crearNuevoTurno() {
      if (!this.puedeCrearTurno || this.creandoTurno || this.guardando || this.cargandoContexto || this.actualizandoTurnos || this.errorContexto) {
        return;
      }
      var ruta = this.pantalla === "envios" ? this.destinoEnvioSeleccionado : this.rutaSeleccionada;
      if (!ruta && this.pantalla === "envios" && this.envio.paquetes.length) {
        ruta = this.rutasEnvio.find((item) => Number(item.id) === Number(this.envio.paquetes[0].destinoId));
      }
      if (!ruta) {
        var sentido = this.sentidoFacturacion();
        var rutas = this.pantalla === "envios" ? this.rutasEnvio : this.rutas;
        // Crear desde el contexto no debe seleccionar una ruta de venta ni agregar cargos.
        ruta = rutas.find((item) => sentido != null && item.esSentidoIda === sentido &&
          Number.isInteger(Number(item.id)) && Number(item.id) > 0);
      }
      if (!ruta || !Number.isInteger(Number(ruta.id)) || Number(ruta.id) <= 0) {
        this.mostrarMensaje("Seleccione una ruta para determinar el sentido del nuevo turno.", "warning");
        return;
      }
      this.creandoTurno = true;
      var creado = false;
      try {
        var res = await this.$axios.post(this.$hostname + this.$hName + "/transportepv/turnos/generico", {}, {
          headers: this.headers(), params: { rutaId: Number(ruta.id) },
        });
        var data = res.data || {};
        if (data.estatus !== "ok") {
          this.mostrarMensaje(data.mensaje || "No se pudo crear el turno.", "error");
          return;
        }
        creado = true;
        var cargado = await this.cargarContexto(true);
        this.mostrarMensaje(cargado ? "Turno creado." : "Turno creado. Recargue la pantalla para actualizar los datos; no vuelva a crearlo.", cargado ? "ok" : "warning");
      } catch (error) {
        var respuestaHttp = error && error.response;
        var respuesta = respuestaHttp && respuestaHttp.data;
        var motivo = typeof respuesta === "string" ? respuesta.trim() : respuesta && (respuesta.mensaje || respuesta.message);
        var rechazado = respuestaHttp && [400, 403, 409, 422].includes(Number(respuestaHttp.status));
        this.mostrarMensaje(creado
          ? "Turno creado. Recargue la pantalla para actualizar los datos; no vuelva a crearlo."
          : motivo || "No se pudo confirmar la creacion del turno. Consulte los turnos antes de volver a intentarlo.", !creado && rechazado ? "error" : "warning");
      } finally {
        this.creandoTurno = false;
      }
    },
    cargarConfiguracionPesoEnvio() {
      if (!this.contexto.sucursalId) {
        this.rangosPesoEnvio = [];
        return;
      }
      this.$axios.get(this.$hostname + this.$hName + "/configuracionpesoenvio/sucursal/" + this.contexto.sucursalId, { headers: this.headers() })
        .then((res) => {
          this.rangosPesoEnvio = Array.isArray(res.data) ? res.data : [];
          this.actualizarPrecioEnvioCalculado();
        })
        .catch(() => {
          this.rangosPesoEnvio = [];
        });
    },
    limpiarDatosContexto() {
      this.politicasImpresion = { boleto: "", envio: "" };
      this.reiniciarLectura();
      this.rutas = [];
      this.rutasEnvio = [];
      this.rangosPesoEnvio = [];
      this.rutaSeleccionada = null;
      this.destinoEnvioSeleccionado = null;
      this.turnosDisponibles = [];
      this.controlesDisponibles = [];
      this.turno = this.turnoVacio();
      this.turnoFacturacion = null;
      this.puedeCrearTurno = false;
      this.contexto.facturacionElectronicaActiva = false;
      this.errorContexto = true;
    },
    numeroViajeTurno(turnoDetalle) {
      var numeroApi = turnoDetalle.numero_viaje || turnoDetalle.numeroViaje;
      if (numeroApi) {
        return numeroApi;
      }
      var numeroTurno = turnoDetalle.numero_turno || turnoDetalle.numeroTurno;
      var fecha = this.fechaNumeroViajeTurno(turnoDetalle);
      if (!numeroTurno || !fecha) {
        return "";
      }
      return (this.esSentidoIdaTurno(turnoDetalle) ? "I-" : "V-") + fecha + "-" + numeroTurno;
    },
    fechaNumeroViajeTurno(turnoDetalle) {
      var fecha = turnoDetalle.fecha || (turnoDetalle.turno && turnoDetalle.turno.fecha) || this.contexto.fecha;
      if (!fecha) {
        return "";
      }
      if (Array.isArray(fecha) && fecha.length >= 3) {
        return this.rellenarDosDigitos(fecha[2]) + this.rellenarDosDigitos(fecha[1]) + fecha[0];
      }
      var texto = String(fecha).trim();
      var fechaIso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (fechaIso) {
        return fechaIso[3] + fechaIso[2] + fechaIso[1];
      }
      var fechaLocal = texto.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (fechaLocal) {
        return this.rellenarDosDigitos(fechaLocal[1]) + this.rellenarDosDigitos(fechaLocal[2]) + fechaLocal[3];
      }
      return "";
    },
    rellenarDosDigitos(valor) {
      return String(valor || "").padStart(2, "0");
    },
    esSentidoIdaTurno(turnoDetalle) {
      if (typeof turnoDetalle.es_sentido_ida === "boolean") {
        return turnoDetalle.es_sentido_ida;
      }
      if (typeof turnoDetalle.esSentidoIda === "boolean") {
        return turnoDetalle.esSentidoIda;
      }
      if (turnoDetalle.turno && typeof turnoDetalle.turno.esSentidoIda === "boolean") {
        return turnoDetalle.turno.esSentidoIda;
      }
      return true;
    },
    aplicarTurno(turnoDetalle, conservarSeleccion = false) {
      var numeroViaje = this.numeroViajeTurno(turnoDetalle);
      var cambiaTurno = Number(this.turno.id) !== Number(turnoDetalle.id) || this.turno.numeroViaje !== numeroViaje;
      var seleccion = conservarSeleccion && !cambiaTurno ? {
        ficha: this.turno.ficha, chofer: this.turno.chofer, control: this.turno.control, capacidad: this.turno.capacidad,
      } : null;
      // Each trip refresh owns its counters; an older async operation must not mutate them.
      this.turno = Object.assign(this.turnoVacio(), { control: this.turno.control });
      this.turno.id = turnoDetalle.id;
      this.turno.numeroViaje = numeroViaje;
      this.turno.ficha = turnoDetalle.ficha || (turnoDetalle.vehiculo && turnoDetalle.vehiculo.ficha) || "";
      this.turno.hora = turnoDetalle.hora2 || turnoDetalle.hora || "";
      var control = (turnoDetalle.controlTurno && this.valorControlTurno(turnoDetalle.controlTurno)) ||
        this.normalizarOpcionTurno(turnoDetalle.control);
      if (this.existeControlTurno(control)) {
        this.turno.control = control;
      }
      this.turno.capacidad = Number(turnoDetalle.capacidad != null ? turnoDetalle.capacidad : ((turnoDetalle.vehiculo && turnoDetalle.vehiculo.capacidad) || 0));
      this.turno.vendidos = Number(turnoDetalle.vendidos || 0);
      this.turno.seQuedan = Number(turnoDetalle.seQuedan || 0);
      this.turno.pendientes = Number(turnoDetalle.pendientes || 0);
      if (turnoDetalle.idchofer && turnoDetalle.idchofer.nombre) {
        this.turno.chofer = turnoDetalle.idchofer.nombre;
      } else {
        this.turno.chofer = turnoDetalle.chofer || turnoDetalle.conductor || "";
      }
      // Refresh counts without replacing the operator's selection for the same open trip.
      if (seleccion) {
        if (seleccion.ficha !== this.turno.ficha) this.turno.capacidad = seleccion.capacidad;
        this.turno.ficha = seleccion.ficha;
        this.turno.chofer = seleccion.chofer;
        this.turno.control = seleccion.control;
      }
      this.recalcularDisponibles();
      this.sincronizarLecturaConTurno();
      this.sincronizarFinEnviosConTurno();
    },
    turnoVacio() {
      return { id: null, numeroViaje: "", ficha: "", chofer: "", control: "", hora: "", capacidad: 0, vendidos: 0, seQuedan: 0, pendientes: 0, disponibles: 0 };
    },
    recalcularDisponibles() {
      this.turno.disponibles = Math.max(0, Math.min(Number(this.turno.capacidad || 0),
        Number(this.turno.capacidad || 0) - Number(this.turno.vendidos || 0) + Number(this.turno.seQuedan || 0) - Number(this.turno.pendientes || 0)));
    },
    validarCupos(cantidad) {
      if (!Number.isInteger(cantidad) || cantidad < 1) {
        this.mostrarMensaje("La cantidad de asientos debe ser un entero mayor que cero.", "error");
        return false;
      }
      if (cantidad > Number(this.turno.disponibles || 0)) {
        this.mostrarMensaje("Solo quedan " + this.turno.disponibles + " asientos disponibles para este viaje. Se solicitaron " + cantidad + ".", "error");
        return false;
      }
      return true;
    },
    abrirCapacidad() {
      
       if (this.EjecutarPermisoPv == false) {
          this.funcionValidaPermisoPv('AccCambiarCapacidadTransporte')
          return;
        } 
    },

    continuarAbrirCapacidad(){
    if (!this.puedeModificarCapacidad || this.guardando || this.actualizandoTurnos || !this.turno.id) return;
      this.capacidadEdicion = { visible: true, valor: this.turno.capacidad, guardando: false, error: "" };
      this.$nextTick(() => { if (this.$refs.capacidadAsientos) this.$refs.capacidadAsientos.focus(); });
    },

    async guardarCapacidad() {
      var edicion = this.capacidadEdicion;
      if (!this.puedeModificarCapacidad || edicion.guardando) return;
      if (!Number.isInteger(edicion.valor) || edicion.valor < 0) {
        edicion.error = "La capacidad debe ser un entero mayor o igual a cero.";
        return;
      }
      edicion.guardando = true;
      var turno = this.turno;
      var turnoId = turno.id;
      var numeroViaje = turno.numeroViaje;
      var ficha = turno.ficha;
      var caja = this.contexto.cajaId || this.contexto.caja;
      var sucursal = this.contexto.sucursalId;
      var clave = this.claveConfiguracionCaja();
      var vigente = () => turno === this.turno && turnoId === this.turno.id && numeroViaje === this.turno.numeroViaje &&
        ficha === this.turno.ficha && caja === (this.contexto.cajaId || this.contexto.caja) &&
        sucursal === this.contexto.sucursalId && clave === this.claveConfiguracionCaja();
      try {
        var respuesta = await this.$axios.post(this.$hostname + this.$hName + "/transportepv/turnos/capacidad", {
          cajaId: caja, turnoDetalleId: turnoId,
          numeroViaje: numeroViaje, ficha: ficha, capacidad: edicion.valor,
        }, { headers: this.headers() });
        if (!vigente()) { edicion.visible = false; return; }
        var datos = respuesta.data || {};
        if (datos.estatus !== "ok") { edicion.error = datos.mensaje || "No se pudo modificar la capacidad."; return; }
        Object.assign(this.turno, { capacidad: datos.capacidad, vendidos: datos.vendidos, seQuedan: datos.seQuedan, pendientes: datos.pendientes });
        this.fichasDisponibles.filter((f) => this.valorFichaTurno(f) === this.normalizarOpcionTurno(this.turno.ficha))
          .forEach((f) => { f.capacidad = datos.capacidad; });
        this.recalcularDisponibles();
        edicion.visible = false;
      } catch (error) {
        if (!vigente()) { edicion.visible = false; return; }
        edicion.error = error.response && typeof error.response.data === "string" ? error.response.data : "No se pudo modificar la capacidad. Revise la conexion.";
      } finally { edicion.guardando = false; }
    },
    sentidoRutasFacturacion() {
      var ruta = this.pantalla === "envios" ? this.destinoEnvioSeleccionado : this.rutaSeleccionada;
      if (!ruta && this.pantalla === "envios" && this.envio.paquetes.length) {
        ruta = this.rutasEnvio.find((item) => Number(item.id) === Number(this.envio.paquetes[0].destinoId));
      }
      if (ruta && typeof ruta.esSentidoIda === "boolean") return ruta.esSentidoIda;
      var rutas = this.pantalla === "envios" ? this.rutasEnvio : this.pantalla === "venta" ? this.rutas : [];
      // Antes de elegir ruta, una sucursal con un unico sentido ya determina los viajes visibles.
      if (rutas.length && typeof rutas[0].esSentidoIda === "boolean" &&
          rutas.every((item) => item.esSentidoIda === rutas[0].esSentidoIda)) return rutas[0].esSentidoIda;
      return null;
    },
    sentidoFacturacion() {
      var sentido = this.sentidoRutasFacturacion();
      if (sentido != null) return sentido;
      var actual = this.turnoFacturacion || this.turno;
      if (/^[IV]-/.test(actual.numeroViaje)) return actual.numeroViaje.charAt(0) === "I";
      return null;
    },
    filtrarTurnosPorRuta(turnos, dia = this.fechaActualTurnos()) {
      var sentido = this.sentidoRutasFacturacion();
      return this.filtrarTurnosDelDia(turnos, dia)
        .filter((item) => sentido == null || this.esSentidoIdaTurno(item) === sentido);
    },
    fechaActualTurnos() {
      var fecha = new Date();
      return fecha.getFullYear() + "-" + this.rellenarDosDigitos(fecha.getMonth() + 1) + "-" + this.rellenarDosDigitos(fecha.getDate());
    },
    filtrarTurnosDelDia(turnos, dia = this.fechaActualTurnos()) {
      var fechaHoy = dia.split("-").reverse().join("");
      return (Array.isArray(turnos) ? turnos : []).filter((item) => {
        if (!item || item.cerrado === true || item.turnoCerrado === true || item.turnoActivo === false || item.borrado === true) return false;
        if (item.turno && (item.turno.activo === false || item.turno.borrado === true)) return false;
        // El numero de viaje conserva la fecha de negocio sin conversiones de zona horaria.
        var numero = item.numero_viaje || item.numeroViaje;
        if (numero) {
          var partes = String(numero).match(/^[IV]-(\d{8})-\d+$/);
          return !!partes && partes[1] === fechaHoy;
        }
        var fecha = (item.turno && item.turno.fecha) || item.fecha;
        return !!fecha && this.fechaNumeroViajeTurno({ fecha: fecha }) === fechaHoy;
      });
    },
    comprobarDiaTurnos() {
      var hoy = this.fechaActualTurnos();
      if (hoy === this.diaTurnos || this.guardando || this.cargandoContexto || this.creandoTurno) return;
      this.diaTurnos = hoy;
      this.turnosDisponibles = this.filtrarTurnosDelDia(this.turnosDisponibles);
      this.seleccionarTurnoFacturacion(this.sentidoFacturacion(), true);
      if (this.contexto.caja && !this.actualizandoTurnos) return this.actualizarTurnosFacturacion();
    },
    seleccionarViajeFacturacion(id, selector = null) {
      if (this.guardando || this.creandoTurno || this.cargandoContexto) return;
      var elegido = this.filtrarTurnosDelDia(this.turnosDisponibles).find((item) => Number(item.id) === Number(id));
      if (!elegido) {
        this.turno = this.turnoVacio();
        this.mostrarMensaje("El viaje seleccionado ya no esta disponible. Seleccione un turno abierto.", "error");
        return;
      }
      if (!this.validarSentidoTurno(elegido)) {
        if (selector) selector.value = String(this.turno.id || "");
        return;
      }
      this.aplicarTurno(elegido);
    },
    seleccionarTurnoFacturacion(sentido, conservarActual = false) {
      var abiertos = this.filtrarTurnosDelDia(this.turnosDisponibles);
      var candidatos = abiertos.filter((item) => sentido == null || this.esSentidoIdaTurno(item) === sentido);
      var actual = this.turnoFacturacion || this.turno;
      // Conservar la seleccion solo si sigue abierta y pertenece al sentido de la ruta.
      var siguiente = (conservarActual && candidatos.find((item) => Number(item.id) === Number(actual.id))) || candidatos[0];
      // Historical closure/reprint keeps its own displayed trip while sales advance.
      var visible = this.pantalla === "cierre-viaje" ? this.turno : null;
      if (visible) this.turno = this.turnoFacturacion || this.turnoVacio();
      if (siguiente) this.aplicarTurno(siguiente, conservarActual);
      else {
        this.turno = this.turnoVacio();
        if (sentido != null && (this.pantalla === "venta" || this.pantalla === "envios")) {
          this.mostrarMensaje("No hay turnos abiertos para hoy en este sentido. Cree o seleccione un nuevo turno antes de facturar.", "warning");
        }
      }
      if (visible) {
        this.turnoFacturacion = this.turno;
        this.turno = visible;
      }
      return siguiente;
    },
    async actualizarTurnosFacturacion(verificarCierre = false) {
      if (this.guardando && !verificarCierre) return false;
      var solicitud = ++this.solicitudTurnos;
      var caja = Number(this.contexto.caja);
      var sucursal = Number(this.contexto.sucursalId);
      var clave = this.claveConfiguracionCaja();
      var vigente = () => solicitud === this.solicitudTurnos && caja === Number(this.contexto.caja) &&
        sucursal === Number(this.contexto.sucursalId) && clave === this.claveConfiguracionCaja();
      var sentido = this.sentidoFacturacion();
      this.diaTurnos = this.fechaActualTurnos();
      this.actualizandoTurnos = true;
      try {
        var res = await this.$axios.get(this.$hostname + this.$hName + "/transportepv/turnos/facturacion", {
          headers: this.headers(), params: { cajaId: caja }, timeout: 30000,
        });
        if (!vigente()) return false;
        this.diaTurnos = this.fechaActualTurnos();
        this.turnosDisponibles = this.filtrarTurnosDelDia(res.data);
        var siguiente = this.seleccionarTurnoFacturacion(this.sentidoFacturacion(), true);
        if (!siguiente && (this.pantalla === "venta" || this.pantalla === "envios")) {
          this.mostrarMensaje("No hay turnos abiertos para hoy en este sentido. Cree o seleccione un nuevo turno antes de facturar.", "warning");
        }
        return true;
      } catch (error) {
        if (!vigente()) return false;
        this.turnosDisponibles = [];
        this.seleccionarTurnoFacturacion(sentido);
        this.mostrarMensaje("No se pudo verificar el siguiente turno. Actualice antes de facturar.", "error");
        return false;
      } finally {
        if (solicitud === this.solicitudTurnos) this.actualizandoTurnos = false;
      }
    },
    validarSentidoTurno(turnoDetalle) {
      var sentido = this.sentidoRutasFacturacion();
      var rutas = [this.rutaSeleccionada];
      if (this.pantalla === "envios") {
        rutas = this.envio.paquetes.length ? this.envio.paquetes.map((paquete) =>
          this.rutasEnvio.find((ruta) => Number(ruta.id) === Number(paquete.destinoId)) ||
          (this.destinoEnvioSeleccionado && Number(this.destinoEnvioSeleccionado.id) === Number(paquete.destinoId)
            ? this.destinoEnvioSeleccionado : null)) : [this.destinoEnvioSeleccionado];
      }
      if ((sentido != null && sentido !== this.esSentidoIdaTurno(turnoDetalle)) ||
        rutas.some((ruta) => ruta && typeof ruta.esSentidoIda === "boolean" &&
        ruta.esSentidoIda !== this.esSentidoIdaTurno(turnoDetalle))) {
        this.mostrarMensaje("La ruta y el turno deben tener el mismo sentido (ida o vuelta). Revise tambien los destinos de los paquetes.", "error");
        return false;
      }
      return true;
    },
    validarTurnoVenta() {
      if (this.errorContexto) {
        this.mostrarMensaje("La caja no esta cargada. Revise conexion/API antes de facturar.", "error");
        return false;
      }
      if (this.cargandoContexto || this.actualizandoTurnos) {
        this.mostrarMensaje("Espere mientras se verifica el turno abierto.", "warning");
        return false;
      }
      var disponible = this.filtrarTurnosDelDia(this.turnosDisponibles).find((item) => Number(item.id) === Number(this.turno.id) &&
        this.numeroViajeTurno(item) === this.turno.numeroViaje && item.cerrado !== true);
      if (this.pantalla === "cierre-viaje" || !this.turno.id || !disponible) {
        this.mostrarMensaje("Debe seleccionar un turno abierto del dia para facturar. No se permite facturar en un turno cerrado o de otra fecha.", "error");
        return false;
      }
      return this.validarSentidoTurno(disponible);
    },
    nombreRuta(ruta) {
      if (ruta.sucursalSalida && ruta.sucursalLlegada) {
        return (ruta.sucursalSalida.descripcion || ruta.sucursalSalida.nombre || "Origen") + " -> " +
          (ruta.sucursalLlegada.descripcion || ruta.sucursalLlegada.nombre || "Destino");
      }
      return ruta.descripcion || ruta.nombre || ("Ruta " + ruta.id);
    },
    partesNombreRuta(textoRuta) {
      var partes = String(textoRuta || "")
        .split("->")
        .map((valor) => String(valor || "").trim())
        .filter((valor) => valor !== "");
      return {
        origen: partes.length ? partes[0] : "",
        destino: partes.length ? partes[partes.length - 1] : String(textoRuta || "").trim(),
      };
    },
    precioRuta(ruta) {
      return Number(ruta.precioPasaje || ruta.precio || 0);
    },
    precioRutaEnvio(ruta) {
      if (!ruta) {
        return 0;
      }
      return Number(ruta.precioLibra || 0);
    },
    seleccionarRuta(ruta) {
      if (ruta && typeof ruta.esSentidoIda === "boolean") this.seleccionarTurnoFacturacion(ruta.esSentidoIda, true);
      var mismaRuta = this.rutaSeleccionada && ruta && Number(this.rutaSeleccionada.id) === Number(ruta.id);
      this.rutaSeleccionada = ruta;
      if (mismaRuta) {
        if (!this.turno.id) return;
        var cantidad = Number(this.venta.cantidad || 0) + 1;
        if (!this.validarCupos(cantidad)) return;
        this.venta.cantidad = cantidad;
      } else {
        this.venta.cantidad = 1;
      }
      this.enfocarCampoBoleto("boletoCantidad");
    },
    enfocarCampoBoleto(refName) {
      var campo = this.$refs && this.$refs[refName];
      if (this.pantalla !== "venta" || this.guardando || !campo) return;
      this.$nextTick(() => {
        if (this.pantalla !== "venta" || this.guardando || this.$refs[refName] !== campo) return;
        campo.focus();
        if (typeof campo.select === "function") campo.select();
      });
    },
    confirmarCantidadBoletos(event) {
      if (this.pantalla !== "venta" || this.guardando || (event && event.repeat)) return;
      var cantidad = Number(this.venta.cantidad);
      var errorCantidad = "La cantidad de boletos debe ser un entero mayor que cero.";
      if (!Number.isInteger(cantidad) || cantidad < 1) {
        this.mensaje = errorCantidad;
        this.mensajeTipo = "error";
        this.enfocarCampoBoleto("boletoCantidad");
        return;
      }
      if (this.mensaje === errorCantidad) {
        this.mensaje = "";
        this.mensajeTipo = "";
      }
      if (!this.validarCupos(cantidad)) return;
      this.enfocarCampoBoleto("boletoEfectivo");
    },
    confirmarEfectivoBoletos(event) {
      if (this.pantalla !== "venta" || this.guardando || (event && event.repeat)) return;
      this.autocompletarFormaPago("efectivo", event);
    },
    moneda(valor) {
      return "RD$ " + Number(valor || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    nuevaVenta() {
      return {
        cantidad: 1,
        numeroMaleta: 0,
        nombre: "Cliente contado",
        telefono: "",
        descuento: 0,
        recargo: 0,
        motivoRecargo: "",
        valorRecargoUnitario: 0,
        cantidadVecesRecargo: 1,
      };
    },
    nuevoComprobante() {
      return {
        tipo: "consumidor",
        rnc: "",
        nombre: "",
        direccion: "",
      };
    },
    identificacionFiscalNormalizada() {
      return String(this.comprobante.rnc || "").replace(/[\s-]/g, "");
    },
    cancelarBusquedaFiscal() {
      if (this.consultaFiscal.temporizador !== null) clearTimeout(this.consultaFiscal.temporizador);
      this.consultaFiscal.temporizador = null;
      this.consultaFiscal.solicitud++;
      this.consultaFiscal.cargando = false;
      this.consultaFiscal.enCurso = "";
      this.consultaFiscal.mensaje = "";
      this.consultaFiscal.tipo = "";
    },
    programarBusquedaFiscal() {
      this.cancelarBusquedaFiscal();
      var rnc = this.identificacionFiscalNormalizada();
      if (this.consultaFiscal.consultada !== rnc) {
        this.consultaFiscal.consultada = "";
        this.consultaFiscal.identificacionValida = null;
      }
      if (this.consultaFiscal.rncDatos && this.consultaFiscal.rncDatos !== rnc) {
        this.comprobante.nombre = "";
        this.comprobante.direccion = "";
        this.consultaFiscal.rncDatos = "";
      }
      if (this.comprobante.tipo !== "fiscal" || !/^\d{9}$|^\d{11}$/.test(rnc)) return;
      this.consultaFiscal.temporizador = setTimeout(() => {
        this.consultaFiscal.temporizador = null;
        this.buscarDatosFiscales();
      }, 400);
    },
    buscarDatosFiscales() {
      if (this.consultaFiscal.temporizador !== null) clearTimeout(this.consultaFiscal.temporizador);
      this.consultaFiscal.temporizador = null;
      var rnc = this.identificacionFiscalNormalizada();
      if (this.guardando || this.comprobante.tipo !== "fiscal" || !/^\d{9}$|^\d{11}$/.test(rnc)) return Promise.resolve();
      if (this.consultaFiscal.cargando && this.consultaFiscal.enCurso === rnc) return this._busquedaFiscalPromesa;
      if (this.consultaFiscal.consultada === rnc) return Promise.resolve();
      var solicitud = ++this.consultaFiscal.solicitud;
      var comprobante = this.comprobante;
      var nombreAnterior = comprobante.nombre;
      this.consultaFiscal.rncDatos = rnc;
      this.consultaFiscal.cargando = true;
      this.consultaFiscal.identificacionValida = null;
      this.consultaFiscal.enCurso = rnc;
      this.consultaFiscal.mensaje = "Buscando datos fiscales...";
      this.consultaFiscal.tipo = "";
      var vigente = () => solicitud === this.consultaFiscal.solicitud && this.comprobante === comprobante
        && this.comprobante.tipo === "fiscal" && rnc === this.identificacionFiscalNormalizada() && !this.guardando;
      this._busquedaFiscalPromesa = this.$axios.get(this.$hostname + this.$hName + "/padron-dgii/buscar", {
        headers: this.headers(), params: { identificacion: rnc }, timeout: 15000,
      }).then((res) => {
        if (!vigente()) return;
        this.consultaFiscal.consultada = rnc;
        this.consultaFiscal.identificacionValida = res.data && typeof res.data.identificacionValida === "boolean" ? res.data.identificacionValida : null;
        var persona = res.data && res.data.encontrado ? res.data.contribuyente : null;
        if (!persona) {
          this.consultaFiscal.mensaje = this.consultaFiscal.identificacionValida === false
            ? "El RNC/cedula no es valido. Revise los digitos."
            : "RNC/cedula no encontrado en el padron. Cliente pendiente de registro.";
          this.consultaFiscal.tipo = this.consultaFiscal.identificacionValida === false ? "error" : "aviso";
          return;
        }
        var nombre = String(persona.razon_social || "").trim();
        var direccion = String(persona.direccion || "").trim();
        if (nombre && (comprobante.nombre === nombreAnterior || !String(comprobante.nombre || "").trim())) {
          comprobante.nombre = nombre;
        }
        if (direccion && !String(comprobante.direccion || "").trim()) {
          comprobante.direccion = direccion;
        }
        this.consultaFiscal.mensaje = !nombre ? "El registro no tiene razon social." : persona.estado === false
          ? "Contribuyente no activo en el padron." : "Datos fiscales encontrados.";
        this.consultaFiscal.tipo = !nombre || persona.estado === false ? "aviso" : "";
      }).catch(() => {
        if (!vigente()) return;
        this.consultaFiscal.consultada = "";
        this.consultaFiscal.mensaje = "No se pudo consultar el padron DGII.";
        this.consultaFiscal.tipo = "error";
      }).finally(() => {
        if (solicitud === this.consultaFiscal.solicitud) {
          this.consultaFiscal.cargando = false;
          this.consultaFiscal.enCurso = "";
        }
      });
      return this._busquedaFiscalPromesa;
    },
    limpiarConsultaFiscal() {
      this.cancelarBusquedaFiscal();
      this.consultaFiscal.consultada = "";
      this.consultaFiscal.rncDatos = "";
      this.consultaFiscal.identificacionValida = null;
    },
    nuevosPagos() {
      return {
        efectivo: 0,
        credito: 0,
        tarjeta: 0,
        pagoDestino: 0,
        cheque: 0,
        valorCortesia: 0,
        notadecredito: 0,
        transferencia: 0,
      };
    },
    nuevoEnvio() {
      return {
        remitente: {
          cedula: "",
          nombre: "",
          telefono: "",
          direccion: "",
        },
        destinatario: {
          nombre: "",
          telefono: "",
          documento: "",
          direccion: "",
        },
        tipo: "P",
        calculo: "digitado",
        cantidadAsientos: 1,
        fragil: false,
        perecedero: false,
        fragilesGlobal: false,
        busquedaDestino: "",
        descripcion: "",
        cantidadLbPies: 1,
        valorDeclarado: 0,
        precio: 0,
        paquetes: [],
        entradaConfirmada: false,
        indiceEdicion: -1,
        borradorAnterior: null,
        copiasEtiqueta: 0,
        copiasFactura: 1,
      };
    },
    limpiarVenta() {
      this.limpiarCortesia();
      this.limpiarConsultaFiscal();
      this.rutaSeleccionada = null;
      this.busquedaRuta = "";
      this.venta = this.nuevaVenta();
      this.pagos = this.nuevosPagos();
      this.comprobante = this.nuevoComprobante();
      this.editarFiscal = false;
      this.limpiarDescuento();
    },
    limpiarEnvio() {
      this.limpiarCortesia();
      this.limpiarConsultaFiscal();
      this.envio = this.nuevoEnvio();
      this.destinoEnvioSeleccionado = null;
      this.ultimaBusquedaPersonaEnvio = "";
      this.venta = this.nuevaVenta();
      this.pagos = this.nuevosPagos();
      this.comprobante = this.nuevoComprobante();
      this.editarFiscal = false;
      this.limpiarDescuento();
    },
    seleccionarDestinoEnvio(ruta) {
      this.prepararPaqueteEnvio();
      if (!this.editandoPaqueteEnvio && ruta && typeof ruta.esSentidoIda === "boolean") this.seleccionarTurnoFacturacion(ruta.esSentidoIda, true);
      this.destinoEnvioSeleccionado = ruta;
      this.envio.busquedaDestino = this.nombreRuta(ruta);
      if (Number(this.envio.precio || 0) <= 0 || this.envio.calculo !== "digitado") {
        this.envio.precio = this.calcularPrecioEnvio();
      }
      this.enfocarCampoEnvioPaquete("envioPrecio");
    },
    enfocarCampoEnvioPaquete(refName) {
      this.$nextTick(() => {
        var control = this.$refs[refName];
        if (Array.isArray(control)) {
          control = control[0];
        }
        if (control && typeof control.focus === "function") {
          control.focus();
          if (typeof control.select === "function") {
            control.select();
          }
        }
      });
    },
    normalizarPersonaEnvio(valor) {
      return String(valor || "").replace(/[^0-9]/g, "").trim();
    },
    payloadBusquedaPersonaEnvio(tipo, campo) {
      var persona = tipo === "destinatario" ? this.envio.destinatario : this.envio.remitente;
      var payload = {
        tipo: tipo,
        cedula: "",
        telefono: "",
      };
      if (campo === "telefono") {
        payload.telefono = this.normalizarPersonaEnvio(persona.telefono);
      } else if (campo === "documento") {
        payload.cedula = this.normalizarPersonaEnvio(persona.documento);
      } else {
        payload.cedula = this.normalizarPersonaEnvio(persona.cedula);
      }
      return payload;
    },
    aplicarPersonaEnvio(tipo, persona) {
      if (!persona) {
        return;
      }
      var nombre = persona.nombre || "";
      var telefono = persona.telefono || "";
      var cedula = persona.cedula || persona.codigo_cedula || persona.codigoCedula || "";
      var direccion = persona.direccion || "";
      if (tipo === "destinatario") {
        if (nombre) {
          this.envio.destinatario.nombre = nombre;
        }
        if (telefono) {
          this.envio.destinatario.telefono = telefono;
        }
        if (cedula) {
          this.envio.destinatario.documento = cedula;
        }
        if (direccion) {
          this.envio.destinatario.direccion = direccion;
        }
        return;
      }
      if (nombre) {
        this.envio.remitente.nombre = nombre;
      }
      if (telefono) {
        this.envio.remitente.telefono = telefono;
      }
      if (cedula) {
        this.envio.remitente.cedula = cedula;
      }
      if (direccion) {
        this.envio.remitente.direccion = direccion;
      }
    },
    async buscarPersonaEnvio(tipo, campo, siguienteRef) {
      var payload = this.payloadBusquedaPersonaEnvio(tipo, campo);
      if (!payload.cedula && !payload.telefono) {
        if (siguienteRef) {
          this.enfocarCampoEnvioPaquete(siguienteRef);
        }
        return;
      }
      var claveBusqueda = tipo + "|" + campo + "|" + payload.cedula + "|" + payload.telefono;
      if (claveBusqueda === this.ultimaBusquedaPersonaEnvio) {
        if (siguienteRef) {
          this.enfocarCampoEnvioPaquete(siguienteRef);
        }
        return;
      }
      this.ultimaBusquedaPersonaEnvio = claveBusqueda;
      try {
        var respuesta = await this.$axios.post(this.$hostname + this.$hName + "/transportepv/envios/persona", payload, { headers: this.headers() });
        this.aplicarPersonaEnvio(tipo, respuesta.data ? respuesta.data.persona : null);
      } catch (e) {
        // La busqueda es de apoyo al llenado; si falla no debe interrumpir la facturacion.
      }
      if (siguienteRef) {
        this.enfocarCampoEnvioPaquete(siguienteRef);
      }
    },
    seleccionarTipoEnvio(tipo) {
      this.prepararPaqueteEnvio();
      this.envio.tipo = tipo;
      if (tipo !== "P" && ["peso", "asiento"].includes(this.envio.calculo)) {
        this.envio.calculo = "digitado";
      }
      this.actualizarPrecioEnvioCalculado();
    },
    seleccionarCalculoEnvio(calculo) {
      if (["peso", "asiento"].includes(calculo) && this.envio.tipo !== "P") {
        this.mostrarMensaje("El calculo por peso solo aplica para envios de paquetes.", "error");
        return;
      }
      this.envio.calculo = calculo;
      this.prepararPaqueteEnvio();
      this.actualizarPrecioEnvioCalculado();
    },
    actualizarPrecioEnvioCalculado() {
      if (this.envio.calculo !== "digitado") {
        this.envio.precio = this.calcularPrecioEnvio();
      }
    },
    precioPesoEnvio() {
      var libras = Number(this.envio.cantidadLbPies || 0);
      if (libras <= 0) {
        return 0;
      }
      var rango = this.rangosPesoEnvio.find((item) => {
        return libras >= Number(item.libraInicial || 0) && libras <= Number(item.libraFinal || 0);
      });
      return rango ? Math.round((Number(rango.precio || 0) * libras) * 100) / 100 : 0;
    },
    calcularPrecioEnvio() {
      var precioBase = this.destinoEnvioSeleccionado ? this.precioRuta(this.destinoEnvioSeleccionado) : 0;
      if (this.envio.calculo === "asiento") {
        return Math.round(Number(this.destinoEnvioSeleccionado && this.destinoEnvioSeleccionado.precioAdicionalAsientoEnvio || 0) * Number(this.envio.cantidadAsientos || 0) * 100) / 100;
      }
      if (this.envio.calculo === "peso") {
        return this.precioPesoEnvio();
      }
      if (this.envio.calculo === "valor") {
        return Math.round(Math.max(precioBase, Number(this.envio.valorDeclarado || 0) * 0.01) * 100) / 100;
      }
      return Number(this.envio.precio || precioBase || 0);
    },
    prepararPaqueteEnvio() {
      if (!this.guardando) this.envio.entradaConfirmada = false;
    },
    enfocarNuevoPaqueteEnvio() {
      this.enfocarCampoEnvioPaquete(this.envio.calculo === "peso" ? "envioCantidad" :
        this.envio.calculo === "valor" ? "envioValorDeclarado" : "envioPrecio");
    },
    agregarPaqueteEnvio(evento) {
      if (this.guardando || this.envio.entradaConfirmada || (evento && evento.repeat)) return;
      if (!this.destinoEnvioSeleccionado) {
        this.mostrarMensaje("Debe seleccionar el destino del envio.", "error");
        return;
      }
      var precio = this.editandoPaqueteEnvio && this.envio.calculo === "digitado"
        ? Number(this.envio.precio) : Number(this.calcularPrecioEnvio() || 0);
      if (!this.esImportePositivo(precio)) {
        if (this.envio.calculo === "peso") {
          this.mostrarMensaje("No existe configuracion de peso para esas libras en la sucursal actual.", "error");
        } else {
          this.mostrarMensaje("Debe indicar el precio del envio.", "error");
        }
        return;
      }
      if (this.envio.calculo === "peso" && Number(this.envio.cantidadLbPies || 0) <= 0) {
        this.mostrarMensaje("Debe indicar el peso del paquete.", "error");
        return;
      }
      var cantidad = Number(this.envio.cantidadLbPies);
      var valorDeclarado = Number(this.envio.valorDeclarado);
      if (!Number.isFinite(cantidad) || cantidad < 0 || !Number.isFinite(valorDeclarado) || valorDeclarado < 0) {
        this.mostrarMensaje("La cantidad y el valor declarado deben ser numeros mayores o iguales a 0.", "error");
        return;
      }
      var anterior = this.editandoPaqueteEnvio ? this.envio.paquetes[this.envio.indiceEdicion] : null;
      var asientos = this.envio.calculo === "asiento" ? Number(this.envio.cantidadAsientos) : 0;
      if (this.envio.calculo === "asiento") {
        if (!Number.isInteger(asientos) || asientos < 1 || !this.esImportePositivo(this.precioRuta(this.destinoEnvioSeleccionado))) {
          this.mostrarMensaje("Indique asientos enteros mayores que cero y una ruta con precio de boleto.", "error");
          return;
        }
        if (!this.validarCupos(this.asientosEnvio - Number(anterior && anterior.cantidadAsientos || 0) + asientos)) return;
      }
      if (this.editandoPaqueteEnvio && !anterior) {
        this.mostrarMensaje("El paquete seleccionado ya no esta disponible. Cancele la edicion.", "error");
        return;
      }
      var descripcion = this.envio.descripcion || (this.envio.tipo === "D" ? "Envio de dinero" : "Paquete");
      var impuestos = anterior ? Number(anterior.impuestos || 0) : 0;
      var paquete = Object.assign({}, anterior, {
        descripcion: descripcion,
        destinoId: this.destinoEnvioSeleccionado.id,
        destinoNombre: this.nombreRuta(this.destinoEnvioSeleccionado),
        cantidadLbPies: cantidad,
        valorDeclarado: valorDeclarado,
        precio: precio,
        impuestos: impuestos,
        importe: precio + impuestos,
        tipo: this.envio.tipo,
        calculo: this.envio.calculo,
        cantidadAsientos: asientos,
        precioBoleto: asientos ? this.precioRuta(this.destinoEnvioSeleccionado) : 0,
        fragil: Boolean(this.envio.fragil || this.envio.fragilesGlobal),
        perecedero: anterior ? anterior.perecedero : Boolean(this.envio.perecedero),
      });
      if (this.editandoPaqueteEnvio) {
        var ruta = this.destinoEnvioSeleccionado;
        this.envio.paquetes.splice(this.envio.indiceEdicion, 1, paquete);
        this.cancelarEdicionPaqueteEnvio();
        this.envio.entradaConfirmada = true;
        if (Number(ruta.id) !== Number(anterior.destinoId) && typeof ruta.esSentidoIda === "boolean") {
          this.seleccionarTurnoFacturacion(ruta.esSentidoIda, true);
        }
        this.mostrarMensaje("Paquete actualizado.", "ok");
        this.enfocarNuevoPaqueteEnvio();
        return;
      }
      // El borrador solo se consume una vez, aunque haya clics o Enter pendientes.
      this.envio.entradaConfirmada = true;
      this.envio.paquetes.push(paquete);
      this.envio.descripcion = "";
      this.envio.valorDeclarado = 0;
      this.envio.cantidadLbPies = 1;
      this.envio.cantidadAsientos = 1;
      this.envio.precio = 0;
      this.enfocarNuevoPaqueteEnvio();
    },
    editarPaqueteEnvio(index) {
      if (this.guardando || this.editandoPaqueteEnvio || !Number.isInteger(index) || !this.envio.paquetes[index]) return;
      var paquete = this.envio.paquetes[index];
      var campos = ["descripcion", "cantidadLbPies", "cantidadAsientos", "valorDeclarado", "precio", "tipo", "calculo", "fragil", "busquedaDestino", "entradaConfirmada"];
      var borrador = {};
      campos.forEach((campo) => { borrador[campo] = this.envio[campo]; });
      this.envio.borradorAnterior = { campos: borrador, destino: this.destinoEnvioSeleccionado };
      this.prepararPaqueteEnvio();
      this.envio.indiceEdicion = index;
      ["descripcion", "cantidadLbPies", "cantidadAsientos", "valorDeclarado", "precio", "tipo", "calculo", "fragil"].forEach((campo) => {
        this.envio[campo] = paquete[campo];
      });
      this.destinoEnvioSeleccionado = this.rutasEnvio.find((ruta) => Number(ruta.id) === Number(paquete.destinoId)) ||
        (this.destinoEnvioSeleccionado && Number(this.destinoEnvioSeleccionado.id) === Number(paquete.destinoId) ? this.destinoEnvioSeleccionado : null);
      this.envio.busquedaDestino = this.destinoEnvioSeleccionado ? this.nombreRuta(this.destinoEnvioSeleccionado) : "";
      if (!this.destinoEnvioSeleccionado) this.mostrarMensaje("La ruta del paquete ya no esta disponible. Seleccione otra ruta.", "error");
      this.enfocarCampoEnvioPaquete("envioDescripcion");
    },
    cancelarEdicionPaqueteEnvio() {
      if (this.guardando || !this.editandoPaqueteEnvio) return;
      var borrador = this.envio.borradorAnterior;
      if (borrador) {
        Object.assign(this.envio, borrador.campos);
        this.destinoEnvioSeleccionado = borrador.destino;
      }
      this.envio.indiceEdicion = -1;
      this.envio.borradorAnterior = null;
    },
    removerPaqueteEnvio(index) {
      if (this.guardando || this.editandoPaqueteEnvio || !Number.isInteger(index) || index < 0) return;
      this.envio.paquetes.splice(index, 1);
    },
    removerUltimoPaqueteEnvio() {
      this.removerPaqueteEnvio(this.envio.paquetes.length - 1);
    },
    abrirRecargo() {
      if (this.pantalla === "recargo") return;
      this.recargoOrigen = this.pantalla === "entrega" ? "entrega" : "venta";
      if (this.recargoOrigen === "entrega" && (!this.entrega.envio || this.entrega.envio.is_recogido)) {
        this.entrega.mensaje = "Seleccione un envio pendiente de entrega antes de agregar el recargo.";
        this.entrega.tipoMensaje = "warning";
        return;
      }
      this.recargo = {
        id: null,
        motivo: this.venta.motivoRecargo || "",
        valor: this.venta.valorRecargoUnitario || 0,
        cantidad: this.venta.cantidadVecesRecargo || 1,
        busqueda: "",
        catalogo: [],
        precioEditable: true,
      };
      if (this.recargoOrigen === "entrega") {
        const seleccionado = this.entrega.recargo;
        Object.assign(this.recargo, { id: seleccionado && seleccionado.id, motivo: seleccionado ? seleccionado.descripcion : "",
          valor: seleccionado ? seleccionado.precio : 0, cantidad: 1, precioEditable: false });
      }
      this.pantalla = "recargo";
      this.cargarRecargos();
    },
    cargarRecargos() {
      const peticion = ++this.peticionRecargo;
      this.$axios.post(this.$hostname + this.$hName + "/transportepv/recargos", {
        busqueda: this.recargo.busqueda,
        aplicacion: this.recargoOrigen,
      }, { headers: this.headers() })
        .then((response) => {
          if (peticion !== this.peticionRecargo) return;
          var data = response.data || {};
          this.recargo.catalogo = data.recargos || [];
          this.recargo.precioEditable = this.recargoOrigen !== "entrega" && data.precioEditable !== false;
        })
        .catch(() => {
          this.mostrarMensaje("No fue posible cargar los recargos. Revise conexion/API.", "error");
        });
    },
    seleccionarRecargo(item) {
      this.recargo.id = item.id;
      this.recargo.motivo = item.descripcion || "";
      this.recargo.valor = Number(item.precio || 0);
    },
    aplicarRecargo() {
      if (this.recargoOrigen === "entrega") {
        const item = this.recargo.catalogo.find(r => r.id === this.recargo.id);
        if (!item || !(Number(item.precio) > 0) || !this.entrega.envio || this.entrega.envio.is_recogido) {
          this.mostrarMensaje("Seleccione un recargo de entrega activo con precio mayor que cero.", "error"); return;
        }
        const anterior = this.totalCobrarEntrega;
        this.entrega.recargo = { id: item.id, descripcion: item.descripcion, precio: Number(item.precio) };
        if (Number(this.pagos.efectivo || 0) === anterior && this.totalPagadoEntrega === anterior) this.pagos.efectivo = this.totalCobrarEntrega;
        this.limpiarFirmaEntrega();
        this.pantalla = "entrega";
        return;
      }
      if (!this.recargo.motivo || Number(this.recargo.valor || 0) <= 0) {
        this.mostrarMensaje("Debe indicar el motivo y valor del recargo.", "error");
        return;
      }
      this.venta.motivoRecargo = this.recargo.motivo;
      this.venta.valorRecargoUnitario = Number(this.recargo.valor || 0);
      this.venta.cantidadVecesRecargo = Number(this.recargo.cantidad || 1);
      this.recalcularRecargoAplicado();
      this.pantalla = "venta";
    },
    quitarRecargoEntrega() {
      const anterior = this.totalCobrarEntrega;
      this.entrega.recargo = null;
      if (Number(this.pagos.efectivo || 0) === anterior && this.totalPagadoEntrega === anterior) this.pagos.efectivo = this.totalCobrarEntrega;
      this.limpiarFirmaEntrega();
    },
    aplicarDescuento() {
      var tipo = this.descuento.tipo || "identificacion";
      var valor = tipo === "pin" ? this.descuento.pin : this.descuento.identificacion;
      if (!String(valor || "").trim()) {
        this.mostrarMensaje(tipo === "pin" ? "Debe indicar el PIN." : "Debe indicar la identificacion.", "error");
        return;
      }
      this.descuento.cargando = true;
      this.$axios.post(this.$hostname + this.$hName + "/transportepv/descuento/verificar", {
        tipo: tipo,
        identificacion: this.descuento.identificacion,
        pin: this.descuento.pin,
        caja: this.contexto.caja,
        usuario: this.contexto.cajero,
      }, { headers: this.headers() })
        .then((response) => {
          var data = response.data || {};
          if (data.estatus !== "ok") {
            this.limpiarDescuento(false);
            this.mostrarMensaje(data.mensaje || "Descuento no disponible.", "error");
            return;
          }
          var porcentaje = Number(data.porcentaje || 0);
          this.descuento.porcentaje = porcentaje;
          this.descuento.referencia = data.descuento || null;
          this.venta.descuento = Math.round((this.subtotal * (porcentaje / 100)) * 100) / 100;
          this.mostrarMensaje("Descuento aplicado correctamente.", "ok");
          this.pantalla = "venta";
        })
        .catch(() => {
          this.mostrarMensaje("No fue posible verificar el descuento. Revise conexion/API.", "error");
        })
        .finally(() => {
          this.descuento.cargando = false;
        });
    },
    recalcularDescuentoAplicado() {
      if (Number(this.descuento.porcentaje || 0) > 0) {
        this.venta.descuento = Math.round((this.subtotal * (Number(this.descuento.porcentaje || 0) / 100)) * 100) / 100;
      }
    },
    recalcularRecargoAplicado() {
      if (Number(this.venta.valorRecargoUnitario || 0) > 0) {
        this.venta.recargo = Math.round(Number(this.venta.valorRecargoUnitario || 0) * Number(this.venta.cantidad || 1) * Number(this.venta.cantidadVecesRecargo || 1) * 100) / 100;
      }
    },
    limpiarDescuento(limpiarCampos) {
      this.venta.descuento = 0;
      this.descuento.porcentaje = 0;
      this.descuento.referencia = null;
      if (limpiarCampos !== false) {
        this.descuento.identificacion = "";
        this.descuento.pin = "";
      }
    },
    limpiarResultadosLectura() {
      this.lectura.sesion++;
      this.lectura.claveSesion = this.claveSesionLectura;
      this.lectura.ultimo = {};
      this.lectura.abordadosAhora = [];
      this.lectura.yaAbordados = [];
      if (this.pantalla === "lectura") {
        this.mensaje = "";
        this.mensajeTipo = "";
      }
    },
    reiniciarLectura() {
      this.lectura.viaje = "";
      this.lectura.ficha = "";
      this.lectura.chofer = "";
      this.lectura.ticket = "";
      this.limpiarResultadosLectura();
    },
    sincronizarLecturaConTurno() {
      if (this.lectura.leyendo) return;
      this.lectura.viaje = this.turno.numeroViaje || "";
      this.lectura.ficha = this.turno.ficha || "";
      this.lectura.chofer = this.turno.chofer || "";
      if (this.lectura.claveSesion !== this.claveSesionLectura) this.limpiarResultadosLectura();
    },
    recibirPaquete() {
      if (this.recepcion.cargando) return;
      var noEnvio = String(this.recepcion.noEnvio || "").trim().toUpperCase();
      if (!noEnvio) {
        this.recepcion.estado = "error";
        this.recepcion.tipoMensaje = "error";
        this.recepcion.mensaje = "Debe especificar el numero de envio.";
        this.recepcion.envio = null;
        return;
      }
      if (!this.contexto.sucursalId) {
        this.recepcion.estado = "error";
        this.recepcion.tipoMensaje = "error";
        this.recepcion.mensaje = "Debe seleccionar la sucursal que recibe.";
        this.recepcion.envio = null;
        return;
      }
      this.recepcion.cargando = true;
      this.recepcion.mensaje = "";
      this.recepcion.tipoMensaje = "";
      return this.$axios.post(this.$hostname + this.$hName + "/transportepv/envios/recepcion", {
        noEnvio: noEnvio,
        sucursalId: Number(this.contexto.sucursalId || 0),
        usuario: this.contexto.cajero || this.obtenerCajero(),
      }, { headers: this.headers() })
        .then((res) => {
          var data = res.data || {};
          var estado = data.estado || data.estatus || "";
          var envio = data.envio || null;
          var mensaje = data.mensaje || "Recepcion procesada.";
          if (estado === "sucursal_incorrecta" && envio && envio.sucursal_destino) {
            mensaje = "Este paquete debe recibirse en " + envio.sucursal_destino + ".";
          }
          this.recepcion.estado = estado;
          this.recepcion.mensaje = mensaje;
          this.recepcion.envio = envio;
          this.recepcion.tipoMensaje = estado === "recibido" || estado === "ya_recibido" ? "ok" : "error";
          if (estado === "recibido") {
            this.recepcion.noEnvio = "";
          }
        })
        .catch(() => {
          this.recepcion.estado = "error";
          this.recepcion.tipoMensaje = "error";
          this.recepcion.mensaje = "No se pudo recibir el paquete. Revise conexion/API.";
          this.recepcion.envio = null;
        })
        .finally(() => {
          this.recepcion.cargando = false;
          if (this.recepcion.estado === "recibido") {
            this.$nextTick(() => {
              if (this.$refs.recepcionNoEnvio) this.$refs.recepcionNoEnvio.focus();
            });
          }
        });
    },
    entregaPayloadFiltros() {
      return {
        noEnvio: String(this.entrega.filtros.noEnvio || "").trim().toUpperCase(),
        fechaDesde: this.entrega.filtros.fechaDesde,
        fechaHasta: this.entrega.filtros.fechaHasta,
        nombre: this.entrega.filtros.nombre,
        telefono: this.entrega.filtros.telefono,
        sucursalId: Number(this.contexto.sucursalId || 0),
      };
    },
    cargarListadoEntrega(conservarMensaje = false) {
      if (!this.contexto.sucursalId) {
        this.entrega.mensaje = "Debe seleccionar una sucursal.";
        this.entrega.tipoMensaje = "error";
        return;
      }
      this.entrega.cargando = true;
      if (conservarMensaje !== true) {
        this.entrega.mensaje = "";
        this.entrega.tipoMensaje = "";
      }
      this.$axios.post(this.$hostname + this.$hName + "/transportepv/envios/entrega/listado", this.entregaPayloadFiltros(), { headers: this.headers() })
        .then((res) => {
          var data = res.data || {};
          if (data.estatus !== "ok") {
            this.entrega.mensaje = data.mensaje || "No se pudo cargar el listado de entrega.";
            this.entrega.tipoMensaje = "error";
            return;
          }
          this.entrega.listado = Array.isArray(data.envios) ? data.envios : [];
          if (this.entrega.listado.length === 0) {
            this.entrega.envio = null;
          }
        })
        .catch(() => {
          this.entrega.mensaje = "No se pudo cargar el listado de entrega. Revise conexion/API.";
          this.entrega.tipoMensaje = "error";
        })
        .finally(() => {
          this.entrega.cargando = false;
        });
    },
    seleccionarEntrega(item) {
      if (!item || !item.no_envio || this.entrega.guardando || this.entrega.firmaVisible) {
        return;
      }
      var peticion = ++this.entrega.peticionDetalle;
      this.entrega.cargandoDetalle = true;
      this.entrega.envio = null;
      this.entrega.recargo = null;
      this.limpiarFirmaEntrega();
      this.entrega.mensaje = "";
      this.entrega.tipoMensaje = "";
      this.entrega.cedulaRequerida = false;
      this.$axios.post(this.$hostname + this.$hName + "/transportepv/envios/entrega/detalle", {
        noEnvio: item.no_envio,
      }, { headers: this.headers() })
        .then((res) => {
          if (peticion !== this.entrega.peticionDetalle) return;
          var data = res.data || {};
          if (data.estatus !== "ok") {
            this.entrega.mensaje = data.mensaje || "No se pudo cargar el detalle del envio.";
            this.entrega.tipoMensaje = "error";
            return;
          }
          this.entrega.envio = data.envio || null;
          this.entrega.cedulaEntrega = this.entrega.envio && this.entrega.envio.cedula_entrega ? this.entrega.envio.cedula_entrega : "";
          this.pagos = this.nuevosPagos();
          this.pagos.pagoDestino = this.pagoDestinoEntrega;
          if (this.pagoDestinoEntrega > 0) {
            this.pagos.efectivo = this.pagoDestinoEntrega;
          }
        })
        .catch(() => {
          if (peticion !== this.entrega.peticionDetalle) return;
          this.entrega.mensaje = "No se pudo cargar el detalle del envio. Revise conexion/API.";
          this.entrega.tipoMensaje = "error";
        }).finally(() => { if (peticion === this.entrega.peticionDetalle) this.entrega.cargandoDetalle = false; });
    },
    claveFirmaEntrega() {
      return JSON.stringify([this.entrega.envio && this.entrega.envio.no_envio, this.contexto.caja,
        this.contexto.sucursalId, String(this.entrega.cedulaEntrega || "").trim(), this.entrega.recargo]);
    },
    limpiarFirmaEntrega() {
      this.entrega.firmaVisible = false;
      this.entrega.fotoFirma = "";
      this.entrega.firmaContexto = "";
    },
    confirmarFirmaEntrega(imagen) {
      if (!this.entrega.firmaVisible || this.entrega.firmaContexto !== this.claveFirmaEntrega()) {
        this.limpiarFirmaEntrega();
        return;
      }
      this.entrega.fotoFirma = imagen;
      this.entrega.firmaVisible = false;
      return this.entregarPaquete();
    },
    entregaPayload() {
      return {
        recargoEntregaId: this.entrega.recargo ? this.entrega.recargo.id : null,
        recargoEntregaPrecio: this.entrega.recargo ? this.entrega.recargo.precio : 0,
        noEnvio: this.entrega.envio ? this.entrega.envio.no_envio : "",
        cedulaEntrega: this.entrega.cedulaEntrega,
        fotoFirma: this.entrega.firmaContexto === this.claveFirmaEntrega() ? this.entrega.fotoFirma : "",
        usuario: this.contexto.cajero || this.obtenerCajero(),
        caja: Number(this.contexto.caja || this.contexto.cajaId || 0),
        sucursalId: Number(this.contexto.sucursalId || 0),
        efectivo: Number(this.pagos.efectivo || 0),
        cheque: Number(this.pagos.cheque || 0),
        tarjeta: Number(this.pagos.tarjeta || 0),
        transferencia: Number(this.pagos.transferencia || 0),
        credito: Number(this.pagos.credito || 0),
        notadecredito: Number(this.pagos.notadecredito || 0),
      };
    },
    limpiarAdvertenciaCedulaEntrega() {
      if (this.entrega.cedulaRequerida && String(this.entrega.cedulaEntrega || "").trim()) {
        this.entrega.cedulaRequerida = false;
        this.entrega.mensaje = "";
        this.entrega.tipoMensaje = "";
      }
    },
    async entregarPaquete() {
      if (this.entrega.guardando || this.entrega.cargandoDetalle || this.entrega.firmaVisible) return;
      if (this.cargandoContexto || this.errorContexto) {
        this.entrega.mensaje = "Debe cargar la configuracion de la caja antes de entregar.";
        this.entrega.tipoMensaje = "error";
        return;
      }
      if (!this.entrega.envio) {
        this.entrega.mensaje = "Debe seleccionar el paquete a entregar.";
        this.entrega.tipoMensaje = "error";
        return;
      }
      if (!String(this.entrega.cedulaEntrega || "").trim()) {
        this.entrega.cedulaRequerida = true;
        this.entrega.mensaje = "Debe digitar la cédula del destinatario para entregar e imprimir el paquete.";
        this.entrega.tipoMensaje = "warning";
        this.$nextTick(() => {
          var campo = this.$refs.cedulaEntrega;
          if (campo) {
            campo.scrollIntoView({ block: "center", behavior: "smooth" });
            campo.focus({ preventScroll: true });
          }
        });
        return;
      }
      this.limpiarAdvertenciaCedulaEntrega();
      if (this.entrega.recargo && (Number(this.pagos.credito || 0) !== 0 || Number(this.pagos.notadecredito || 0) !== 0)) {
        this.entrega.mensaje = "Para cobrar el recargo utilice efectivo, tarjeta, cheque o transferencia.";
        this.entrega.tipoMensaje = "error";
        return;
      }
      if (this.totalPagadoEntrega < this.totalCobrarEntrega) {
        this.entrega.mensaje = "Debe completar el pago en destino y el recargo antes de entregar.";
        this.entrega.tipoMensaje = "error";
        return;
      }
      if (this.entrega.envio.is_recogido) {
        this.entrega.mensaje = "Este paquete ya fue entregado. Use R.R Entrega para reimprimir el recibo.";
        this.entrega.tipoMensaje = "warning";
        return;
      }
      if (this.contexto.usaFirmaDigital && (!this.entrega.fotoFirma || this.entrega.firmaContexto !== this.claveFirmaEntrega())) {
        this.limpiarFirmaEntrega();
        this.entrega.mensaje = "";
        this.entrega.firmaContexto = this.claveFirmaEntrega();
        this.entrega.firmaVisible = true;
        return;
      }
      this.entrega.guardando = true;
      try {
        var res = await this.$axios.post(this.$hostname + this.$hName + "/transportepv/envios/entrega", this.entregaPayload(), { headers: this.headers() });
        var data = res.data || {};
        if (data.estatus !== "ok") {
          if (data.estatus === "firma_requerida" || data.estatus === "firma_invalida") {
            this.contexto.usaFirmaDigital = true;
            this.limpiarFirmaEntrega();
            this.entrega.firmaContexto = this.claveFirmaEntrega();
            this.entrega.firmaVisible = true;
          }
          if (data.estatus === "ya_entregado" && data.envio) this.entrega.envio = data.envio;
          this.entrega.mensaje = data.mensaje || "No se pudo entregar el paquete.";
          this.entrega.tipoMensaje = "error";
          return;
        }
        this.entrega.envio = data.envio || this.entrega.envio;
        try {
          await this.imprimirEntregaPaquete(data);
          this.entrega.mensaje = data.mensaje || "Paquete entregado correctamente.";
          this.entrega.tipoMensaje = "ok";
        } catch (errorImpresion) {
          this.entrega.mensaje = "Paquete entregado y guardado. No se confirmo la impresion; revise la cola antes de reimprimir desde R.R Entrega.";
          this.entrega.tipoMensaje = "warning";
        }
        this.limpiarFirmaEntrega();
        this.entrega.cedulaEntrega = "";
        this.entrega.envio = null;
        this.entrega.recargo = null;
        this.pagos = this.nuevosPagos();
        this.cargarListadoEntrega(true);
      } catch (e) {
        this.entrega.mensaje = "No se pudo confirmar la entrega. Consulte el estado del envio antes de reintentar; no vuelva a cobrar.";
        this.entrega.tipoMensaje = "error";
      } finally {
        this.entrega.guardando = false;
      }
    },
    sincronizarFinEnviosConTurno() {
      this.finEnvios.numeroViaje = this.turno.numeroViaje || this.finEnvios.numeroViaje;
      this.finEnvios.ficha = this.turno.ficha || this.finEnvios.ficha;
      this.finEnvios.chofer = this.turno.chofer || this.finEnvios.chofer;
    },
    finEnviosPayload() {
      return {
        numeroViaje: String(this.finEnvios.numeroViaje || "").trim(),
        sucursalId: Number(this.contexto.sucursalId || 0),
      };
    },
    cargarFinEnvios() {
      if (this.finEnvios.cargando) return Promise.resolve(false);
      if (!String(this.finEnvios.numeroViaje || "").trim()) {
        this.finEnvios.mensaje = "Debe especificar el viaje.";
        this.finEnvios.tipoMensaje = "error";
        return Promise.resolve(false);
      }
      if (!this.contexto.sucursalId) {
        this.finEnvios.mensaje = "Debe seleccionar una sucursal.";
        this.finEnvios.tipoMensaje = "error";
        return Promise.resolve(false);
      }
      this.finEnvios.cargando = true;
      this.finEnvios.envios = [];
      this.finEnvios.mensaje = "";
      this.finEnvios.tipoMensaje = "";
      var consulta = this.finEnviosPayload();
      return this.$axios.post(this.$hostname + this.$hName + "/transportepv/envios/fin/datos-viaje", consulta, { headers: this.headers() })
        .then((res) => {
          if (JSON.stringify(consulta) !== JSON.stringify(this.finEnviosPayload())) {
            this.finEnvios.mensaje = "El viaje o la sucursal cambio. Consulte nuevamente antes de generar el reporte.";
            this.finEnvios.tipoMensaje = "error";
            return false;
          }
          var data = res.data || {};
          if (data.estatus !== "ok") {
            this.finEnvios.mensaje = data.mensaje || "No se pudieron cargar los envios del viaje.";
            this.finEnvios.tipoMensaje = "error";
            return false;
          }
          this.finEnvios.envios = Array.isArray(data.envios) ? data.envios : [];
          this.finEnvios.mensaje = data.mensaje || "Envios cargados.";
          this.finEnvios.tipoMensaje = this.finEnvios.envios.length ? "ok" : "error";
          return this.finEnvios.envios.length > 0;
        })
        .catch(() => {
          this.finEnvios.mensaje = "No se pudieron cargar los envios del viaje. Revise conexion/API.";
          this.finEnvios.tipoMensaje = "error";
          return false;
        })
        .finally(() => {
          this.finEnvios.cargando = false;
        });
    },
    async imprimirFinEnvios(formato) {
      if (this.finEnvios.imprimiendo || this.finEnvios.cargando) return;
      if (!["paquetesEntregadoAChofer", "EnviosEntregadosEnDestino"].includes(formato)) {
        this.finEnvios.mensaje = "Formato de fin de envios no valido.";
        this.finEnvios.tipoMensaje = "error";
        return;
      }
      this.finEnvios.imprimiendo = true;
      try {
        if (!await this.cargarFinEnvios()) return;
        var payload = {
          accion: "preview",
          enviarDirecto: false,
          formato: formato,
          envios: this.finEnvios.envios.map((envioFin) => this.finEnvioImpresion(envioFin)),
        };
        await this.postImpresoraLocal("/impresora/imprimir", this.prepararOperacionImpresion(payload, "fin-envios-transporte"));
        this.finEnvios.mensaje = "Vista previa abierta en el programa de impresora.";
        this.finEnvios.tipoMensaje = "ok";
      } catch (e) {
        this.finEnvios.mensaje = this.esTiempoEsperaImpresion(e)
          ? "No se recibio confirmacion del reporte. Revise la vista previa o la cola antes de volver a generarlo."
          : "No se pudo generar el reporte de fin de envios. Revise el programa de impresora.";
        this.finEnvios.tipoMensaje = "error";
      } finally {
        this.finEnvios.imprimiendo = false;
      }
    },
    finEnvioImpresion(envioFin) {
      return {
        no_viaje: envioFin.no_viaje || this.finEnvios.numeroViaje || "",
        no_envio: envioFin.no_envio || "",
        valor_declarado: Number(envioFin.valor_declarado || 0),
        descripcion: envioFin.descripcion || "",
        propietario: envioFin.propietario || "",
        conductor: envioFin.conductor || this.finEnvios.chofer || "",
        fecha: envioFin.fecha || this.fechaTrabajo,
        ficha: envioFin.ficha || this.finEnvios.ficha || "",
        destino: envioFin.destino || "",
        empresa: envioFin.empresa || "",
        direccionEmpresa: envioFin.direccionEmpresa || envioFin.direccionempresa || "",
        rncEmpresa: envioFin.rncEmpresa || envioFin.rncempresa || "",
        telefonoEmpresa: envioFin.telefonoEmpresa || envioFin.telefonoempresa || "",
        logo: envioFin.logo || "",
      };
    },
    seleccionarFiltroCancelacion(opcion) {
      this.cancelacionEnvios.opcionFiltrado = opcion;
      this.cargarCancelacionEnvios();
    },
    limpiarFiltroCancelacion() {
      this.cancelacionEnvios.noEnvio = "";
      this.cancelacionEnvios.cajero = "";
      this.cancelacionEnvios.opcionFiltrado = 1;
      this.cancelacionEnvios.envio = null;
      this.cancelacionEnvios.motivo = "";
      this.cargarCancelacionEnvios();
    },
    cancelacionPayloadFiltros() {
      return {
        noEnvio: String(this.cancelacionEnvios.noEnvio || "").trim().toUpperCase(),
        fechaDesde: this.cancelacionEnvios.fechaDesde,
        fechaHasta: this.cancelacionEnvios.fechaHasta,
        cajero: this.cancelacionEnvios.cajero,
        opcionFiltrado: Number(this.cancelacionEnvios.opcionFiltrado || 1),
      };
    },
    cargarCancelacionEnvios(conservarMensaje = false) {
      if (this.cancelacionEnvios.guardando) return;
      this.cancelacionEnvios.peticionDetalle++;
      this.cancelacionEnvios.cargandoDetalle = false;
      this.cancelacionEnvios.envio = null;
      this.cancelacionEnvios.cargando = true;
      if (conservarMensaje !== true) {
        this.cancelacionEnvios.mensaje = "";
        this.cancelacionEnvios.tipoMensaje = "";
      }
      return this.$axios.post(this.$hostname + this.$hName + "/transportepv/envios/cancelacion/listado", this.cancelacionPayloadFiltros(), { headers: this.headers() })
        .then((res) => {
          var data = res.data || {};
          if (data.estatus !== "ok") {
            this.cancelacionEnvios.mensaje = data.mensaje || "No se pudo cargar el listado de envios.";
            this.cancelacionEnvios.tipoMensaje = "error";
            return;
          }
          this.cancelacionEnvios.listado = Array.isArray(data.envios) ? data.envios : [];
          if (!this.cancelacionEnvios.listado.length) {
            this.cancelacionEnvios.envio = null;
            this.cancelacionEnvios.motivo = "";
          }
        })
        .catch(() => {
          this.cancelacionEnvios.mensaje = "No se pudo cargar el listado de envios. Revise conexion/API.";
          this.cancelacionEnvios.tipoMensaje = "error";
        })
        .finally(() => {
          this.cancelacionEnvios.cargando = false;
        });
    },
    seleccionarCancelacionEnvio(item) {
      if (!item || !item.no_envio || this.cancelacionEnvios.guardando || this.cancelacionEnvios.cargando) {
        return;
      }
      var peticion = ++this.cancelacionEnvios.peticionDetalle;
      this.cancelacionEnvios.envio = null;
      this.cancelacionEnvios.cargandoDetalle = true;
      this.cancelacionEnvios.mensaje = "";
      this.cancelacionEnvios.tipoMensaje = "";
      return this.$axios.post(this.$hostname + this.$hName + "/transportepv/envios/entrega/detalle", {
        noEnvio: item.no_envio,
      }, { headers: this.headers() })
        .then((res) => {
          if (peticion !== this.cancelacionEnvios.peticionDetalle) return;
          var data = res.data || {};
          if (data.estatus !== "ok") {
            this.cancelacionEnvios.mensaje = data.mensaje || "No se pudo cargar el detalle del envio.";
            this.cancelacionEnvios.tipoMensaje = "error";
            return;
          }
          this.cancelacionEnvios.envio = data.envio || null;
          var misma = this.cancelacionEnvios.solicitud && this.cancelacionEnvios.solicitud.noEnvio === item.no_envio;
          if (!misma) {
            this.cancelacionEnvios.solicitud = null;
            this.cancelacionEnvios.pendienteFiscal = false;
            this.cancelacionEnvios.incierta = false;
          }
          this.cancelacionEnvios.motivo = misma ? this.cancelacionEnvios.solicitud.motivo : (this.cancelacionEnvios.envio && this.cancelacionEnvios.envio.motivo) || "";
        })
        .catch(() => {
          if (peticion !== this.cancelacionEnvios.peticionDetalle) return;
          this.cancelacionEnvios.mensaje = "No se pudo cargar el detalle del envio. Revise conexion/API.";
          this.cancelacionEnvios.tipoMensaje = "error";
        }).finally(() => { if (peticion === this.cancelacionEnvios.peticionDetalle) this.cancelacionEnvios.cargandoDetalle = false; });
    },
    estadoRecepcionEntrega(item) {
      if (!item) {
        return "";
      }
      if (item.is_recogido) {
        return "ENTREGADO";
      }
      if (item.is_recibido) {
        return "RECIBIDO";
      }
      return "NO RECIBIDO";
    },
    async cancelarEnvioSeleccionado() {
      var c = this.cancelacionEnvios;
      if (c.guardando || c.cargando || c.cargandoDetalle) return;
      c.tipoMensaje = "error";
      if (!c.envio) { c.mensaje = "Debe seleccionar el envio a cancelar."; return; }
      if (c.envio.activado === false) { c.mensaje = "Este envio ya esta cancelado."; return; }
      if (c.envio.is_recibido && c.envio.is_recogido) { c.mensaje = "No se puede cancelar un envio que ya fue recibido y entregado."; return; }
      var motivo = String(c.motivo || "").trim();
      if (motivo.length < 5 || motivo.length > 1000) { c.mensaje = "Indique un motivo de entre 5 y 1000 caracteres."; return; }
      if (!window.confirm("Seguro que desea cancelar este envio? Si tiene factura electronica se generara una devolucion E34.")) return;
      c.guardando = true;
      var completada = false;
      var enviado = false;
      try {
        if (!c.solicitud || c.solicitud.noEnvio !== c.envio.no_envio || (!c.incierta && !c.pendienteFiscal && c.solicitud.motivo !== motivo)) {
          c.solicitud = { noEnvio: c.envio.no_envio, motivo, idSolicitud: nuevoIdSolicitud(), confirmarCerrado: false };
        }
        var enviar = () => {
          enviado = true;
          return this.$axios.post(this.$hostname + this.$hName + "/transportepv/envios/cancelacion", { ...c.solicitud }, { headers: this.headers() });
        };
        var res;
        try { res = await enviar(); }
        catch (error) {
          var aviso = error.response && error.response.data && (error.response.data.message || error.response.data.mensaje);
          if (!c.solicitud.confirmarCerrado && aviso && aviso.includes("Esta correccion afecta registros cerrados.")) {
            c.mensaje = aviso;
            if (!window.confirm(aviso)) return;
            c.solicitud.confirmarCerrado = true;
            res = await enviar();
          } else throw error;
        }
        var data = res.data || {};
        c.pendienteFiscal = data.pendienteFiscal === true;
        c.incierta = false;
        c.mensaje = data.mensaje || "No se pudo cancelar el envio.";
        c.tipoMensaje = c.pendienteFiscal ? "warning" : data.estatus === "ok" ? "ok" : "error";
        if (data.estatus === "ok" && !c.pendienteFiscal) {
          completada = true; c.envio = null; c.motivo = ""; c.solicitud = null;
        }
      } catch (error) {
        var respuesta = error.response && error.response.data;
        c.incierta = enviado && (!error.response || error.response.status >= 500);
        c.mensaje = (respuesta && (respuesta.message || respuesta.mensaje)) || (!enviado && error.message) || "No se pudo confirmar la cancelacion. Reintente para consultar la misma operacion; no cree otra devolucion.";
        c.tipoMensaje = c.incierta ? "warning" : "error";
      } finally { c.guardando = false; }
      if (completada) await this.cargarCancelacionEnvios(true);
    },
    async reimprimirEnvioCancelacion() {
      if (!this.cancelacionEnvios.envio) {
        this.cancelacionEnvios.mensaje = "Debe seleccionar el envio a reimprimir.";
        this.cancelacionEnvios.tipoMensaje = "error";
        return;
      }
      var data = {
        envios: [this.cancelacionEnvios.envio],
        facturaVenta: null,
      };
      await this.imprimirEnvioPaqueteDesdeCancelacion(data);
    },
    async imprimirEnvioPaqueteDesdeCancelacion(data) {
      var enviarDirecto = Boolean(this.impresion.enviarDirecto);
      var impresora = this.impresoraSeleccionada() || "";
      if (enviarDirecto && !impresora) {
        this.cancelacionEnvios.mensaje = "Seleccione la impresora antes de imprimir.";
        this.cancelacionEnvios.tipoMensaje = "error";
        return;
      }
      var envio = this.cancelacionEnvios.envio;
      var payload = {
        accion: enviarDirecto ? "print" : "preview",
        enviarDirecto: enviarDirecto,
        formato: "TicketEnvio",
        impresora: impresora,
        copiasFactura: enviarDirecto ? Number(this.impresion.copias || 0) : 0,
        copiasEtiqueta: envio && envio.activado === false ? 0 : 1,
        impresoraEtiquetasEnvio: this.contexto.impresoraEtiquetasEnvio || "0",
        factura: null,
        envios: data.envios.map((item) => this.envioCancelacionImpresion(item)),
      };
      try {
        await this.postImpresoraLocal("/impresora/imprimir", this.prepararOperacionImpresion(payload, "envio-paquete-transporte"));
        this.cancelacionEnvios.mensaje = enviarDirecto ? "Envio enviado a reimpresion." : "Vista previa del envio abierta en el programa de impresora.";
        this.cancelacionEnvios.tipoMensaje = "ok";
      } catch (e) {
        this.cancelacionEnvios.mensaje = "No se pudo reimprimir el envio.";
        this.cancelacionEnvios.tipoMensaje = "error";
      }
    },
    async reimprimirEntregaCancelacion() {
      if (!this.cancelacionEnvios.envio || !this.cancelacionEnvios.envio.is_recogido) {
        this.cancelacionEnvios.mensaje = "El recibo de entrega solo aplica a envios entregados.";
        this.cancelacionEnvios.tipoMensaje = "error";
        return;
      }
      var entregaAnterior = this.entrega.envio;
      var cedulaAnterior = this.entrega.cedulaEntrega;
      this.entrega.envio = this.cancelacionEnvios.envio;
      this.entrega.cedulaEntrega = this.cancelacionEnvios.envio.cedula_entrega || "";
      try {
        await this.imprimirEntregaPaquete({ envio: this.cancelacionEnvios.envio });
        this.cancelacionEnvios.mensaje = "Recibo de entrega enviado a reimpresion.";
        this.cancelacionEnvios.tipoMensaje = "ok";
      } catch (e) {
        this.cancelacionEnvios.mensaje = "No se pudo reimprimir el recibo de entrega.";
        this.cancelacionEnvios.tipoMensaje = "error";
      } finally {
        this.entrega.envio = entregaAnterior;
        this.entrega.cedulaEntrega = cedulaAnterior;
      }
    },
    verFirmaEntrega() {
      var envio = this.cancelacionEnvios.envio;
      var firma = String(envio && envio.foto_firma || "").replace(/^data:image\/(png|jpeg);base64,/, "").replace(/[\r\n]/g, "").trim();
      var tipo = firma.startsWith("iVBORw0KGgo") ? "png" : firma.startsWith("/9j/") ? "jpeg" : "";
      this.firmaConsulta.imagen = tipo && firma.length <= 3000000 && /^[A-Za-z0-9+/=]+$/.test(firma) ? "data:image/" + tipo + ";base64," + firma : "";
      this.firmaConsulta.visible = true;
    },
    envioCancelacionImpresion(envio) {
      var base = this.envioImpresion(envio);
      base.numero_envio = envio.no_envio || envio.noEnvio || "";
      var rutaCancelacion = String(envio.ruta_destino || "").trim();
      var partesRutaCancelacion = this.partesNombreRuta(rutaCancelacion);
      base.d_origen = envio.ruta_origen || partesRutaCancelacion.origen || base.d_origen;
      var destinoCancelacion = String(envio.ruta_destino || base.d_destino || "").trim();
      if (destinoCancelacion.indexOf("->") >= 0) {
        destinoCancelacion = this.partesNombreRuta(destinoCancelacion).destino;
      }
      base.d_destino = destinoCancelacion;
      base.nombre_destinatario = envio.nombre_destinatario || base.nombre_destinatario;
      base.telefono_destinatario = envio.telefono_destinatario || base.telefono_destinatario;
      base.nombre_remitente = envio.nombre_remitente || base.nombre_remitente;
      base.telefono_remitente = envio.telefono_remitente || base.telefono_remitente;
      base.cedula_remitente = envio.cedula_remitente || base.cedula_remitente;
      base.valor_declarado = String(envio.valor_declarado || 0);
      base.tipo_envio = envio.tipo_envio || "";
      base.tipo_pago = envio.tipo_pago || "";
      base.no_viaje = envio.no_viaje || "";
      base.fecha = envio.fecha || this.fechaTrabajo;
      base.hora_salida = envio.hora_salida || "";
      base.ficha = envio.ficha || "";
      base.subtotal = Number(envio.precio_envio || 0);
      base.itbis = Number(envio.impuestos || 0);
      base.total = Number(envio.precio_envio || 0) + Number(envio.impuestos || 0);
      base.efectivo = Number(envio.efectivo || 0);
      base.tarjeta = Number(envio.tarjeta || 0);
      base.cheque = Number(envio.cheque || 0);
      base.notacredito = Number(envio.notacredito || 0);
      base.credito = Number(envio.credito || 0);
      base.transferencia = Number(envio.transferencia || 0);
      base.pago_destino = Number(envio.pago_destino || 0);
      base.activado = envio.activado !== false;
      base.motivo_cancelacion = envio.motivo || "";
      base.cajera = envio.cajero || this.contexto.cajero || "";
      base.control_turno = envio.control_turno || "";
      return base;
    },
    lecturaPayload() {
      return {
        boleto: String(this.lectura.ticket || "").trim(),
        turnoDetalleId: null,
        numeroViaje: String(this.lectura.viaje || "").trim().toUpperCase(),
        caja: Number(this.contexto.caja || 0),
        usuario: this.contexto.cajero,
      };
    },
    async leerTicket() {
      if (this.lectura.leyendo) return;
      if (this.cargandoContexto || this.actualizandoTurnos) {
        this.mostrarMensaje("Espere mientras se cargan los viajes de la caja.", "warning");
        return;
      }
      var payload = this.lecturaPayload();
      if (!payload.numeroViaje) {
        this.mostrarMensaje("Debe especificar el viaje que quiere abordar primero.", "error");
        return;
      }
      if (!/^[IV]-\d{8}-[1-9]\d*$/.test(payload.numeroViaje)) {
        this.mostrarMensaje("Debe indicar el numero de viaje completo, por ejemplo I-30092026-1.", "error");
        return;
      }
      if (!payload.boleto) {
        this.mostrarMensaje("Debe indicar el numero de ticket.", "error");
        return;
      }
      if (!Number.isInteger(payload.caja) || payload.caja <= 0) {
        this.mostrarMensaje("Debe indicar la caja que realiza la lectura.", "error");
        return;
      }
      if (this.lectura.claveSesion !== this.claveSesionLectura) this.limpiarResultadosLectura();
      var sesion = this.lectura.sesion;
      var clave = this.claveSesionLectura;
      var sesionVigente = () => sesion === this.lectura.sesion && clave === this.claveSesionLectura && this.pantalla === "lectura";
      this.lectura.leyendo = true;
      var procesado = false;
      try {
        // Resolve the visible boarding trip, independently of the trip selected for sales.
        var consulta = await this.$axios.get(this.$hostname + this.$hName + "/transportepv/turnos/facturacion", {
          headers: this.headers(), params: { cajaId: payload.caja }, timeout: 30000,
        });
        if (!sesionVigente()) return;
        var viajes = (Array.isArray(consulta.data) ? consulta.data : []).filter((viaje) => viaje.cerrado !== true &&
          Number.isInteger(Number(viaje.id)) && Number(viaje.id) > 0 &&
          this.numeroViajeTurno(viaje).trim().toUpperCase() === payload.numeroViaje);
        if (viajes.length !== 1) {
          this.mostrarMensaje(viajes.length > 1 ? "Hay mas de un turno con ese numero de viaje. Revise la configuracion antes de abordar."
            : "No se encontro un viaje abierto con ese numero para esta caja. Verifique el viaje a abordar.", "error");
          return;
        }
        var viaje = viajes[0];
        payload.turnoDetalleId = Number(viaje.id);
        this.lectura.viaje = payload.numeroViaje;
        var mismoTurno = Number(this.turno.id) === payload.turnoDetalleId && this.turno.numeroViaje === payload.numeroViaje;
        this.lectura.ficha = (mismoTurno && this.turno.ficha) || viaje.ficha || (viaje.vehiculo && viaje.vehiculo.ficha) || "";
        this.lectura.chofer = (mismoTurno && this.turno.chofer) || (viaje.idchofer && viaje.idchofer.nombre) || viaje.chofer || viaje.conductor || "";
        var res = await this.$axios.post(this.$hostname + this.$hName + "/transportepv/lectura", payload, { headers: this.headers() });
        if (!sesionVigente()) return;
        var data = res.data || {};
        var abordado = data.estatus === "abordado";
        var fila = data.ticket || (Array.isArray(data.datos) && data.datos.length > 0 ? data.datos[0] : null);
        if (fila && (abordado || data.estatus === "ya-abordado")) {
          var ticket = this.ticketLecturaDesdeFila(fila);
          this.lectura.ultimo = ticket;
          if (abordado) {
            this.agregarTicketLectura("abordadosAhora", ticket);
          } else if (data.estatus === "ya-abordado") {
            this.agregarTicketLectura("yaAbordados", ticket);
          }
        } else {
          this.lectura.ultimo = {};
        }
        procesado = abordado || data.estatus === "ya-abordado";
        this.mostrarMensaje(data.mensaje || "Lectura procesada.", abordado ? "ok" : "error");
        if (procesado) this.lectura.ticket = "";
      } catch (error) {
        if (!sesionVigente()) return;
        this.lectura.ultimo = {};
        this.mostrarMensaje(payload.turnoDetalleId ? "No se pudo confirmar la lectura del ticket. Revise conexion/API."
          : "No se pudo verificar el viaje a abordar. Revise conexion/API.", "error");
      } finally {
        this.lectura.leyendo = false;
        if (procesado && sesionVigente()) this.$nextTick(() => {
          if (!sesionVigente()) return;
          var campo = this.$refs.lecturaTicket;
          if (campo) campo.focus();
        });
      }
    },
    ticketLecturaDesdeFila(fila) {
      return {
        boleto: fila.boleto || fila.id || "",
        turno: fila.numero_turno || fila.numeroTurno || fila.turno_abordado || this.lectura.viaje || "",
        fecha: fila.fecha || "",
        fechaLectura: fila.fecha_lectura_ticket || fila.fechaLecturaTicket || "",
        precio: Number(fila.efectivo || fila.precio || 0),
        usuario: fila.usuario_lectura_ticket || fila.usuarioLecturaTicket || this.contexto.cajero || "",
        origen: fila.origen || "",
        destino: fila.destino || "",
      };
    },
    agregarTicketLectura(lista, ticket) {
      var existe = this.lectura.abordadosAhora.concat(this.lectura.yaAbordados)
        .some((item) => String(item.boleto) === String(ticket.boleto));
      if (!existe) {
        this.lectura[lista].unshift(ticket);
      }
    },
    cierreViajePayload() {
      return {
        caja: Number(this.contexto.caja || 0),
        cierreId: this.cierreViaje.cierreId,
        turnoDetalleId: this.turno.id,
        numeroViaje: String(this.turno.numeroViaje || ""),
        ficha: this.turno.ficha || "",
        sucursalCierre: Number(this.contexto.sucursalId || 0),
        sucursalCerrada: Number(this.contexto.sucursalId || 0),
        usuario: this.contexto.cajero,
        dieta: Number(this.cierreViaje.dieta || 0),
        otrasDeducciones: Number(this.cierreViaje.otrasDeducciones || 0),
        conceptoOtrasDeducciones: this.cierreViaje.conceptoOtrasDeducciones || "",
      };
    },
    abrirConsultaViajesCierre() {
      if (this.cargandoContexto || this.cierreViaje.cargando || this.cierreViaje.guardando) return;
      this.consultaViajes.visible = true;
      this.consultaViajes.fecha = this.fechaTrabajoReporte;
      this.consultaViajes.sentido = "";
      this.consultaViajes.estado = "";
      this.consultaViajes.busqueda = "";
      return this.cargarConsultaViajesCierre();
    },
    cargarConsultaViajesCierre() {
      var solicitud = ++this.consultaViajes.solicitud;
      this.consultaViajes.viajes = [];
      this.consultaViajes.error = "";
      if (!this.contexto.sucursalId || !this.contexto.caja) {
        this.consultaViajes.cargando = false;
        this.consultaViajes.error = "Debe seleccionar una caja con sucursal.";
        return;
      }
      this.consultaViajes.cargando = true;
      var payload = {
        fecha: this.consultaViajes.fecha || this.fechaTrabajoReporte,
        esSentidoIda: this.consultaViajes.sentido ? this.consultaViajes.sentido === "I" : null,
        estado: this.consultaViajes.estado,
        caja: Number(this.contexto.caja),
        sucursal: Number(this.contexto.sucursalId || 0),
      };
      return this.$axios.post(this.$hostname + this.$hName + "/transportepv/cierre-viaje/viajes", payload, { headers: this.headers(), timeout: 30000 })
        .then((res) => {
          if (solicitud !== this.consultaViajes.solicitud) return;
          var data = res.data || {};
          if (data.estatus === "error") {
            this.consultaViajes.error = data.mensaje || "No se pudieron cargar los cierres.";
            return;
          }
          this.consultaViajes.viajes = Array.isArray(data.viajes) ? data.viajes : [];
        })
        .catch((error) => {
          if (solicitud !== this.consultaViajes.solicitud) return;
          this.consultaViajes.error = error && error.code === "ECONNABORTED"
            ? "La consulta de cierres tardo demasiado. Intente buscar nuevamente."
            : "No se pudieron cargar los cierres. Revise conexion/API.";
        })
        .finally(() => {
          if (solicitud === this.consultaViajes.solicitud) this.consultaViajes.cargando = false;
        });
    },
    seleccionarViajeCierre(viaje) {
      if (!viaje || this.consultaViajes.cargando || this.cierreViaje.cargando || this.cierreViaje.guardando) {
        return;
      }
      this.limpiarDetalleCierreViaje();
      this.cierreViaje.cierreId = Number(viaje.cierre_id || 0) || null;
      this.cierreViaje.cerrado = viaje.cerrado === true;
      this.turno.id = Number(viaje.turno_detalle || viaje.id_turno || 0) || null;
      this.turno.numeroViaje = viaje.numero_viaje || this.turno.numeroViaje;
      this.turno.ficha = viaje.ficha || this.turno.ficha;
      this.turno.chofer = viaje.conductor_nombre || this.turno.chofer;
      if (viaje.capacidad) {
        this.turno.capacidad = Number(viaje.capacidad || 0);
      }
      this.consultaViajes.visible = false;
      return this.cargarCierreViajeDetalle();
    },
    limpiarDetalleCierreViaje() {
      this.cierreViaje.detalleCargado = false;
      this.cierreViaje.cierreId = null;
      this.cierreViaje.dieta = 0;
      this.cierreViaje.otrasDeducciones = 0;
      this.cierreViaje.conceptoOtrasDeducciones = "";
      this.cierreViaje.boletos = [];
      this.cierreViaje.resumen = {};
      this.cierreViaje.cierre = null;
      this.cierreViaje.cerrado = false;
    },
    buscarCierreViajeManual() {
      if (this.cierreViaje.cerrado || this.cierreViaje.cargando || this.cierreViaje.guardando) return;
      var numeroViaje = String(this.turno.numeroViaje || "").trim();
      this.limpiarDetalleCierreViaje();
      this.turno.id = null;
      this.mostrarMensaje(numeroViaje ? "Buscando detalle del viaje " + numeroViaje + "..." : "Debe indicar el viaje que quiere cerrar.", numeroViaje ? "ok" : "error");
      if (!numeroViaje) {
        return;
      }
      return this.cargarCierreViajeDetalle();
    },
    cargarCierreViajeDetalle() {
      if (this.cierreViaje.cargando) return;
      this.cierreViaje.detalleCargado = false;
      if (this.cargandoContexto) {
        this.mostrarMensaje("Cargando datos del viaje...", "ok");
        return;
      }
      if (!this.resolverTurnoCierreViaje()) {
        return;
      }
      if (!this.turno.id && !String(this.turno.numeroViaje || "").trim()) {
        this.mostrarMensaje("Debe indicar el viaje que quiere cerrar.", "error");
        return;
      }
      this.cierreViaje.cargando = true;
      this.mostrarMensaje("Cargando detalle del viaje...", "ok");
      return this.$axios.post(this.$hostname + this.$hName + "/transportepv/cierre-viaje/detalle", this.cierreViajePayload(), { headers: this.headers() })
        .then((res) => {
          var data = res.data || {};
          if (data.estatus === "error") {
            this.mostrarMensaje(data.mensaje || "No se pudo cargar el cierre.", "error");
            return;
          }
          this.cierreViaje.boletos = Array.isArray(data.boletos) ? data.boletos : [];
          this.cierreViaje.resumen = data.resumen || {};
          this.cierreViaje.configuracion = data.configuracion || {};
          this.cierreViaje.cerrado = data.cerrado === true;
          this.cierreViaje.cierre = data.cierre || null;
          this.cierreViaje.cierreId = data.cierre ? data.cierre.id : null;
          this.cierreViaje.dieta = Number(this.cierreViaje.resumen.dietaDescontar || 0);
          this.cierreViaje.otrasDeducciones = Number(this.cierreViaje.resumen.otrosMontosDescontar || 0);
          this.cierreViaje.conceptoOtrasDeducciones = this.cierreViaje.resumen.conceptoOtrasDeducciones || "";
          this.cierreViaje.detalleCargado = true;
          if (this.cierreViaje.resumen.turno_detalle) {
            this.turno.id = this.cierreViaje.resumen.turno_detalle;
          }
          if (this.cierreViaje.resumen.numero_viaje || this.cierreViaje.resumen.numeroViaje) {
            this.turno.numeroViaje = this.cierreViaje.resumen.numero_viaje || this.cierreViaje.resumen.numeroViaje;
          }
          if (this.cierreViaje.resumen.ficha) {
            this.turno.ficha = this.cierreViaje.resumen.ficha;
          }
          if (this.cierreViaje.resumen.conductor_nombre) {
            this.turno.chofer = this.cierreViaje.resumen.conductor_nombre;
          }
          this.mostrarMensaje(this.cierreViaje.cerrado ? "Cierre guardado cargado. Solo disponible para reimprimir." : "Detalle de cierre cargado.", "ok");
        })
        .catch(() => {
          this.mostrarMensaje("No se pudo cargar el cierre de viaje. Revise conexion/API.", "error");
        })
        .finally(() => {
          this.cierreViaje.cargando = false;
        });
    },
    guardarCierreViaje() {
      if (this.cargandoContexto || this.cierreViaje.cargando || this.cierreViaje.guardando || !this.cierreViaje.detalleCargado) {
        return;
      }
      if (!this.turno.id) {
        this.mostrarMensaje("Debe seleccionar el viaje que quiere cerrar.", "error");
        return;
      }
      if (this.cierreViaje.cerrado) {
        this.mostrarMensaje("Este viaje ya ha sido cerrado.", "error");
        return;
      }
      this.cierreViaje.guardando = true;
      return this.$axios.post(this.$hostname + this.$hName + "/transportepv/cierre-viaje", this.cierreViajePayload(), { headers: this.headers() })
        .then(async (res) => {
          var data = res.data || {};
          if (data.estatus !== "ok") {
            this.mostrarMensaje(data.mensaje || "No se pudo guardar el cierre.", "error");
            if (data.estatus === "cerrado") {
              this.cierreViaje.cerrado = true;
              this.cierreViaje.cierreId = data.cierre ? data.cierre.id : this.cierreViaje.cierreId;
              await this.cargarCierreViajeDetalle();
              await this.actualizarTurnosFacturacion();
            }
            return;
          }
          this.cierreViaje.cerrado = true;
          this.cierreViaje.cierre = data.cierre || null;
          this.cierreViaje.cierreId = data.cierre ? data.cierre.id : null;
          this.cierreViaje.resumen = data.resumen || this.cierreViaje.resumen;
          this.cierreViaje.boletos = Array.isArray(data.boletos) ? data.boletos : this.cierreViaje.boletos;
          var actualizado = await this.actualizarTurnosFacturacion();
          var siguiente = this.turnoFacturacion || this.turno;
          var estadoTurno = !actualizado ? " No se pudo verificar el siguiente turno; la facturacion queda bloqueada."
            : siguiente.id ? " Siguiente turno: " + siguiente.numeroViaje + "." : " No hay otro turno abierto para este sentido. Cree o seleccione un nuevo turno.";
          try {
            var modoReporte = await this.imprimirCierreViaje();
            if (modoReporte === false) {
              this.mostrarMensaje(this.mensaje + estadoTurno, "error");
              return;
            }
          } catch (e) {
            this.mostrarMensaje("Cierre guardado. No se pudo imprimir el cierre de viaje." + estadoTurno, "error");
            return;
          }
          this.mostrarMensaje("Cierre de viaje guardado: " + (this.cierreViaje.cierre && this.cierreViaje.cierre.id ? this.cierreViaje.cierre.id : "OK")
            + (modoReporte === "preview" ? ". Vista previa abierta." : "") + estadoTurno, actualizado ? "ok" : "warning");
        })
        .catch(() => {
          this.mostrarMensaje("No se pudo guardar el cierre de viaje. Revise conexion/API.", "error");
        })
        .finally(() => {
          this.cierreViaje.guardando = false;
        });
    },
    statusCierreClase(boleto) {
      return boleto && boleto.status === "Abordado" ? "abordado" : "no-abordado";
    },
    async imprimirCierreViaje() {
      if (!this.cierreViaje.detalleCargado || this.cierreViaje.cargando || this.cierreViaje.imprimiendo || !this.cierreViaje.cerrado) return false;
      if (!this.cierreViaje.boletos || this.cierreViaje.boletos.length === 0) {
        this.mostrarMensaje("Cierre guardado. No hay boletos para generar el reporte del cierre.", "error");
        return false;
      }
      var enviarDirecto = Boolean(this.impresion.enviarDirecto);
      var impresora = enviarDirecto ? (this.impresoraSeleccionada() || "") : "";
      this.cierreViaje.imprimiendo = true;
      try {
        var resumen = this.cierreViaje.resumen || {};
        var formato = Number(resumen.comisionFijaBoletos || 0) > 0 ? "CierreTurno_AetraBus" : "CierreTurno";
        var payload = {
          accion: enviarDirecto ? "print" : "preview",
          enviarDirecto: enviarDirecto,
          formato: formato,
          impresora: impresora,
          copias: enviarDirecto ? Number(this.impresion.copias || 0) : 0,
          cierres: this.cierreViaje.boletos.map((boleto) => this.cierreViajeImpresion(boleto, formato)),
        };
        await this.postImpresoraLocal("/impresora/imprimir", this.prepararOperacionImpresion(payload, "cierre-viaje-transporte"));
        if (!this.cierreViaje.guardando) {
          this.mostrarMensaje(enviarDirecto ? "Cierre de viaje enviado a impresion." : "Vista previa del cierre abierta en el programa de impresora.", "ok");
        }
        return payload.accion;
      } catch (e) {
        this.mostrarMensaje(this.esTiempoEsperaImpresion(e)
          ? "Cierre guardado. No se recibio confirmacion del reporte. Revise la vista previa o la cola antes de reimprimir."
          : "Cierre guardado. No se pudo imprimir o abrir la vista previa del cierre de viaje. Revise el programa de impresora y utilice Reimprimir.", "error");
        return false;
      } finally {
        this.cierreViaje.imprimiendo = false;
      }
    },
    cierreViajeImpresion(boleto) {
      var configGeneral = this.configuracionGeneral();
      var config = configGeneral.config || {};
      var resumen = this.cierreViaje.resumen || {};
      var cierre = this.cierreViaje.cierre || {};
      var esAbordado = boleto.status === "Abordado";
      var cantidadCortesia = Number(resumen.cantidadCortesia || 0);
      var cantidadAbordados = Number(resumen.cantidadAbordados || 0);
      var empresaImpresion = String(this.contexto.sucursal || config.nombre || "").trim();
      var direccionImpresion = String(this.contexto.sucursalDireccion || config.direccion || "").trim();
      var telefonoImpresion = String(this.contexto.sucursalTelefono || config.telefono || "").trim();
      var rncImpresion = String(this.contexto.sucursalRnc || config.rnc || "").trim();
      return {
        empresa: empresaImpresion,
        direccion: direccionImpresion,
        telefono: telefonoImpresion,
        rnc: rncImpresion,
        logo: config.logo || "",
        numeroViaje: this.turno.numeroViaje || "",
        fecha: resumen.fechaCierre || (cierre.fecha ? String(cierre.fecha).slice(0, 10) : this.fechaTrabajoReporte),
        ficha: this.turno.ficha || resumen.ficha || "",
        conductor: this.turno.chofer || resumen.conductor_nombre || "",
        boleto: boleto.numero_boleto ? String(boleto.numero_boleto) : "",
        capacidad: Number(resumen.capacidad || this.turno.capacidad || 0),
        vendido: Number(resumen.cantidadVendida || 0),
        disponible: Number(this.disponiblesCierreViaje || 0),
        ruta: boleto.ruta || ((boleto.origen || "") + " -> " + (boleto.destino || "")),
        cantidadCortesia: cantidadCortesia,
        cantidadDescuento: Number(resumen.cantidadDescuento || 0),
        cantidadRecargos: Number(resumen.cantidadRecargos || 0),
        cantidadAbordados: cantidadAbordados,
        cantidadNoAbordados: Number(resumen.cantidadNoAbordados || 0),
        valor: Number(boleto.precio || 0),
        descuento: Number(boleto.descuento || 0),
        recargo: Number(boleto.recargo || 0),
        cortecia: Number(boleto.valor_cortesia || 0),
        importe: Number(boleto.importe || 0),
        totalCortecia: Number(resumen.valorCortesia || 0),
        totalDescuento: Number(resumen.valorDescuento || 0),
        totalRecargos: Number(resumen.valorRecargos || 0),
        totalAbordados: Number(resumen.valorAbordados || 0),
        totalNoAbordados: Number(resumen.valorNoAbordados || 0),
        valorAEntregar: Number(this.totalCierreViaje || 0),
        status: esAbordado ? "Abordado" : "No abordado",
        turno: boleto.turno_detalle ? String(boleto.turno_detalle) : "",
        turnoAbordado: boleto.turno_abordado ? String(boleto.turno_abordado) : "",
        turnoACerrar: this.turno.id ? String(this.turno.id) : "",
        numeroCierre: cierre.id ? String(cierre.id) : "",
        propietario: resumen.nombre_propietario || "",
        cantidadComisiones: Math.max(0, cantidadAbordados - cantidadCortesia),
        totalComisiones: Number(resumen.comisionDescontar || 0),
        dieta: Number(this.cierreViaje.dieta || 0),
        otros_cargos: Number(this.cierreViaje.otrasDeducciones || 0),
        motivo_otros_cargos: this.cierreViaje.conceptoOtrasDeducciones || "",
        destino: boleto.destino || "",
        cajero: cierre.cajero || this.contexto.cajero || "",
        cantidadNoAbordadosAnteriores: 0,
      };
    },
    cierreCajaPayload() {
      return {
        caja: Number(this.contexto.caja || 0),
        sucursal: Number(this.contexto.sucursalId || 0),
        usuario: this.contexto.cajero,
        efectivo: Number(this.totalEfectivoCaja || 0),
        tarjeta: Number(this.cierreCaja.tarjeta || 0),
        cheques: Number(this.cierreCaja.cheques || 0),
        cantidadTarjeta: Number(this.cierreCaja.cantidadTarjeta || 0),
        cantidadCheques: Number(this.cierreCaja.cantidadCheques || 0),
        sobranteUsuarioAnterior: Number(this.cierreCaja.sobranteUsuarioAnterior || 0),
        denominaciones: this.cierreCaja.denominaciones,
      };
    },
    limpiarConteoCierreCaja() {
      this.denominacionesCaja.forEach((den) => {
        this.$set(this.cierreCaja.denominaciones, den, 0);
      });
      this.cierreCaja.cantidadTarjeta = 0;
      this.cierreCaja.tarjeta = 0;
      this.cierreCaja.cantidadCheques = 0;
      this.cierreCaja.cheques = 0;
      this.cierreCaja.sobranteUsuarioAnterior = 0;
      this.cierreCaja.detalleImpresion = [];
    },
    cierreCajaTieneDatos(resumen) {
      resumen = resumen || {};
      return [
        "ventaBoletos",
        "compraBoletos",
        "ventaEnvios",
        "ventaEnviosOrigen",
        "cobrosEnviosDestino",
        "enviosPorCobrarDestino",
        "deposito",
        "otrasVentas",
        "pagosEnviados",
        "pagosRecibidos",
        "cantidadVendidos",
        "cantidadAbordados",
        "cantidadSinAbordar",
      ].some((campo) => Number(resumen[campo] || 0) > 0);
    },
    cargarCierreCajaDetalle() {
      if (this.cierreCaja.cargando || this.cierreCaja.guardando) return;
      if (!this.contexto.caja) {
        this.mostrarMensaje("Debe seleccionar una caja.", "error");
        return;
      }
      this.mensaje = "";
      this.mensajeTipo = "ok";
      this.reimpresionPendiente = null;
      this.limpiarConteoCierreCaja();
      this.cierreCaja.cierre = null;
      this.cierreCaja.cargando = true;
      return this.$axios.post(this.$hostname + this.$hName + "/transportepv/cierre-caja/detalle", this.cierreCajaPayload(), { headers: this.headers(), timeout: 30000 })
        .then((res) => {
          var data = res.data || {};
          if (data.estatus !== "ok") {
            this.mostrarMensaje(data.mensaje || "No se pudo cargar el cierre de caja.", "error");
            return;
          }
          this.cierreCaja.resumen = data.resumen || {};
          this.cierreCaja.configuracion = data.configuracion || {};
          if (this.cierreCajaTieneDatos(this.cierreCaja.resumen)) {
            this.mostrarMensaje("Detalle de cierre de caja cargado.", "ok");
          }
        })
        .catch(() => {
          this.mostrarMensaje("No se pudo cargar el cierre de caja. Revise conexion/API.", "error");
        })
        .finally(() => {
          this.cierreCaja.cargando = false;
        });
    },
    guardarCierreCaja() {
      if (this.cierreCaja.cargando || this.cierreCaja.guardando) return;
      if (!this.contexto.caja) {
        this.mostrarMensaje("Debe seleccionar una caja.", "error");
        return;
      }
      this.cierreCaja.guardando = true;
      return this.$axios.post(this.$hostname + this.$hName + "/transportepv/cierre-caja", this.cierreCajaPayload(), { headers: this.headers() })
        .then(async (res) => {
          var data = res.data || {};
          if (data.estatus !== "ok") {
            this.mostrarMensaje(data.mensaje || "No se pudo guardar el cierre de caja.", "error");
            return;
          }
          this.cierreCaja.cierre = data.cierre || null;
          this.cierreCaja.detalleImpresion = Array.isArray(data.detalleImpresion) ? data.detalleImpresion : [];
          this.contexto.numeroCierre = this.cierreCaja.cierre && this.cierreCaja.cierre.secuencia ? this.cierreCaja.cierre.secuencia : this.contexto.numeroCierre;
          this.mostrarMensaje("Cierre de caja guardado correctamente.", "ok");
          try {
            await this.imprimirCierreCaja();
          } catch (e) {
            this.mostrarMensaje("Cierre guardado. No se pudo imprimir el cierre de caja.", "error");
            return;
          }
          this.mostrarMensaje("Cierre de caja guardado: " + (this.contexto.numeroCierre || "OK"), "ok");
        })
        .catch(() => {
          this.mostrarMensaje("No se pudo guardar el cierre de caja. Revise conexion/API.", "error");
        })
        .finally(() => {
          this.cierreCaja.guardando = false;
        });
    },
    async imprimirCierreCaja() {
      var formato = this.formatoImpresionCierreCaja();
      var payload = {
        accion: "print",
        formato: formato,
        formatoSolicitado: formato,
        impresora: this.impresoraSeleccionada() || "",
        copias: Number(this.impresion.copias || 0),
        cierres: this.cierresCajaParaImpresion(formato),
      };
      await this.postImpresoraLocal("/impresora/imprimir", this.prepararOperacionImpresion(payload, "cierre-caja-transporte"));
    },
    async reimprimirUltimoCierreCaja() {
      if (this.cierreCaja.cargando || this.cierreCaja.guardando) return;
      if (!this.contexto.caja) {
        this.mostrarMensaje("Debe seleccionar una caja para reimprimir el cierre.", "error");
        return;
      }
      this.cierreCaja.cargando = true;
      try {
        var res = await this.$axios.post(this.$hostname + this.$hName + "/transportepv/cierre-caja/ultimo", {
          caja: Number(this.contexto.caja || 0),
          sucursal: Number(this.contexto.sucursalId || 0),
          usuario: this.contexto.cajero,
        }, { headers: this.headers() });
        var data = res.data || {};
        if (data.estatus !== "ok") {
          this.mostrarMensaje(data.mensaje || "No se encontro un cierre de caja para reimprimir.", "error");
          return;
        }
        this.cierreCaja.cierre = data.cierre || null;
        this.cierreCaja.resumen = data.resumen || {};
        this.cierreCaja.configuracion = data.configuracion || {};
        this.cierreCaja.detalleImpresion = Array.isArray(data.detalleImpresion) ? data.detalleImpresion : [];
        this.cierreCaja.cantidadTarjeta = Number(data.cantidadTarjeta || 0);
        this.cierreCaja.tarjeta = Number(data.tarjeta || 0);
        this.cierreCaja.cantidadCheques = Number(data.cantidadCheques || 0);
        this.cierreCaja.cheques = Number(data.cheques || 0);
        this.cierreCaja.sobranteUsuarioAnterior = Number(data.sobranteUsuarioAnterior || 0);
        var denominaciones = data.denominaciones || {};
        this.denominacionesCaja.forEach((den) => {
          this.$set(this.cierreCaja.denominaciones, den, Number(denominaciones[den] || denominaciones[String(den)] || 0));
        });
        this.contexto.numeroCierre = this.cierreCaja.cierre && this.cierreCaja.cierre.secuencia ? this.cierreCaja.cierre.secuencia : this.contexto.numeroCierre;
        await this.imprimirCierreCaja();
        this.mostrarMensaje("Ultimo cierre de esta caja reimpreso: " + this.numeroCierreCajaTrabajo, "ok");
      } catch (e) {
        this.mostrarMensaje("No se pudo reimprimir el ultimo cierre de esta caja. Revise conexion/API o impresora.", "error");
      } finally {
        this.cierreCaja.cargando = false;
      }
    },
    formatoImpresionCierreCaja() {
      var config = this.cierreCaja.configuracion || {};
      if (Number(config.formatoCierreCaja || 1) === 2) {
        return "CierreCaja_formatoAetra";
      }
      if (Number(config.formatoDeduccionComisionesBoletos || 1) !== 1) {
        return "CierreCaja_AetraBus";
      }
      return "CierreCaja";
    },
    cierresCajaParaImpresion(formato) {
      var cierreBase = this.cierreCajaImpresion();
      if (formato !== "CierreCaja_formatoAetra") {
        return [cierreBase];
      }
      var detalle = Array.isArray(this.cierreCaja.detalleImpresion) ? this.cierreCaja.detalleImpresion : [];
      if (!detalle.length) {
        return [cierreBase];
      }
      return detalle.map((fila) => {
        var valorAbordo = Number(fila.valor_abordo || 0);
        var comision = Number(fila.comision_descontar || 0);
        var dieta = Number(fila.dieta_descontar || 0);
        var otras = Number(fila.otros_montos_descontar || 0);
        return Object.assign({}, cierreBase, {
          cierre_viaje: fila.id_cierre_viaje ? String(fila.id_cierre_viaje) : "",
          numero_cierre: fila.id_cierre_viaje ? String(fila.id_cierre_viaje) : "",
          ficha: fila.ficha ? String(fila.ficha) : "",
          ventas: valorAbordo - dieta - otras,
          comisiones: comision,
          dieta: dieta,
        });
      });
    },
    cierreCajaImpresion() {
      var configGeneral = this.configuracionGeneral();
      var config = configGeneral.config || {};
      var resumen = this.cierreCaja.resumen || {};
      var cierre = this.cierreCaja.cierre || {};
      var den = this.cierreCaja.denominaciones || {};
      var sucursalNombre = String(this.contexto.sucursal || config.nombre || "").trim();
      var sucursalTelefono = String(this.contexto.sucursalTelefono || config.telefono || "").trim();
      var sucursalRnc = String(this.contexto.sucursalRnc || config.rnc || "").trim();
      var valorVendidos = Number(resumen.valorVendidos != null ? resumen.valorVendidos : resumen.ventaBoletos || 0);
      var valorSinAbordar = Number(resumen.valorSinAbordar != null ? resumen.valorSinAbordar : Math.max(0, valorVendidos - Number(resumen.compraBoletos || 0)));
      var valorAbordados = Number(resumen.valorAbordados != null ? resumen.valorAbordados : Math.max(0, valorVendidos - valorSinAbordar));
      return {
        empresa: sucursalNombre,
        direccion: "",
        telefono: sucursalTelefono,
        rnc: sucursalRnc,
        logo: config.logo || "",
        numeroCierre: cierre.secuencia_por_caja || cierre.secuencia || this.contexto.numeroCierre || "",
        fecha: this.fechaTrabajoReporte,
        fechaCierre: this.fechaTrabajoReporte,
        cajero: this.contexto.cajero || "",
        caja: this.contexto.caja ? String(this.contexto.caja) : "",
        turno: "",
        sucursal: this.contexto.sucursal || "",
        cantidad_tarjetas: String(this.cierreCaja.cantidadTarjeta || 0),
        valor_tarjetas: String(this.cierreCaja.tarjeta || 0),
        cantidad_cheques: String(this.cierreCaja.cantidadCheques || 0),
        valor_cheques: String(this.cierreCaja.cheques || 0),
        cantidad_2000: String(den[2000] || 0),
        cantidad_1000: String(den[1000] || 0),
        cantidad_500: String(den[500] || 0),
        cantidad_200: String(den[200] || 0),
        cantidad_100: String(den[100] || 0),
        cantidad_50: String(den[50] || 0),
        cantidad_25: String(den[25] || 0),
        cantidad_20: String(den[20] || 0),
        cantidad_10: String(den[10] || 0),
        cantidad_5: String(den[5] || 0),
        cantidad_1: String(den[1] || 0),
        monto_2000: Number(den[2000] || 0) * 2000,
        monto_1000: Number(den[1000] || 0) * 1000,
        monto_500: Number(den[500] || 0) * 500,
        monto_200: Number(den[200] || 0) * 200,
        monto_100: Number(den[100] || 0) * 100,
        monto_50: Number(den[50] || 0) * 50,
        monto_25: Number(den[25] || 0) * 25,
        monto_20: Number(den[20] || 0) * 20,
        monto_10: Number(den[10] || 0) * 10,
        monto_5: Number(den[5] || 0) * 5,
        monto_1: Number(den[1] || 0),
        total_efectivo: Number(this.totalEfectivoCaja || 0),
        totalFinal: Number(this.totalEfectivoCaja || 0) + Number(this.cierreCaja.tarjeta || 0) + Number(this.cierreCaja.cheques || 0),
        reimpresion: cierre.secuencia ? true : false,
        venta_boletos: Number(resumen.ventaBoletos || 0),
        venta_envios: Number(resumen.ventaEnvios || 0),
        compra_boletos: Number(resumen.compraBoletos || 0),
        deposito: Number(resumen.deposito || 0),
        otras_ventas: Number(resumen.otrasVentas || 0),
        pagos_enviados: Number(resumen.pagosEnviados || 0),
        pagos_recibidos: Number(resumen.pagosRecibidos || 0),
        sobrante_usuario_anterior: Number(this.cierreCaja.sobranteUsuarioAnterior || 0),
        sumar_sobrante: Number(this.cierreCaja.sobranteUsuarioAnterior || 0) >= 0,
        boletos_vendidos: Number(resumen.cantidadVendidos || 0),
        boletos_sin_abordar: Number(resumen.cantidadSinAbordar || 0),
        boletos_abordados: Number(resumen.cantidadAbordados || 0),
        valor_sin_abordar: valorSinAbordar,
        valor_vendidos: valorVendidos,
        valor_abordados: valorAbordados,
        ventas: Number(resumen.ventaBoletos || 0),
        comisiones: Number(resumen.compraBoletos || 0),
        dieta: 0,
        cierre_viaje: "",
        numero_cierre: "",
      };
    },
    datosFiscalesPayload() {
      return {
        nombreFiscal: String(this.comprobante.nombre || "").trim(),
        rncFiscal: String(this.comprobante.rnc || "").trim(),
        direccionFiscal: String(this.comprobante.direccion || "").trim(),
      };
    },
    validarDatosFiscales() {
      if (this.comprobante.tipo !== "fiscal") return true;
      var datos = this.datosFiscalesPayload();
      var faltante = [
        ["rncFiscal", "fiscalRnc"],
        ["nombreFiscal", "fiscalNombre"],
        ["direccionFiscal", "fiscalDireccion"],
      ].find((campo) => !datos[campo[0]]);
      var direccionLarga = datos.direccionFiscal.length > 150;
      var nombreLargo = datos.nombreFiscal.length > 250;
      var rnc = this.identificacionFiscalNormalizada();
      var rncInvalido = !/^\d{9}$|^\d{11}$/.test(rnc)
        || (this.consultaFiscal.consultada === rnc && this.consultaFiscal.identificacionValida === false);
      if (!faltante && !direccionLarga && !nombreLargo && !rncInvalido) return true;
      this.editarFiscal = true;
      this.mostrarMensaje(faltante ? "Debe completar los datos del cliente para credito fiscal: nombre, RNC/cedula y direccion."
        : rncInvalido ? "El RNC/cedula no es valido. Revise los digitos."
        : nombreLargo ? "El nombre fiscal no puede superar 250 caracteres."
        : "La direccion fiscal no puede superar 150 caracteres.", "error");
      this.$nextTick(() => {
        var campo = this.$refs[faltante ? faltante[1] : rncInvalido ? "fiscalRnc" : nombreLargo ? "fiscalNombre" : "fiscalDireccion"];
        if (campo) campo.focus();
      });
      return false;
    },
    ventaPayload() {
      var payload = {
        numeroViaje: String(this.turno.numeroViaje || ""),
        nombre: this.venta.nombre,
        telefono: this.venta.telefono,
        numeroMaleta: Number(this.venta.numeroMaleta || 0),
        precio: this.precioSeleccionado,
        descuento: Number(this.venta.descuento || 0),
        cantidad: Number(this.venta.cantidad || 1),
        recargo: Number(this.venta.recargo || 0),
        motivoRecargo: this.venta.motivoRecargo,
        valorCortesia: Number(this.pagos.valorCortesia || 0),
        tipoComprobante: this.comprobante.tipo === "fiscal" ? 2 : 1,
        ...this.datosFiscalesPayload(),
        efectivo: Number(this.pagos.efectivo || 0),
        cheque: Number(this.pagos.cheque || 0),
        tarjeta: Number(this.pagos.tarjeta || 0),
        transferencia: Number(this.pagos.transferencia || 0),
        notadecredito: Number(this.pagos.notadecredito || 0),
        credito: Number(this.pagos.credito || 0),
        pagoDestino: Number(this.pagos.pagoDestino || 0),
        caja: this.contexto.caja,
        numeroCierreCaja: 0,
        ficha: this.turno.ficha,
        chofer: this.turno.chofer,
        cajero: this.contexto.cajero,
        ruta: { id: this.rutaSeleccionada.id },
        sucursal: { codigo: Number(this.contexto.sucursalId) },
      };
      if (this.rutaSeleccionada.sucursalLlegada && this.rutaSeleccionada.sucursalLlegada.codigo) {
        payload.sucursalDestino = { codigo: Number(this.rutaSeleccionada.sucursalLlegada.codigo) };
      }
      if (this.turno.id) {
        payload.turnoDetalle = { id: this.turno.id };
      }
      var control = this.controlTurnoSeleccionado();
      if (control) {
        payload.controlTurno = { id: Number(control.id) };
      }
      if (this.cortesiaCompletaValidada()) payload.cortesia = { id: Number(this.cortesia.registro.id) };
      return payload;
    },
    envioPayload() {
      var control = this.controlTurnoSeleccionado();
      return {
        numeroViaje: String(this.turno.numeroViaje || ""),
        turnoDetalleId: this.turno.id ? Number(this.turno.id) : null,
        ficha: this.turno.ficha || "",
        chofer: this.turno.chofer || "",
        control: control ? Number(control.id) : null,
        horaSalida: this.turno.hora || "",
        cajaId: this.contexto.cajaId || (this.contexto.caja && this.contexto.caja.codigo ? this.contexto.caja.codigo : this.contexto.caja),
        sucursalId: Number(this.contexto.sucursalId || 0),
        numeroCierreCaja: 0,
        cajero: this.contexto.cajero,
        nombreRemitente: this.envio.remitente.nombre || "",
        cedulaRemitente: this.envio.remitente.cedula || "",
        telefonoRemitente: this.envio.remitente.telefono || "",
        direccionRemitente: this.envio.remitente.direccion || "",
        nombreDestinatario: this.envio.destinatario.nombre || "",
        telefonoDestinatario: this.envio.destinatario.telefono || "",
        documentoDestinatario: this.envio.destinatario.documento || "",
        direccionDestinatario: this.envio.destinatario.direccion || "",
        tipoEnvio: this.envio.tipo,
        descuento: Number(this.venta.descuento || 0),
        recargo: Number(this.venta.recargo || 0),
        motivoRecargo: this.venta.motivoRecargo || "",
        valorCortesia: Number(this.pagos.valorCortesia || 0),
        tipoComprobante: this.comprobante.tipo === "fiscal" ? 2 : 1,
        ...this.datosFiscalesPayload(),
        efectivo: Number(this.pagos.efectivo || 0),
        cheque: Number(this.pagos.cheque || 0),
        tarjeta: Number(this.pagos.tarjeta || 0),
        transferencia: Number(this.pagos.transferencia || 0),
        notadecredito: Number(this.pagos.notadecredito || 0),
        credito: Number(this.pagos.credito || 0),
        pagoDestino: Number(this.pagos.pagoDestino || 0),
        perecedero: Boolean(this.envio.perecedero),
        fragilesGlobal: Boolean(this.envio.fragilesGlobal),
        paquetes: this.envio.paquetes.map((paquete) => Object.assign({}, paquete)),
        impresion: {
          enviarDirecto: Boolean(this.impresion.enviarDirecto),
          copiasEtiqueta: Number(this.envio.copiasEtiqueta || 0),
          copiasFactura: Number(this.envio.copiasFactura || 0),
        },
      };
    },
    esImportePositivo(valor) {
      var importe = Number(valor);
      return Number.isFinite(importe) && Math.round(importe * 100) > 0;
    },
    cantidadFormasPago() {
      return Object.keys(this.nuevosPagos()).filter((campo) => {
        var monto = Number(this.pagos[campo]);
        return Number.isFinite(monto) && monto > 0;
      }).length;
    },
    mensajeBoletosGuardados(data) {
      var boletos = Array.isArray(data.boletos) ? data.boletos : [];
      var numeros = boletos.filter((boleto) => boleto && boleto.id).map((boleto) => String(boleto.id));
      if (!numeros.length) {
        var boleto = data.ventaTicket || data;
        if (boleto.id) numeros = [String(boleto.id)];
      }
      numeros = Array.from(new Set(numeros));
      return numeros.length > 1
        ? "Boletos guardados (" + numeros.length + "): " + numeros.join(", ")
        : "Boleto guardado: " + (numeros[0] || "OK");
    },
    finalizarVenta() {
      if (this.creandoTurno || this.guardando) {
        return;
      }
      var maletas = Number(this.venta.numeroMaleta || 0);
      if (!Number.isInteger(maletas) || maletas < 0 || maletas > 20) {
        this.mostrarMensaje("La cantidad de maletas debe ser un entero entre 0 y 20.", "error");
        return;
      }
      if (!this.rutaSeleccionada) {
        this.mostrarMensaje("Debe seleccionar una ruta.", "error");
        return;
      }
      if (!this.esImportePositivo(this.precioSeleccionado)) {
        this.mostrarMensaje("El precio de la ruta debe ser mayor que 0.", "error");
        return;
      }
      if (this.cortesia.registro && !this.cortesiaCompletaValidada()) {
        this.mostrarMensaje("La venta cambio. Lea nuevamente la cedula para aplicar cortesia.", "error");
        return;
      }
      if (!this.esImportePositivo(this.total) && !this.cortesiaCompletaValidada()) {
        this.mostrarMensaje("El total de la factura debe ser mayor que 0.", "error");
        return;
      }
      var formasPago = this.cantidadFormasPago();
      if (formasPago > 2) {
        this.mostrarMensaje("Debe digitar correctamente la forma de pago", "error");
        return;
      }
      if (formasPago === 0) {
        this.mostrarMensaje("Debe Digitar una Forma de Pago.", "error");
        return;
      }
      if (!this.validarDatosFiscales() || !this.validarTurnoVenta() || !this.validarControlFacturacion()) return;
      if (!this.validarCupos(Number(this.venta.cantidad))) return;
      if (!Number.isFinite(this.totalPagado) || Math.round(this.totalPagado * 100) < Math.round(this.total * 100)) {
        this.mostrarMensaje("El pago debe cubrir el total de la venta, incluidos los recargos.", "error");
        return;
      }
      this.guardando = true;
      var ventaConfirmada = false;
      var mensajeGuardado = "Venta guardada";
      return this.$axios.post(this.$hostname + this.$hName + "/transportepv/venta", this.ventaPayload(), { headers: this.headers() })
        .then(async (res) => {
          var data = res.data || {};
          if (data.estatus && data.estatus !== "ok") {
            if (data.estatus === "cerrado") await this.actualizarTurnosFacturacion(true);
            this.mostrarMensaje(data.mensaje || "No se pudo guardar el boleto.", "error");
            return;
          }
          ventaConfirmada = true;
          mensajeGuardado = this.mensajeBoletosGuardados(data);
          var ventaTicket = data.ventaTicket || data;
          var facturacionOk = await this.procesarFacturacionElectronicaSiAplica(data);
          var errorImpresion = null;
          var payloadImpresion = null;
          if (facturacionOk !== false || (data.facturasVenta || []).some((f) => f.aceptada === true)) {
            try {
              payloadImpresion = this.prepararImpresionBoletosVenta(data);
              await this.enviarImpresionPreparada(payloadImpresion);
            } catch (error) {
              errorImpresion = error;
            }
          }
          this.limpiarVenta();
          if (facturacionOk === false) {
            this.mostrarMensaje(mensajeGuardado + ". " + (data.ecfMensaje || "Emision pendiente; revise Comprobantes e-CF."), "error");
          } else if (!errorImpresion) {
            this.mostrarMensaje(mensajeGuardado, "ok");
          } else {
            this.mostrarErrorImpresion(mensajeGuardado, errorImpresion,
              this.crearReimpresionPendiente("boleto", ventaTicket && ventaTicket.id ? ventaTicket.id : "OK", payloadImpresion));
          }
        })
        .catch((error) => {
          if (ventaConfirmada) {
            this.limpiarVenta();
            this.mostrarMensaje(mensajeGuardado + ". No vuelva a facturar; revise Comprobantes e-CF o reimpresion.", "error");
            return;
          }
          var respuesta = error && error.response;
          var mensaje = respuesta && respuesta.status === 409 && typeof respuesta.data === "string" ? respuesta.data : "";
          this.mostrarMensaje(mensaje || "No se pudo guardar. Revise conexion/API.", "error");
        })
        .finally(async () => {
          try {
            if (ventaConfirmada) {
              var mensajeVenta = this.mensaje;
              var tipoMensajeVenta = this.mensajeTipo;
              var reimpresion = this.reimpresionPendiente;
              // Refresh after printing so the receipt keeps the trip that was sold.
              await this.actualizarTurnosFacturacion(true);
              if (this.mensaje !== mensajeVenta) {
                this.mostrarMensaje(mensajeVenta + ". " + this.mensaje,
                  tipoMensajeVenta === "error" ? "error" : this.mensajeTipo, reimpresion);
              }
            }
          } finally {
            this.guardando = false;
          }
        });
    },
    finalizarEnvio() {
      if (this.guardando || this.creandoTurno) return;
      if (this.editandoPaqueteEnvio) {
        this.mostrarMensaje("Debe guardar o cancelar la edicion del paquete antes de facturar.", "error");
        this.enfocarCampoEnvioPaquete("envioAgregar");
        return;
      }
      if (!this.envio.paquetes.length) {
        this.mostrarMensaje("Debe agregar al menos un paquete.", "error");
        return;
      }
      if (!this.envio.remitente.nombre || !this.envio.destinatario.nombre) {
        this.mostrarMensaje("Debe completar remitente y destinatario.", "error");
        return;
      }
      if (this.envio.paquetes.some((paquete) => !this.esImportePositivo(paquete.precio))) {
        this.mostrarMensaje("El precio de cada envio debe ser mayor que 0.", "error");
        return;
      }
      if (!this.esImportePositivo(this.totalEnvio)) {
        this.mostrarMensaje("El total de la factura debe ser mayor que 0.", "error");
        return;
      }
      if (this.cantidadFormasPago() > 2) {
        this.mostrarMensaje("Debe digitar correctamente la forma de pago", "error");
        return;
      }
      if (!this.validarDatosFiscales() || !this.validarTurnoVenta() || !this.validarControlFacturacion()) return;
      if (this.asientosEnvio > 0 && !this.validarCupos(this.asientosEnvio)) return;
      if (this.asientosEnvio > 0 && Math.round(this.totalPagado * 100) < Math.round(this.totalEnvio * 100)) {
        this.mostrarMensaje("El pago debe cubrir el envio y los boletos de los asientos.", "error");
        return;
      }
      this.guardando = true;
      var ventaConfirmada = false;
      return this.$axios.post(this.$hostname + this.$hName + "/transportepv/envios", this.envioPayload(), { headers: this.headers() })
        .then(async (res) => {
          var data = res.data || {};
          if (data.estatus && data.estatus !== "ok") {
            if (data.estatus === "cerrado") await this.actualizarTurnosFacturacion(true);
            this.mostrarMensaje(data.mensaje || "No se pudo guardar el envio.", "error");
            return;
          }
          ventaConfirmada = true;
          var facturacionOk = await this.procesarFacturacionElectronicaSiAplica(data);
          var errorImpresion = null;
          var payloadImpresion = null;
          if (facturacionOk !== false || (data.facturasVenta || []).some((f) => f.aceptada === true)) {
            try {
              payloadImpresion = this.prepararImpresionEnvioPaquete(data);
              if (Array.isArray(data.boletosAsientos) && data.boletosAsientos.length) {
                payloadImpresion = [payloadImpresion, this.prepararImpresionBoletosVenta({
                  boletos: data.boletosAsientos, facturasVenta: data.facturasVenta,
                  facturacionElectronica: data.facturacionElectronica,
                })].filter(Boolean);
              }
              await this.enviarImpresionPreparada(payloadImpresion);
            } catch (error) {
              errorImpresion = error;
            }
          }
          this.limpiarEnvio();
          if (facturacionOk === false) {
            this.mostrarMensaje(data.ecfMensaje || "Envio guardado. Emision pendiente; revise Comprobantes e-CF.", "error");
          } else if (!errorImpresion) {
            this.mostrarMensaje("Envio guardado: " + (data.noEnvio || "OK"), "ok");
          } else {
            this.mostrarErrorImpresion("Envio guardado: " + (data.noEnvio || "OK"), errorImpresion,
              this.crearReimpresionPendiente("envio", data.noEnvio || "OK", payloadImpresion));
          }
        })
        .catch((error) => {
          if (ventaConfirmada) {
            this.limpiarEnvio();
            this.mostrarMensaje("Envio guardado. No vuelva a facturar; revise Comprobantes e-CF o reimpresion.", "error");
            return;
          }
          var respuesta = error && error.response;
          var mensaje = respuesta && respuesta.status === 409 && typeof respuesta.data === "string" ? respuesta.data : "";
          this.mostrarMensaje(mensaje || "No se pudo guardar el envio. Revise conexion/API.", "error");
        })
        .finally(async () => {
          try {
            if (ventaConfirmada) {
              var mensaje = this.mensaje, tipo = this.mensajeTipo, pendiente = this.reimpresionPendiente;
              await this.actualizarTurnosFacturacion(true);
              if (this.mensaje !== mensaje) this.mostrarMensaje(mensaje + ". " + this.mensaje, tipo, pendiente);
            }
          } finally { this.guardando = false; }
        });
    },
    ventaRequiereEcf(data) {
      data = data || {};
      if (data.facturacionElectronica && data.facturacionElectronica.habilitada === true) return true;
      var documentos = [data.facturaVenta, data.ventaTicket].concat(
        Array.isArray(data.facturasVenta) ? data.facturasVenta : [],
        Array.isArray(data.boletos) ? data.boletos : [],
        Array.isArray(data.envios) ? data.envios : []);
      return documentos.some((documento) => documento && /^E/i.test(String(documento.ncf || "").trim()));
    },
    async procesarFacturacionElectronicaSiAplica(data) {
      var info = data && data.facturacionElectronica ? data.facturacionElectronica : null;
      if (!this.contexto.facturacionElectronicaActiva && !this.ventaRequiereEcf(data)) {
        return true;
      }
      if (!info || info.habilitada !== true) {
        data.ecfMensaje = "Venta guardada sin confirmacion electronica. Revise que e-CF este activo en la caja y su sucursal; no vuelva a facturar ni imprimir como comprobante convencional.";
        return false;
      }
      var facturas = Array.isArray(data.facturasVenta) && data.facturasVenta.length ? data.facturasVenta : (data.facturaVenta ? [data.facturaVenta] : []);
      if (!facturas.length) {
        data.ecfMensaje = "Venta guardada. Falta la identidad de la factura; revise Comprobantes e-CF.";
        return false;
      }
      data.facturasVenta = facturas;
      var pendientes = [];
      for (var factura of facturas) {
        try {
          var respuesta = await this.facturacionEletronicaGet(factura);
          Object.assign(factura, respuesta);
          this.recordarComprobanteElectronico(factura);
          if (respuesta.aceptada !== true) pendientes.push(factura.ncf + ": " + (respuesta.mensaje || respuesta.estado || "INCIERTO"));
        } catch (error) {
          factura.aceptada = false;
          factura.estado = "INCIERTO";
          factura.mensaje = this.mensajeErrorElectronico(error);
          this.recordarComprobanteElectronico(factura);
          pendientes.push((factura.ncf || this.claveFactura(factura)) + ": " + factura.mensaje);
        }
      }
      data.facturaVenta = facturas[0];
      data.ecfMensaje = pendientes.length ? "Venta guardada. Revise Comprobantes e-CF: " + pendientes.join(", ") : "";
      return pendientes.length === 0;
    },
    async facturacionEletronicaGet(factura) {
      var pk = factura && factura.facturasventaPK;
      if (!pk || !pk.documento || !pk.secuencia) throw new Error("Falta la identidad de la factura.");
      var res = await this.$axios.post(this.$hostname + this.$hName + "/transportepv/ecf/" + pk.documento + "/" + pk.secuencia, null,
        { headers: this.headers(), params: { cajaId: this.contexto.cajaId || this.contexto.caja }, timeout: 180000 });
      var r = res.data;
      if (!r || typeof r !== "object" || this.claveFactura(r) !== this.claveFactura(factura)) throw new Error("Respuesta electronica invalida.");
      r.aceptada = r.aceptada === true && ["ACEPTADO", "ACEPTADO_CONDICIONAL"].includes(r.estado) && !!r.documentoFiscal;
      return r;
    },
    mensajeErrorElectronico(error) {
      var respuesta = error && error.response;
      var status = respuesta && respuesta.status;
      var detalle = respuesta && respuesta.data;
      if (status === 401 || status === 403) return "API HTTP " + status + ": no se autorizo el procesamiento e-CF. Revise la sesion. La venta sigue guardada.";
      if (status === 404) return "API HTTP 404: no se encontro el servicio e-CF. Verifique que la API y TransporNet esten actualizados.";
      var mensaje = typeof detalle === "string" ? detalle : detalle && detalle.message;
      if (mensaje && mensaje.length <= 500 && !/[<>]/.test(mensaje)) return "API" + (status ? " HTTP " + status : "") + ": " + mensaje;
      return "Venta guardada. " + (status ? "API HTTP " + status + ". " : "No se pudo confirmar la conexion con la API. ") + "Consulte este mismo comprobante; no vuelva a facturar.";
    },
    async descargarXmlElectronico(factura, tipo) {
      if (this.ecf.procesando || !["completo", "envio"].includes(tipo)) return;
      var pk = factura && factura.facturasventaPK;
      if (!pk || !pk.documento || !pk.secuencia) return;
      this.ecf.procesando = this.claveFactura(factura);
      this.ecf.error = "";
      try {
        var r = await this.$axios.get(this.$hostname + this.$hName + "/transportepv/ecf/" + pk.documento + "/" + pk.secuencia + "/xml",
          { headers: this.headers(), params: { cajaId: this.contexto.cajaId || this.contexto.caja, tipo: tipo }, responseType: "blob", timeout: 20000 });
        var contenido = r.headers && r.headers["content-type"] || "";
        if (!contenido.includes("xml")) throw new Error("Respuesta XML invalida.");
        var url = URL.createObjectURL(r.data);
        var enlace = document.createElement("a");
        try {
          enlace.href = url;
          enlace.download = String(factura.ncf || "factura").replace(/[^A-Za-z0-9_-]/g, "") + "-" + tipo + ".xml";
          document.body.appendChild(enlace);
          enlace.click();
        } finally {
          enlace.remove();
          setTimeout(() => URL.revokeObjectURL(url), 1000);
        }
      } catch (error) {
        this.ecf.error = "No se pudo descargar el XML. " + this.mensajeErrorElectronico(error);
      } finally { this.ecf.procesando = ""; }
    },
    claveFactura(factura) {
      var pk = factura && factura.facturasventaPK || {};
      return String(pk.documento || "") + "/" + String(pk.secuencia || "");
    },
    recordarComprobanteElectronico(factura) {
      var clave = this.claveFactura(factura);
      var indice = this.ecf.facturas.findIndex((f) => this.claveFactura(f) === clave);
      if (indice >= 0) this.ecf.facturas.splice(indice, 1, factura);
      else {
        if (this.ecf.pagina !== 0) this.ecf.facturas = [];
        this.ecf.pagina = 0;
        this.ecf.facturas = [factura].concat(this.ecf.facturas).slice(0, 100);
      }
    },
    abrirComprobantesElectronicos() {
      if (this.EjecutarPermisoPv == false) {
          this.funcionValidaPermisoPv('AccComprobantesECFTrasporte')
          return;
        } 
    },

    continuarAbrirComprobantesElectronicos() {
if (this.ecf.cargando || this.ecf.procesando) return;
      this.ecf.facturas = [];
      this.ecf.pagina = 0;
      this.ecf.busquedaNcf = "";
      this.ecf.ncfFiltro = "";
      this.ecf.visible = true;
      return this.cargarComprobantesElectronicos(0);
    },


    buscarComprobantesElectronicos() {
      var ncf = (this.ecf.busquedaNcf || "").trim().toUpperCase();
      if (ncf && !/^[A-Z0-9]{1,13}$/.test(ncf)) {
        this.ecf.error = "El NCF solo admite letras y numeros, hasta 13 caracteres.";
        return;
      }
      return this.cargarComprobantesElectronicos(0, ncf);
    },
    limpiarBusquedaComprobantes() {
      if (this.ecf.cargando || this.ecf.procesando) return;
      this.ecf.busquedaNcf = "";
      return this.buscarComprobantesElectronicos();
    },
    async cargarComprobantesElectronicos(pagina = 0, ncf = this.ecf.ncfFiltro || "") {
      if (this.ecf.cargando || this.ecf.procesando) return;
      var caja = this.contexto.cajaId || this.contexto.caja;
      this.ecf.cargando = true;
      this.ecf.error = "";
      try {
        var params = { cajaId: caja, pagina: pagina };
        if (ncf) params.ncf = ncf;
        var r = await this.$axios.get(this.$hostname + this.$hName + "/transportepv/ecf", { headers: this.headers(), params: params, timeout: 20000 });
        if (!Array.isArray(r.data)) throw new Error("Respuesta de consulta invalida.");
        if (caja === (this.contexto.cajaId || this.contexto.caja)) {
          this.ecf.facturas = r.data;
          this.ecf.pagina = pagina;
          this.ecf.ncfFiltro = ncf;
        }
      } catch (error) {
        this.ecf.error = "No se pudieron consultar los e-CF. Las ventas guardadas no deben facturarse otra vez.";
      } finally { this.ecf.cargando = false; }
    },
    async reintentarComprobanteElectronico(factura) {
      if (this.ecf.procesando) return;
      this.ecf.procesando = this.claveFactura(factura);
      this.ecf.error = "";
      try { this.recordarComprobanteElectronico(await this.facturacionEletronicaGet(factura)); }
      catch (error) { this.ecf.error = this.mensajeErrorElectronico(error); }
      finally { this.ecf.procesando = ""; }
    },
    async reimprimirComprobanteElectronico(factura) {
      if (this.ecf.procesando || !factura.aceptada || !factura.documentoFiscal) return;
      this.ecf.procesando = this.claveFactura(factura);
      this.ecf.error = "";
      try {
        var impresora = this.impresoraSeleccionada() || "";
        if (Array.isArray(factura.documentoFiscal.envios) && factura.documentoFiscal.envios.length) {
          var envioPayload = this.prepararOperacionImpresion({ accion: "print", formato: "TicketEnvio", impresora: impresora,
            reimpresionConsultaComprobante: true,
            copiasFactura: 0, copiasEtiqueta: 1, impresoraEtiquetasEnvio: this.contexto.impresoraEtiquetasEnvio || "0",
            factura: factura, documentoFiscal: factura.documentoFiscal,
            envios: factura.documentoFiscal.envios.map((envio) => this.envioImpresion(envio)) }, "envio-paquete-transporte");
          await this.enviarImpresionPreparada(envioPayload);
          return;
        }
        if (!factura.documentoFiscal.boleto) {
          this.ecf.error = "Este comprobante antiguo no conserva el detalle de transporte. Reimprima desde la consulta del envio original.";
          return;
        }
        var boleto = Object.assign({}, factura.documentoFiscal.boleto || {}, { ncf: factura.ncf, documentoFiscal: factura.documentoFiscal });
        var payload = this.prepararOperacionImpresion({ accion: "print", formato: "TicketViaje", impresora: impresora,
          reimpresionConsultaComprobante: true,
          copias: 0, copiasPequeno: 0, imprimirPequeno: false, imprimirMaletas: false,
          boletos: [boleto] }, "boleto-transporte");
        await this.enviarImpresionPreparada(payload);
      } catch (error) { this.ecf.error = "No se pudo confirmar la impresion. Revise la impresora antes de reimprimir."; }
      finally { this.ecf.procesando = ""; }
    },
    async imprimirBoletosVenta(data) {
      await this.enviarImpresionPreparada(this.prepararImpresionBoletosVenta(data));
    },
    prepararImpresionBoletosVenta(data) {
      this.impresion.enviarDirecto = true;
      var boletos = Array.isArray(data.boletos) ? data.boletos : [];
      if (boletos.length === 0 && data.ventaTicket) {
        boletos = [data.ventaTicket];
      }
      if (boletos.length === 0) {
        return null;
      }
      var impresora = this.impresoraSeleccionada() || "";
      var facturas = data.facturasVenta || (data.facturaVenta ? [data.facturaVenta] : []);
      var electronica = this.ventaRequiereEcf(data);
      var documentos = boletos.map((boleto, index) => {
        var factura = facturas.find((f) => boleto.facturasventaPK && this.claveFactura(f) === this.claveFactura(boleto))
          || facturas.find((f) => boleto.ncf && f.ncf === boleto.ncf) || (!electronica ? facturas[index] : null) || {};
        if (electronica && (factura.aceptada !== true || !factura.documentoFiscal)) return null;
        var impresion = this.boletoImpresion(boleto, index, factura);
        if (electronica) {
          Object.assign(impresion, factura.documentoFiscal.boleto || {});
          impresion.documentoFiscal = factura.documentoFiscal;
        }
        return impresion;
      }).filter(Boolean);
      if (!documentos.length) return null;
      // Las maletas son del grupo: el sistema anterior las imprime con el primer boleto aceptado.
      documentos.forEach((boleto, index) => { if (index > 0) boleto.cantidad_maletas = 0; });
      var payload = {
        accion: "print",
        formato: this.impresion.formato,
        impresora: impresora,
        imprimirMaletas: Number(documentos[0].cantidad_maletas || 0) > 0,
        impresoraEtiquetas: this.contexto.impresoraEtiquetas || "",
        copias: Number(this.impresion.copias || 0),
        copiasPequeno: Number(this.impresion.copiasPequeno || 0),
        boletos: documentos,
      };
      return this.prepararOperacionImpresion(payload, "boleto-transporte");
    },
    async imprimirEnvioPaquete(data) {
      await this.enviarImpresionPreparada(this.prepararImpresionEnvioPaquete(data));
    },
    prepararImpresionEnvioPaquete(data) {
      if (this.ventaRequiereEcf(data) && !(data.facturaVenta && data.facturaVenta.aceptada === true && data.facturaVenta.documentoFiscal)) return null;
      var enviarDirecto = Boolean(this.impresion.enviarDirecto);
      var envios = Array.isArray(data.envios) ? data.envios : [];
      if (!envios.length) {
        return null;
      }
      var impresora = this.impresoraSeleccionada() || "";
      var copiasExtraEtiqueta = Number(this.envio.copiasEtiqueta || 0);
      copiasExtraEtiqueta = Number.isFinite(copiasExtraEtiqueta) ? Math.max(0, Math.trunc(copiasExtraEtiqueta)) : 0;
      var payload = {
        accion: enviarDirecto ? "print" : "preview",
        enviarDirecto: enviarDirecto,
        formato: "TicketEnvio",
        impresora: impresora,
        copiasFactura: enviarDirecto ? Number(this.envio.copiasFactura || 0) : 0,
        // El campo contiene copias adicionales; ImpresoraWeb recibe la cantidad total por paquete.
        copiasEtiqueta: enviarDirecto ? 1 + copiasExtraEtiqueta : 1,
        impresoraEtiquetasEnvio: this.contexto.impresoraEtiquetasEnvio || "0",
        factura: data.facturaVenta || null,
        documentoFiscal: data.facturaVenta && data.facturaVenta.aceptada === true ? data.facturaVenta.documentoFiscal : null,
        envios: envios.map((envio) => this.envioImpresion(envio)),
      };
      return this.prepararOperacionImpresion(payload, "envio-paquete-transporte");
    },
    async enviarImpresionPreparada(payload) {
      if (payload && (this.contexto.vistaPreviaPdf || payload.operacion === "recargo-entrega")) {
        const documentos = [];
        for (const operacion of (Array.isArray(payload) ? payload : [payload])) {
          if (!operacion) continue;
          if (operacion.operacion === "boleto-transporte") {
            (operacion.boletos || []).forEach(b => documentos.push({ tipo: "tickets", referencia: String(b.numero_boleto) }));
          } else if (operacion.operacion === "envio-paquete-transporte") {
            (operacion.envios || []).forEach(e => documentos.push({ tipo: "envios", referencia: String(e.numero_envio),
              copiasEtiqueta: Number(operacion.copiasEtiqueta || 0), copiasFactura: Number(operacion.copiasFactura || 0),
              etiquetadora: !["", "0", "null", "undefined"].includes(String(operacion.impresoraEtiquetasEnvio || "0").trim().toLowerCase()) }));
          } else if (operacion.operacion === "recargo-entrega") {
            documentos.push({ tipo: "recargos-entrega", referencia: operacion.noEnvio });
          } else throw new Error("Vista previa PDF disponible para ventas de boletos y envios.");
        }
        if (!documentos.length) return;
        this.previewPdf = { visible: true, blob: null, cargando: true, error: "" };
        try {
          const respuesta = await this.$axios.post(this.$hostname + this.$hName + "/transportepv/impresion/pdf", documentos,
            { headers: this.headers(), responseType: "blob", timeout: 120000 });
          if (!(respuesta.data instanceof Blob) || !respuesta.data.size || !respuesta.data.type.includes("application/pdf")) throw new Error("El servidor no devolvio un PDF valido.");
          this.previewPdf.blob = respuesta.data;
        } catch (error) {
          let mensaje = "No se pudo generar la vista previa. La venta sigue guardada; cierre esta ventana y use Reimprimir para intentar de nuevo.";
          if (error.response && error.response.data instanceof Blob) {
            try { const data = JSON.parse(await error.response.data.text()); if (data.message) mensaje += " " + data.message; } catch (_) { /* Keep fallback. */ }
          }
          this.previewPdf.error = mensaje;
          throw error;
        } finally { this.previewPdf.cargando = false; }
        return;
      }
      if (Array.isArray(payload)) {
        for (var documento of payload) await this.enviarImpresionPreparada(documento);
        return;
      }
      if (!payload) {
        return;
      }
      await this.postImpresoraLocal("/impresora/imprimir", payload);
    },
    crearReimpresionPendiente(tipo, referencia, payload) {
      if (!payload) {
        return null;
      }
      return {
        tipo: tipo,
        referencia: referencia,
        payload: JSON.parse(JSON.stringify(payload)),
        imprimiendo: false,
        confirmacionPendiente: false,
      };
    },
    async reimprimirPendiente() {
      var pendiente = this.reimpresionPendiente;
      if (!pendiente || !pendiente.payload || pendiente.imprimiendo) {
        return;
      }
      if (pendiente.confirmacionPendiente && !window.confirm("La impresora pudo haber impreso estos documentos. Verifique el papel y la cola de impresion. Reimprimir puede generar duplicados. Desea continuar?")) {
        return;
      }
      pendiente.imprimiendo = true;
      try {
        await this.enviarImpresionPreparada(JSON.parse(JSON.stringify(pendiente.payload)));
        var referencia = pendiente.referencia;
        this.reimpresionPendiente = null;
        this.mostrarMensaje((this.contexto.vistaPreviaPdf ? "Vista previa preparada: " : "Documento enviado a reimpresion: ") + referencia, "ok");
      } catch (error) {
        pendiente.imprimiendo = false;
        this.mostrarErrorImpresion("Documento: " + pendiente.referencia, error, pendiente);
      }
    },
    async imprimirEntregaPaquete(data) {
      var guardado = data && data.envio ? data.envio : this.entrega.envio;
      if (guardado && guardado.recargo_entrega_documento && guardado.recargo_entrega_secuencia) {
        await this.enviarImpresionPreparada({ operacion: "recargo-entrega", noEnvio: guardado.no_envio });
        if (this.contexto.vistaPreviaPdf) return;
      }
      if (!this.impresion.enviarDirecto) {
        return;
      }
      var envio = data && data.envio ? data.envio : this.entrega.envio;
      if (!envio) {
        return;
      }
      var impresora = this.impresoraSeleccionada();
      if (!impresora) {
        throw new Error("Seleccione la impresora para imprimir el recibo de entrega.");
      }
      if (envio.firma_excedida) throw new Error("La firma guardada excede el tamano permitido para imprimir.");
      var payload = {
        accion: "print",
        formato: "reciboEntregaPaquete",
        fotoFirma: envio.foto_firma || "",
        impresora: impresora,
        copias: Number(this.impresion.copias || 0),
        envios: [this.entregaImpresion(envio)],
      };
      await this.postImpresoraLocal("/impresora/imprimir", this.prepararOperacionImpresion(payload, "entrega-paquete-transporte"));
    },
    entregaImpresion(envio) {
      var configGeneral = this.configuracionGeneral();
      var config = configGeneral.config || {};
      // The independent surcharge invoice already contains its share of the payment.
      var pagosEntrega = envio.recargo_entrega_documento ? {
        efectivo: envio.efectivo_d || 0, cheque: envio.cheque_d || 0,
        credito: envio.credito_d || 0, tarjeta: envio.tarjeta_d || 0,
        notadecredito: envio.notacredito_d || 0, transferencia: envio.transferencia_d || 0,
      } : null;
      return {
        numero_envio: envio.no_envio || envio.noEnvio || "",
        d_origen: envio.ruta_origen || "",
        d_destino: envio.ruta_destino || "",
        descripcion: envio.descripcion || "",
        telefono_destinatario: envio.telefono_destinatario || "",
        nombre_destinatario: envio.nombre_destinatario || "",
        telefono_remitente: envio.telefono_remitente || "",
        nombre_remitente: envio.nombre_remitente || "",
        chofer: envio.conductor || envio.nombre_chofer || "",
        ficha: envio.ficha || "",
        valor_declarado: String(envio.valor_declarado || 0),
        recargo: Number(envio.monto_recargo || 0),
        motivo_recargo: envio.motivo_recargo || "",
        pago_destino: Number(envio.pago_destino || 0),
        efectivo: Number(pagosEntrega ? pagosEntrega.efectivo : this.pagos.efectivo || envio.efectivo || 0),
        cheque: Number(pagosEntrega ? pagosEntrega.cheque : this.pagos.cheque || envio.cheque || 0),
        credito: Number(pagosEntrega ? pagosEntrega.credito : this.pagos.credito || envio.credito || 0),
        tarjeta: Number(pagosEntrega ? pagosEntrega.tarjeta : this.pagos.tarjeta || envio.tarjeta || 0),
        notacredito: Number(pagosEntrega ? pagosEntrega.notadecredito : this.pagos.notadecredito || envio.notacredito || 0),
        transferencia: Number(pagosEntrega ? pagosEntrega.transferencia : this.pagos.transferencia || envio.transferencia || 0),
        puntos: 0,
        cedulaRecibida: this.entrega.cedulaEntrega || envio.cedula_entrega || "",
        empresa: config.nombre || "",
        telefonoEmpresa: config.telefono || "",
        direccionEmpresa: config.direccion || "",
        rncEmpresa: config.rnc || "",
        logo: config.logo || "",
        caja: this.contexto.cajaNombre || "",
        cajera: this.contexto.cajero || "",
      };
    },
    envioImpresion(envio) {
      var configGeneral = this.configuracionGeneral();
      var config = configGeneral.config || {};
      var noEnvio = envio.noEnvio || envio.no_envio || "";
      var origenNombre = String(envio.origenNombre || this.contexto.sucursal || "").trim();
      var destinoNombre = String(envio.destinoNombre || envio.destino_nombre || envio.ruta_destino || envio.destino || "").trim();
      if (destinoNombre.indexOf("->") >= 0) {
        var partesRutaEnvio = this.partesNombreRuta(destinoNombre);
        origenNombre = partesRutaEnvio.origen || origenNombre;
        destinoNombre = partesRutaEnvio.destino || destinoNombre;
      }
      var nombreRemitente = envio.nombreRemitente || envio.nombre_remitente || this.envio.remitente.nombre || "";
      var telefonoRemitente = envio.telefonoRemitente || envio.telefono_remitente || this.envio.remitente.telefono || "";
      var cedulaRemitente = envio.cedulaRemitente || envio.cedula_remitente || this.envio.remitente.cedula || "";
      var cantidadLbPies = Number(envio.cantidadLbPies || envio.cantidad_lb_pies || 0);
      var valorDeclarado = Number(envio.valorDeclarado || envio.valor_declarado || 0);
      var precioEnvio = Number(envio.precioEnvio || envio.precio_envio || envio.precio || 0);
      var impuestos = Number(envio.impuestos || envio.itbis || 0);
      var totalEnvio = Number(envio.precioTotal || envio.precio_total || envio.total || (precioEnvio + impuestos));
      var empresaImpresion = String(this.contexto.sucursal || config.nombre || "").trim();
      return {
        numero_envio: noEnvio,
        ncf: envio.ncf || "",
        d_origen: origenNombre,
        d_destino: destinoNombre,
        c_origen: "",
        c_destino: "",
        nombre_destinatario: envio.nombreDestinatario || this.envio.destinatario.nombre || "",
        telefono_destinatario: envio.telefonoDestinatario || this.envio.destinatario.telefono || "",
        nombre_remitente: nombreRemitente,
        telefono_remitente: telefonoRemitente,
        cedula_remitente: cedulaRemitente,
        nombrecomprobante: nombreRemitente,
        rnccedula: cedulaRemitente,
        cedulacomprobante: cedulaRemitente,
        nombre_cliente: nombreRemitente,
        descripcion: envio.descripcion || "",
        cantidad_lib_pies: cantidadLbPies,
        valor_declarado: String(valorDeclarado),
        tipo_envio: envio.tipoEnvio || this.envio.tipo || "",
        tipo_pago: envio.tipoPago || "",
        documento_factura: envio.documentoFactura || "",
        no_viaje: envio.noViaje || this.turno.numeroViaje || "",
        fecha: envio.fecha || this.fechaTrabajoReporte,
        hora_salida: this.turno.hora || "",
        ficha: envio.ficha || this.turno.ficha || "",
        precio: precioEnvio,
        subtotal: precioEnvio,
        itbis: impuestos,
        total: totalEnvio,
        descuento: Number(envio.descuento || 0),
        recargo: Number(envio.montoRecargo || 0),
        cortesia: Number(envio.cortesia || 0),
        efectivo: Number(envio.efectivo || 0),
        tarjeta: Number(envio.tarjeta || 0),
        cheque: Number(envio.cheque || 0),
        notacredito: Number(envio.notadecredito || 0),
        credito: Number(envio.credito || 0),
        transferencia: Number(envio.transferencia || 0),
        pagoDestino: Number(envio.pagoDestino || 0),
        pago_destino: Number(envio.pagoDestino || 0),
        es_fragil: Boolean(envio.isProductosFragiles),
        es_perecedero: Boolean(envio.isProductosPerecederos),
        activado: envio.activado !== false,
        empresa: empresaImpresion,
        direccionEmpresa: "",
        telefonoEmpresa: config.telefono || "",
        rncEmpresa: config.rnc || "",
        logo: config.logo || "",
        caja: this.contexto.cajaNombre || "",
        cajera: envio.cajero || this.contexto.cajero || "",
        control_turno: this.nombreControlSeleccionado(),
        politicas: this.politicasImpresion.envio,
        hora_registro: envio.horaRegistro || envio.hora_registro || "",
      };
    },
    boletoImpresion(boleto, index, facturaVenta) {
      var configGeneral = this.configuracionGeneral();
      var config = configGeneral.config || {};
      var factura = facturaVenta || {};
      var rutaBoleto = boleto.ruta || this.rutaSeleccionada || {};
      var origen = rutaBoleto.sucursalSalida || {};
      var destino = rutaBoleto.sucursalLlegada || {};
      var origenNombre = String(origen.descripcion || this.contexto.sucursal || "").trim();
      var destinoNombre = String(destino.descripcion || "").trim();
      var rutaDescripcion = [origenNombre, destinoNombre]
        .filter((valor) => String(valor || "").trim() !== "")
        .join(" -> ");
      var empresaImpresion = String(origen.descripcion || this.contexto.sucursal || config.nombre || "").trim();
      var direccionImpresion = String(origen.direccion || this.contexto.sucursalDireccion || config.direccion || "").trim();
      var telefonoImpresion = String(origen.telefono || this.contexto.sucursalTelefono || config.telefono || "").trim();
      var rncImpresion = String(origen.rnc || this.contexto.sucursalRnc || config.rnc || "").trim();
      var subtotalBoleto = Number(boleto.precio || this.precioSeleccionado || 0);
      var descuentoBoleto = Number(boleto.descuento || 0);
      var recargoBoleto = Number(boleto.recargo || 0);
      var cortesiaBoleto = Number(boleto.valorCortesia || 0);
      var totalBoleto = Math.max(0, subtotalBoleto + recargoBoleto - descuentoBoleto - cortesiaBoleto);
      return {
        numero_boleto: boleto.id ? String(boleto.id) : "",
        ncf: boleto.ncf || "",
        ruta_descripcion: rutaDescripcion || this.nombreRuta(rutaBoleto),
        d_origen: origenNombre,
        d_destino: destinoNombre || this.nombreRuta(rutaBoleto),
        c_origen: origen.codigo ? String(origen.codigo) : String(this.contexto.sucursalId || ""),
        c_destino: destino.codigo ? String(destino.codigo) : "",
        nombre_cliente: boleto.nombre != null ? boleto.nombre : (this.venta.nombre || ""),
        cantidad_maletas: Number(boleto.numeroMaleta != null ? boleto.numeroMaleta : (this.venta.numeroMaleta || 0)),
        telefono_cliente: boleto.telefono != null ? boleto.telefono : (this.venta.telefono || ""),
        rnccedula: "",
        c_tipocomprobante: this.comprobante.tipo === "fiscal" ? "2" : "1",
        n_tipocomprobante: this.comprobante.tipo === "fiscal" ? "Comprobante fiscal" : "Consumidor final",
        cedulacomprobante: this.comprobante.rnc || "",
        telefonocomprobante: this.venta.telefono || "",
        nombrecomprobante: this.comprobante.nombre || "",
        no_viaje: this.turno.numeroViaje || "",
        c_ruta: rutaBoleto.id ? String(rutaBoleto.id) : "",
        fecha: this.fechaTrabajoReporte,
        hora_salida: this.turno.hora || "",
        ficha: this.turno.ficha || "",
        chofer: this.turno.chofer || "",
        subtotal: subtotalBoleto,
        itbis: 0,
        total: totalBoleto,
        descuento: descuentoBoleto,
        recargo: recargoBoleto,
        cortesia: cortesiaBoleto,
        efectivo: Number(boleto.efectivo || 0),
        tarjeta: Number(boleto.tarjeta || 0),
        cheque: Number(boleto.cheque || 0),
        notacredito: Number(boleto.notadecredito || 0),
        credito: Number(boleto.credito || 0),
        puntos: Number(boleto.punto || 0),
        valor_cortesia: cortesiaBoleto,
        transferencia: Number(boleto.transferencia || 0),
        pagoDestino: Number(boleto.pagoDestino || 0),
        status: true,
        motivo_recargo: this.venta.motivoRecargo || "",
        empresa: empresaImpresion,
        direccionEmpresa: direccionImpresion,
        telefonoEmpresa: telefonoImpresion,
        rncEmpresa: rncImpresion,
        logo: config.logo || "",
        caja: this.contexto.cajaNombre || "",
        valido_hasta: "",
        precio: subtotalBoleto,
        devuelta: !boleto.esAsientoEnvioPaquete && index === 0 && Number(this.venta.cantidad || 1) === 1 ? ("Recibido en efectivo: " + this.moneda(this.pagos.efectivo) + "\nDevuelta: " + this.moneda(this.devuelta)) : "",
        codigo_barras: boleto.id ? String(boleto.id) : "",
        cajera: this.contexto.cajero || "",
        control_turno: this.nombreControlSeleccionado(),
        politicas: this.politicasImpresion.boleto,
        es_asiento_envio_paquete: Boolean(boleto.esAsientoEnvioPaquete),
        no_envio: boleto.noEnvioPadre || "",
        qrdgii: boleto.qrdgii || factura.qrdgii || "",
        codsegdgii: boleto.codsegdgii || factura.codsegdgii || "",
        qrDgiiImagen: null,
      };
    },
    impresoraSeleccionada() {
      if (this.contexto.impresoraTickets) {
        return this.contexto.impresoraTickets;
      }
      try {
        var seleccion = localStorage.printerSelect ? JSON.parse(localStorage.printerSelect) : null;
        return seleccion && seleccion.nombre ? seleccion.nombre : null;
      } catch (e) {
        return null;
      }
    },
    prepararOperacionImpresion(datos, operacion) {
      datos.operacion = operacion;
      datos.schema = this.headers()["X-TENANT-ID"];
      return datos;
    },
    urlImpresoraLocal(path) {
      return ["http://localhost:15999" + path, "http://127.0.0.1:15999" + path];
    },
    tiempoEsperaImpresion(datos) {
      if (!datos || datos.operacion !== "boleto-transporte") {
        return 60000;
      }
      var copias = (valor) => Number.isFinite(Number(valor)) ? Math.max(0, Math.trunc(Number(valor))) : 0;
      var cantidad = Array.isArray(datos.boletos) ? Math.max(1, datos.boletos.length) : 1;
      var imprimirPequeno = datos.imprimirPequeno === undefined || String(datos.imprimirPequeno).toLowerCase() === "true";
      var documentos = cantidad * (1 + copias(datos.copias) + (imprimirPequeno ? 2 + copias(datos.copiasPequeno) : 0));
      if (String(datos.imprimirMaletas).toLowerCase() === "true" && Array.isArray(datos.boletos)) {
        documentos += datos.boletos.reduce((total, boleto) => total + copias(boleto.cantidad_maletas), 0);
      }
      // El servicio imprime cada documento en serie; se reserva otro minuto para el dialogo.
      return Math.min(600000, 60000 + documentos * 60000);
    },
    esTiempoEsperaImpresion(error) {
      return Boolean(error && (error.code === "ECONNABORTED" || error.code === "ETIMEDOUT"));
    },
    mostrarErrorImpresion(prefijo, error, pendiente) {
      if (this.contexto.vistaPreviaPdf) {
        if (pendiente) pendiente.confirmacionPendiente = false;
        this.mostrarMensaje(prefijo + ". No se pudo generar la vista previa PDF. Use Reimprimir para intentar nuevamente sin registrar otra venta.", "warning", pendiente);
        return;
      }
      var sinConfirmacion = this.esTiempoEsperaImpresion(error);
      if (pendiente) {
        pendiente.confirmacionPendiente = sinConfirmacion;
      }
      var detalle = sinConfirmacion
        ? ". No se recibio confirmacion de impresion a tiempo. Puede haberse impreso; verifique la impresora antes de reimprimir."
        : ". No se pudo imprimir.";
      if (sinConfirmacion) {
        console.warn("Impresion sin confirmacion; no se reenviara automaticamente.", error);
      } else {
        console.error("Error al imprimir el documento.", error);
      }
      this.mostrarMensaje(prefijo + detalle, "warning", pendiente);
    },
    async postImpresoraLocal(path, datos) {
      var urls = this.urlImpresoraLocal(path);
      var timeout = this.tiempoEsperaImpresion(datos);
      var ultimoError = null;
      for (const url of urls) {
        try {
          const respuesta = await this.$axios.post(url, datos, { timeout: timeout });
          const avisos = respuesta.data && respuesta.data.advertencias;
          if (Array.isArray(avisos) && avisos.length) window.alert(avisos.join("\n\n"));
          return respuesta;
        } catch (error) {
          ultimoError = error;
          if (error.response || this.esTiempoEsperaImpresion(error)) {
            throw error;
          }
        }
      }
      throw ultimoError;
    },
    mostrarMensaje(texto, tipo, reimpresionPendiente) {
      this.mensaje = texto;
      this.mensajeTipo = tipo;
      this.reimpresionPendiente = reimpresionPendiente || null;
    },
    // Llamar a una función en un componente secundario para los permisos de usuario.
    funcionValidaPermisoPv(e) {
      var Sudo = this.$store.getters.GetdatosInfUsu.usuario.sudo
      var permiso = this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList

      //if (Sudo == false) { }
      var obj = {
        accion: JSON.parse(JSON.stringify(e)),
        Permiso: permiso,
        Sudo: Sudo
      }
      this.$refs.RefPvMenuOpcionBotones.ClickAccionPadreEjecut(obj)
    }, 

    DataRetornMenuOpcBotonesPermisosPv(e) {

    },

    DataRetornPadrePermisoPv(e) {
    if (e == 'AccCambiarCajaTransporte') {
        this.EjecutarPermisoPv = true
        var _this = this;
        setTimeout(function () {
          _this.continuarCambiarConfiguracionCaja();
          _this.EjecutarPermisoPv = false
        }, 500);
        return;
      }

      if (e == 'AccComprobantesECFTrasporte') {
        this.EjecutarPermisoPv = true
        var _this = this;
        setTimeout(function () {
          _this.continuarAbrirComprobantesElectronicos();
          _this.EjecutarPermisoPv = false
        }, 500);
        return;
      }

      if (e == 'AccCambiarCapacidadTransporte') {
        this.EjecutarPermisoPv = true
        var _this = this;
        setTimeout(function () {
          _this.continuarAbrirCapacidad();
          _this.EjecutarPermisoPv = false
        }, 500);
        return;
      }


    },
  },
};
</script>

<style scoped>
.pvt-fiscal-status { grid-column: 1 / -1; font-size: 12px; color: #365973; overflow-wrap: anywhere; }
.pvt-fiscal-status.aviso { color: #765600; }
.pvt-fiscal-status.error { color: #ad2424; }
.pvt-root {
  background: #101820;
  color: #f4f7fb;
  font-family: "Segoe UI", Arial, sans-serif;
  min-height: calc(100vh - 70px);
  border: 1px solid #354555;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  position: relative;
}

.pvt-ecf-search {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-left: auto;
  max-width: 100%;
}

.pvt-ecf-search input {
  width: 200px;
  max-width: 100%;
}

.pvt-topbar {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, max-content));
  gap: 8px;
  padding: 3px 8px;
  background: #376b92;
  font-size: 12px;
  font-weight: 500;
}

.pvt-topbar-line {
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  color: #eaf5ff;
  align-items: center;
}

.pvt-link-btn {
  justify-self: start;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: transparent;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 7px;
  cursor: pointer;
}

.pvt-setup {
  width: min(720px, calc(100vw - 36px));
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.35);
}

.pvt-consulta-viajes {
  width: min(1100px, calc(100vw - 36px));
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.35);
}

.pvt-consulta-table {
  max-height: 420px;
  margin-top: 8px;
  overflow: auto;
}

.pvt-ecf-dialog {
  max-height: calc(100vh - 140px);
  overflow: auto;
}

.pvt-ecf-dialog .pvt-dialog-actions {
  flex-wrap: wrap;
  align-items: center;
}

.pvt-ecf-dialog .pvt-table {
  min-width: 680px;
}

.pvt-ecf-result {
  min-width: 220px;
  white-space: normal;
  overflow-wrap: anywhere;
}

.pvt-ecf-actions {
  min-width: 150px;
  white-space: normal;
}

.pvt-ecf-actions .pvt-action {
  margin: 2px;
}

.pvt-consulta-table tbody tr {
  cursor: pointer;
  background: #fff;
}

.pvt-consulta-table table {
  width: 100%;
  border-collapse: collapse;
}

.pvt-consulta-table th,
.pvt-consulta-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ccd6df;
}

.pvt-root .pvt-consulta-table td {
  color: #18202a;
}

.pvt-consulta-table tbody tr:nth-child(even) {
  background: #f5f7fa;
}

.pvt-consulta-table tbody tr:hover,
.pvt-consulta-table tbody tr:focus {
  background: #eaf0f4;
}

.pvt-root .pvt-cierre-estado {
  font-weight: 700;
  white-space: nowrap;
}

.pvt-root .pvt-cierre-estado.abierto {
  color: #24714b;
}

.pvt-root .pvt-cierre-estado.cerrado {
  color: #526273;
}

.pvt-setup-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: grid;
  place-items: start center;
  padding-top: 108px;
  background: rgba(6, 13, 19, 0.52);
}

.pvt-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 5px 6px;
  background: #18222d;
  border-bottom: 1px solid #354555;
}

.pvt-tab,
.pvt-action,
.pvt-search-btn {
  border: 1px solid #354555;
  background: #1f2b37;
  color: #f4f7fb;
  font-weight: 600;
  cursor: pointer;
}

.pvt-tab {
  padding: 7px 9px;
  font-size: 11px;
}

.pvt-tab.active {
  background: #2f6f9f;
  border-color: #2f6f9f;
}

.pvt-screen {
  padding: 5px;
  overflow-x: hidden;
}

.pvt-grid-main {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(320px, 0.85fr);
  gap: 5px;
  align-items: start;
  max-width: 100%;
}

.pvt-grid-envios {
  grid-template-columns: minmax(0, 1.75fr) minmax(260px, 0.65fr);
}

.pvt-panel {
  background: #202d39;
  border: 1px solid #354555;
  padding: 5px;
  min-width: 0;
  box-sizing: border-box;
}

.pvt-actions {
  display: grid;
  grid-template-columns: repeat(6, minmax(68px, 1fr));
  gap: 4px;
  margin-bottom: 5px;
}

.pvt-envio-trip-head {
  display: grid;
  grid-template-columns: 192px minmax(0, 1fr);
  gap: 5px;
  align-items: end;
  margin-bottom: 5px;
}

.pvt-envio-actions {
  grid-template-columns: 1fr;
  margin-bottom: 0;
}

.pvt-envio-trip-primary {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-bottom: 0;
}

.pvt-envio-trip-secondary {
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.7fr);
}

.pvt-envio-new-turn {
  align-self: end;
  justify-self: start;
  width: 192px;
  max-width: 100%;
}

.pvt-envio-trip-primary label,
.pvt-envio-trip-secondary label {
  color: #000000;
  font-size: 12px;
  font-weight: 700;
}

.pvt-action {
  min-height: 38px;
  padding: 6px;
  font-size: 13px;
}

.pvt-trip-box {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  margin-bottom: 5px;
}

.pvt-trip-box label,
.pvt-ticket label,
.pvt-fiscal-data label,
.pvt-dialog-grid label {
  display: grid;
  gap: 2px;
  font-size: 11px;
  color: #a8b4c2;
}

.pvt-trip-box div {
  background: #1f2b37;
  border: 1px solid #354555;
  padding: 4px;
}

.pvt-trip-box span {
  display: block;
  color: #a8b4c2;
  font-size: 11px;
}

input,
select,
textarea {
  border: 1px solid #354555;
  background: #18222d;
  color: #f4f7fb;
  padding: 4px 6px;
  min-width: 0;
}

.pvt-trip-box select {
  cursor: pointer;
}

.pvt-trip-box .pvt-trip-select {
  appearance: auto;
  width: 100%;
  min-width: 0;
}

.pvt-search {
  display: grid;
  grid-template-columns: 62px 1fr;
  gap: 5px;
  margin-bottom: 5px;
}

.pvt-route-list {
  min-height: 188px;
  max-height: 188px;
  overflow-y: auto;
  border: 1px solid #354555;
  background: #18222d;
  padding: 4px;
}

.pvt-route-list.envio {
  min-height: 170px;
  max-height: 170px;
}

.pvt-route {
  width: 100%;
  min-height: 20px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 6px;
  align-items: center;
  border: 0;
  border-bottom: 1px solid #354555;
  background: transparent;
  color: #f4f7fb;
  padding: 3px 6px;
  font-size: 12px;
  text-align: left;
  cursor: pointer;
}

.pvt-route.selected {
  background: #2f6f9f;
}

.pvt-ticket {
  min-height: 112px;
  border: 1px dashed #354555;
  background: #2c2b1f;
  padding: 8px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  align-items: center;
}

.pvt-ticket h2 {
  margin: 0;
  font-size: 15px;
  line-height: 1.2;
  text-transform: uppercase;
}

.pvt-ticket p {
  margin: 4px 0;
  font-size: 12px;
}

.pvt-pay,
.pvt-fiscal-data,
.pvt-dialog-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
}

.pvt-fiscal-address {
  grid-column: 1 / -1;
}

.pvt-ticket-quantity {
  max-width: 180px;
}

.pvt-baggage {
  grid-column: 1 / -1;
  min-width: 0;
  margin: 0;
  padding: 8px 0 0;
  border: 0;
}

.pvt-baggage legend {
  padding: 0;
  font-size: 13px;
  font-weight: 700;
}

.pvt-baggage-fields {
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr) minmax(150px, 220px);
  gap: 8px;
}

.pvt-baggage-fields label {
  min-width: 0;
}

@media screen and (max-width: 600px) {
  .pvt-baggage-fields {
    grid-template-columns: minmax(0, 1fr);
  }
}

.pvt-total-line {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  font-size: 12px;
  margin-top: 2px;
}

.pvt-total-line.total {
  font-weight: 700;
}

.pvt-selected {
  background: #1f2b37;
  border: 1px solid #354555;
  padding: 7px;
  margin-bottom: 6px;
  font-weight: 600;
}

.pvt-fiscal {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 5px;
  margin-bottom: 5px;
}

.pvt-pay input {
  min-height: 28px;
}

.pvt-pay label {
  display: grid;
  gap: 2px;
  color: #405160;
  font-size: 12px;
  font-weight: 600;
}

.pvt-print-options {
  margin-top: 6px;
  display: grid;
  grid-template-columns: 1fr 82px 128px;
  gap: 5px;
  align-items: end;
  font-size: 12px;
}

.pvt-print-options label {
  display: grid;
  gap: 2px;
}

.pvt-print-options input[type="number"] {
  min-height: 28px;
}

.pvt-print-options.boletos {
  grid-template-columns: 82px 128px;
  justify-content: start;
}

.pvt-check {
  grid-template-columns: 18px 1fr;
  align-items: center;
  min-height: 28px;
}

.pvt-change {
  margin-top: 6px;
  padding: 6px;
  text-align: center;
  font-size: 22px;
  background: #18222d;
  border: 1px solid #354555;
}

.pvt-finish {
  width: 100%;
  margin-top: 6px;
  border: 0;
  background: #2f6f9f;
  color: #ffffff;
  padding: 8px;
  font-size: 25px;
  font-weight: 700;
  cursor: pointer;
}

.pvt-finish:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.pvt-message {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 6px;
  padding: 6px;
  border: 1px solid #354555;
}

.pvt-message.ok {
  color: #46c58f;
}

.pvt-message.error {
  color: #000000;
  background: #ff5252;
  border-color: #b72a2a;
  font-weight: 600;
}

.pvt-message.warning {
  color: #000;
  background: #ff9800;
  border-color: #b96b00;
}

.pvt-message-action {
  flex: 0 0 auto;
  padding: 4px 10px;
  border: 1px solid #8f6500;
  background: #fff;
  color: #000;
  font-weight: 700;
  cursor: pointer;
}

.pvt-message-action:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.pvt-dialog-actions {
  display: flex;
  gap: 6px;
  margin-top: 8px;
}

.pvt-recargo-layout {
  display: grid;
  grid-template-columns: 1fr 86px;
  gap: 8px;
  align-items: end;
}

.pvt-stepper {
  display: grid;
  gap: 5px;
}

.pvt-search-line {
  display: grid;
  gap: 3px;
  margin-top: 7px;
  font-size: 12px;
  color: #a8b4c2;
}

.pvt-list {
  margin-top: 6px;
  border: 1px solid #354555;
  background: #18222d;
  min-height: 190px;
  max-height: 260px;
  overflow: auto;
}

.pvt-list-item {
  width: 100%;
  min-height: 32px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  align-items: center;
  border: 0;
  border-bottom: 1px solid #354555;
  background: transparent;
  color: #f4f7fb;
  padding: 6px 8px;
  text-align: left;
  cursor: pointer;
}

.pvt-list-item:hover {
  background: #263646;
}

.pvt-recepcion-card {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 10px;
}

.pvt-recepcion-card div {
  display: grid;
  gap: 4px;
  min-height: 54px;
  border: 1px solid #354555;
  background: #101820;
  padding: 8px;
}

.pvt-recepcion-card div.wide {
  grid-column: 1 / -1;
}

.pvt-recepcion-card span {
  color: #a8b4c2;
  font-size: 11px;
  text-transform: uppercase;
}

.pvt-recepcion-card strong {
  color: #ffffff;
  overflow-wrap: anywhere;
}

.pvt-entrega-grid {
  display: grid;
  grid-template-columns: minmax(680px, 1.2fr) minmax(320px, 0.8fr);
  gap: 8px;
  margin-top: 8px;
}

.pvt-entrega-table {
  max-height: 210px;
  min-height: 180px;
}

.pvt-entrega-table tr {
  cursor: pointer;
}

.pvt-entrega-table tr.selected td {
  background: #2f6f9f;
  color: #ffffff;
}

.pvt-boarding-head.pvt-entrega-head {
  grid-template-columns: minmax(300px, 470px) 150px 150px 240px 96px 86px 88px;
  align-items: end;
}

.pvt-entrega-head .pvt-action {
  min-height: 30px;
  padding: 4px 8px;
}

.pvt-entrega-head .pvt-entrega-back {
  width: 88px;
  justify-self: start;
}

.pvt-entrega-desde input,
.pvt-entrega-hasta input {
  width: 100%;
  max-width: 150px;
  min-width: 0;
}

.pvt-entrega-print {
  margin-top: 8px;
  justify-content: start;
  color: #000000;
  font-weight: 700;
}

.pvt-entrega-detail {
  margin-top: 8px;
  border: 1px solid #354555;
  background: #18222d;
  padding: 7px;
}

.pvt-entrega-detail h4 {
  margin: 0 0 7px;
  padding: 5px;
  background: #05090d;
  color: #ffffff;
  text-align: center;
}

.pvt-entrega-info {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.pvt-entrega-info div {
  display: grid;
  gap: 3px;
  min-height: 48px;
  border: 1px solid #354555;
  background: #101820;
  padding: 7px;
}

.pvt-entrega-info .wide {
  grid-column: 1 / -1;
}

.pvt-entrega-info .pago-destino strong {
  color: #ff727d;
  font-size: 20px;
}

.pvt-entrega-info span {
  color: #a8b4c2;
  font-size: 11px;
  text-transform: uppercase;
}

.pvt-entrega-info strong {
  color: #ffffff;
  overflow-wrap: anywhere;
}

.pvt-entrega-actions {
  display: grid;
  grid-template-columns: max-content 180px;
  gap: 8px;
  align-items: center;
  margin-top: 2px;
}

.pvt-entrega-actions label {
  display: grid;
  grid-template-columns: max-content 230px;
  gap: 8px;
  align-items: center;
  color: #a8b4c2;
  font-size: 12px;
}

.pvt-cedula-aviso {
  grid-column: 1 / -1;
  box-sizing: border-box;
  max-width: calc(100vw - 48px);
  white-space: normal;
}

.pvt-fin-envios-table {
  margin-top: 8px;
  min-height: 280px;
  max-height: 520px;
}

.pvt-cancel-toolbar {
  display: grid;
  grid-template-columns: 386px 360px 105px 105px 170px 86px 86px 190px;
  gap: 7px;
  align-items: end;
}

.pvt-cancel-toolbar .pvt-cancel-filter {
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}

.pvt-cancel-toolbar label,
.pvt-cancel-actions label {
  display: grid;
  gap: 3px;
  color: #a8b4c2;
  font-size: 12px;
}

.pvt-cancel-date,
.pvt-cancel-cashier {
  width: 100%;
}

.pvt-cancel-table {
  margin-top: 8px;
  min-height: 170px;
  max-height: 260px;
}

.pvt-cancel-table tr {
  cursor: pointer;
}

.pvt-cancel-table tr.selected td {
  background: #2f6f9f;
  color: #ffffff;
}

.pvt-cancel-actions {
  display: grid;
  grid-template-columns: 160px 160px 140px 180px minmax(0, 1fr);
  gap: 8px;
  margin-top: 5px;
  padding: 5px 8px;
  border: 1px solid #354555;
  background: #18222d;
  align-items: start;
}

.pvt-cancel-action-btn {
  height: 62px;
  min-height: 62px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.pvt-cancel-actions textarea {
  min-height: 48px;
  resize: vertical;
}

.pvt-cancel-reason {
  color: #000000 !important;
  font-size: 13px !important;
  font-weight: 700;
}

.pvt-action.danger {
  background: #7d2732;
  border-color: #b64755;
}

.pvt-cancel-actions .pvt-cancel-action-btn.danger {
  color: #ffffff;
}

.pvt-empty {
  padding: 12px;
  color: #a8b4c2;
}

.pvt-segment {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  margin-bottom: 8px;
}

.pvt-segment button {
  min-height: 38px;
  border: 1px solid #354555;
  background: #18222d;
  color: #f4f7fb;
  cursor: pointer;
}

.pvt-segment button.activo {
  background: #2f6f9f;
  border-color: #77b7dd;
}

.pvt-segment button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.pvt-segment.mini {
  margin-bottom: 0;
}

.pvt-segment.mini button {
  min-height: 32px;
}

.pvt-client-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 7px;
}

.pvt-client-grid > div {
  border: 1px solid #354555;
  background: #1f2b37;
  padding: 6px;
}

.pvt-client-grid > .pvt-seat-status {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 16px;
}

.pvt-pending-seats {
  display: block;
  font-size: 11px;
}

.pvt-client-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px 8px;
}

.pvt-client-grid h4 {
  margin: 0 0 6px;
  padding: 4px 6px;
  background: #111923;
  color: #f4f7fb;
  text-align: center;
  font-size: 13px;
}

.pvt-client-grid label,
.pvt-envio-options label,
.pvt-package-entry label {
  display: grid;
  gap: 3px;
  margin-bottom: 5px;
  font-size: 12px;
  color: #a8b4c2;
}

.pvt-package-entry-actions,
.pvt-package-row-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pvt-package-entry-actions .pvt-action {
  flex: 1;
  min-width: 0;
  padding: 8px 5px;
}

.pvt-root .pvt-package-icon {
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  padding: 0;
}

.pvt-root .pvt-package-icon:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pvt-package-edit-status {
  color: #244f70;
  font-weight: 700;
  margin: 6px 0;
}

.pvt-envio-options {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 140px;
  gap: 8px;
  align-items: end;
  margin-bottom: 7px;
}

.pvt-envio-options .pvt-segment.mini {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 5px;
}

.pvt-envio-options .pvt-segment.mini button {
  min-height: 28px;
  padding: 3px 6px;
  font-size: 13px;
}

.pvt-calc-price-group {
  border: 1px solid #6f6a62;
  padding: 4px 6px 6px;
  background: rgba(255, 255, 255, 0.28);
}

.pvt-calc-price-group .pvt-segment.mini {
  max-width: 80%;
}

.pvt-calc-price-group .pvt-segment.mini button {
  min-height: 22px;
  padding: 2px 5px;
}

.pvt-envio-options span {
  display: block;
  margin-bottom: 4px;
  color: #000000;
  font-size: 13px;
  font-weight: 700;
}

.pvt-envio-options .pvt-check {
  color: #000000;
  font-size: 13px;
  font-weight: 700;
}

.pvt-package-entry {
  display: grid;
  grid-template-columns: minmax(185px, 0.72fr) minmax(90px, 0.28fr) minmax(90px, 0.28fr) minmax(90px, 0.28fr) minmax(244px, 1.13fr) 118px minmax(0, 1fr);
  gap: 6px;
  align-items: end;
}

.pvt-package-entry label {
  color: #000000;
  font-size: 13px;
  font-weight: 700;
}

.pvt-package-route,
.pvt-package-description {
  min-width: 0;
}

.pvt-package-entry .wide {
  min-width: 0;
  grid-column: span 2;
}

.pvt-route-picker {
  border: 1px solid #354555;
  background: #18222d;
  margin-bottom: 7px;
  padding: 6px;
}

.pvt-route-picker .pvt-search {
  margin-bottom: 6px;
}

.pvt-envio-table-wrap {
  margin-top: 7px;
  min-height: 112px;
  max-height: 190px;
  overflow: auto;
  border: 1px solid #354555;
  background: #18222d;
}

.pvt-envio-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.pvt-envio-table th,
.pvt-envio-table td {
  border-bottom: 1px solid #354555;
  padding: 5px;
  text-align: left;
}

.pvt-envio-table th {
  background: #243240;
  color: #d6e7f7;
}

.pvt-mini-btn {
  border: 1px solid #354555;
  background: #1f2b37;
  color: #f4f7fb;
  padding: 4px 6px;
  cursor: pointer;
}

.pvt-envio-footer {
  display: grid;
  grid-template-columns: max-content max-content 190px minmax(360px, 1fr);
  gap: 10px;
  align-items: center;
  margin-top: 7px;
}

.pvt-print-options.envio {
  margin-top: 0;
  grid-template-columns: 112px 112px;
  align-items: center;
  justify-self: end;
  width: min(100%, 236px);
}

.pvt-envio-footer > .pvt-check {
  align-items: center;
  white-space: nowrap;
}

.pvt-destination-list {
  min-height: 248px;
  border: 2px solid #d62f2f;
  background: #ffffff;
  padding: 8px;
  display: grid;
  grid-template-columns: repeat(2, minmax(130px, 1fr));
  align-content: start;
  gap: 8px;
}

.pvt-entrega-grid > div {
  min-width: 0;
}

.pvt-destination-list.compact {
  min-height: 0;
  border: 1px solid #354555;
  background: #101820;
  grid-template-columns: repeat(4, minmax(100px, 1fr));
  gap: 6px;
}

.pvt-destination {
  min-height: 110px;
  border: 1px solid #c9d0d8;
  background: #f8fafc;
  color: #111923;
  cursor: pointer;
  display: grid;
  align-content: center;
  gap: 8px;
  text-align: center;
}

.pvt-destination-list.compact .pvt-destination {
  min-height: 58px;
  border-color: #354555;
  background: #13202c;
  color: #f4f7fb;
  gap: 3px;
  padding: 6px;
}

.pvt-destination.selected {
  outline: 3px solid #2f6f9f;
}

.pvt-destination strong {
  font-size: 16px;
}

.pvt-destination-list.compact .pvt-destination strong {
  font-size: 12px;
}

.pvt-destination span {
  font-weight: 700;
}

.pvt-destination-list.compact .pvt-destination span {
  font-size: 12px;
  color: #d6e7f7;
}

.pvt-fiscal.envio {
  margin-top: 8px;
}

.pvt-envio-totals {
  margin-top: 8px;
  padding: 8px;
  border: 1px solid #354555;
  background: #18222d;
}

.pvt-envio-totals div {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  line-height: 1.55;
}

.pvt-envio-totals .total {
  margin-top: 4px;
  font-size: 18px;
  font-weight: 700;
}

.pvt-boarding-head {
  display: grid;
  grid-template-columns: 1.1fr 0.7fr 1.3fr 0.8fr 96px 96px;
  gap: 6px;
  align-items: end;
}

.pvt-boarding-head label {
  display: grid;
  gap: 3px;
  font-size: 13px;
  color: #173b63;
  font-weight: 600;
}

.pvt-boarding-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin-top: 8px;
}

.pvt-boarding-summary div {
  background: #1f2b37;
  border: 1px solid #354555;
  padding: 8px;
}

.pvt-boarding-summary strong {
  color: #ffffff;
}

.pvt-boarding-summary span {
  display: block;
  color: #a8b4c2;
  font-size: 12px;
  margin-bottom: 4px;
}

.pvt-boarding-tables {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 8px;
}

.pvt-boarding-tables h4 {
  margin: 0 0 5px;
  font-size: 14px;
  color: #173b63;
  font-weight: 700;
}

.pvt-boarding-tables table {
  width: 100%;
  border-collapse: collapse;
  background: #18222d;
  border: 1px solid #354555;
  font-size: 12px;
}

.pvt-boarding-tables th,
.pvt-boarding-tables td {
  border-bottom: 1px solid #354555;
  padding: 6px;
  text-align: left;
  color: #ffffff;
}

.pvt-boarding-tables th {
  color: #a8b4c2;
  font-weight: 600;
}

.pvt-close-head {
  display: grid;
  grid-template-columns: 1fr 0.75fr 0.75fr 1.2fr 96px 96px 104px;
  gap: 6px;
  align-items: end;
}

.pvt-close-head label,
.pvt-close-deductions label {
  display: grid;
  gap: 3px;
  font-size: 12px;
  color: #a8b4c2;
}

.pvt-close-stats {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px;
  margin-top: 8px;
}

.pvt-close-stats div,
.pvt-close-totals div {
  background: #1f2b37;
  border: 1px solid #354555;
  padding: 7px;
}

.pvt-close-stats span,
.pvt-close-totals span,
.pvt-close-deliver span {
  display: block;
  color: #a8b4c2;
  font-size: 12px;
  margin-bottom: 4px;
}

.pvt-close-stats strong,
.pvt-close-totals strong,
.pvt-close-deliver strong {
  color: #ffffff;
}

.pvt-close-grid {
  display: grid;
  grid-template-columns: minmax(620px, 1fr) 320px;
  gap: 8px;
  margin-top: 8px;
}

.pvt-close-table {
  overflow: auto;
  border: 1px solid #354555;
  max-height: 435px;
}

.pvt-close-table table {
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
  background: #18222d;
  font-size: 12px;
}

.pvt-close-table th,
.pvt-close-table td {
  border-bottom: 1px solid #354555;
  padding: 6px;
  text-align: left;
  color: #ffffff;
}

.pvt-close-table th {
  color: #a8b4c2;
  font-weight: 600;
}

.pvt-close-table tr.abordado td:last-child {
  color: #46c58f;
  font-weight: 700;
}

.pvt-close-table tr.no-abordado td:last-child {
  color: #ff727d;
  font-weight: 700;
}

.pvt-close-side {
  display: grid;
  gap: 8px;
  align-content: start;
}

.pvt-close-totals {
  display: grid;
  gap: 5px;
}

.pvt-close-deductions {
  border: 1px solid #354555;
  background: #18222d;
  padding: 7px;
  display: grid;
  gap: 6px;
}

.pvt-close-deductions h4 {
  margin: 0;
  font-size: 13px;
  color: #d6e7f7;
}

.pvt-close-bottom {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 8px;
  margin-top: 8px;
  align-items: stretch;
}

.pvt-close-deduction-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  align-items: end;
}

.pvt-close-deduction-grid .wide {
  grid-column: 1 / -1;
}

.pvt-close-deductions textarea {
  min-height: 48px;
  resize: vertical;
}

.pvt-close-deliver {
  border: 1px solid #354555;
  background: #101820;
  padding: 10px;
  text-align: right;
  display: grid;
  align-content: center;
}

.pvt-close-deliver strong {
  display: block;
  font-size: 25px;
  font-weight: 800;
  color: #000000;
}

.pvt-close-deliver span {
  color: #000000;
  font-size: 13px;
  font-weight: 700;
}

.pvt-cash-screen {
  padding-bottom: 10px;
}

.pvt-cash-title-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 6px;
}

.pvt-cash-title-row h3 {
  margin: 0;
}

.pvt-cash-close-number {
  border: 1px solid #b8aa94;
  background: #efe7d9;
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  padding: 5px 12px;
}

.pvt-cash-head {
  display: grid;
  grid-template-columns: minmax(640px, 1fr) auto;
  gap: 10px;
  align-items: end;
  margin-bottom: 8px;
}

.pvt-cash-head-fields {
  display: grid;
  grid-template-columns: 150px minmax(280px, 1fr) 260px;
  gap: 8px;
}

.pvt-cash-head-actions {
  display: grid;
  grid-template-columns: repeat(3, 96px);
  gap: 6px;
}

.pvt-cash-head label,
.pvt-cash-count label,
.pvt-pay-row label,
.pvt-denominations label {
  display: grid;
  gap: 3px;
  font-size: 12px;
  color: #22415f;
  font-weight: 600;
}

.pvt-cash-grid {
  display: grid;
  grid-template-columns: minmax(620px, 1fr) 360px;
  gap: 10px;
  margin-top: 8px;
  align-items: start;
}

.pvt-cash-count,
.pvt-cash-sales {
  border: 1px solid #c3b8a6;
  background: #f7f1e6;
  padding: 10px;
}

.pvt-cash-count h4,
.pvt-cash-sales h4 {
  margin: 0 0 9px;
  padding: 7px 9px;
  background: #d7d7d7;
  color: #000000;
  font-size: 17px;
  font-weight: 800;
  text-align: center;
}

.pvt-pay-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(120px, 1fr));
  gap: 8px;
  margin-top: 9px;
}

.pvt-cash-section-title {
  margin-top: 12px;
  color: #000000;
  font-size: 14px;
  font-weight: 800;
}

.pvt-denominations {
  display: grid;
  grid-template-columns: repeat(4, minmax(110px, 1fr));
  gap: 8px;
  margin-top: 6px;
}

.pvt-cash-total {
  margin-top: 12px;
  padding: 13px;
  border: 1px solid #c3b8a6;
  background: #fffaf0;
  color: #001833;
  font-size: 24px;
  font-weight: 800;
  text-align: center;
}

.pvt-cash-sales div {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center;
  border-bottom: 1px solid #b7b7b7;
  padding: 8px 10px;
  font-size: 12px;
  color: #000000;
}

.pvt-cash-sales span {
  color: #22415f;
  font-weight: 600;
}

.pvt-cash-sales strong {
  color: #000000;
  font-size: 13px;
  font-weight: 800;
}

.pvt-cash-sales .pvt-cash-sub {
  padding-left: 22px;
  font-size: 11px;
  background: #777d83;
}

.pvt-cash-sales .pvt-cash-sub span,
.pvt-cash-sales .pvt-cash-sub strong {
  color: #ffffff;
}

.pvt-cash-sales div:last-child {
  margin-top: 8px;
  border-bottom: 0;
  background: #e2e3e5;
}

.pvt-cash-diff {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: center;
  margin-top: 10px;
  border: 1px solid #c3b8a6;
  background: #fffaf0;
  padding: 12px 14px;
}

.pvt-cash-diff span {
  color: #000000;
  font-size: 22px;
  font-weight: 800;
}

.pvt-cash-diff strong {
  font-size: 34px;
  font-weight: 900;
  text-align: right;
}

.pvt-cash-diff.faltante strong {
  color: #ff727d;
}

.pvt-cash-diff.sobrante strong {
  color: #67a7ff;
}

.pvt-cash-diff.cuadrado strong {
  color: #46c58f;
}

.pvt-placeholder {
  border: 1px solid #354555;
  background: #18222d;
  padding: 12px;
}

.pvt-dgii-hidden {
  display: none;
}

.pvt-root {
  background: #f4efe4;
  color: #18202a;
  border-color: #c8bdab;
}

.pvt-tabs,
.pvt-panel,
.pvt-trip-box div,
.pvt-route-list,
.pvt-selected,
.pvt-fiscal,
.pvt-fiscal-data,
.pvt-pay,
.pvt-print-options,
.pvt-envio-options,
.pvt-route-picker,
.pvt-package-entry,
.pvt-envio-table,
.pvt-envio-footer,
.pvt-recargo-layout,
.pvt-list,
.pvt-discount-card,
.pvt-boarding-head,
.pvt-boarding-summary,
.pvt-boarding-tables,
.pvt-recepcion-card,
.pvt-entrega-table-wrap,
.pvt-entrega-info,
.pvt-entrega-actions,
.pvt-cancel-toolbar,
.pvt-cancel-table-wrap,
.pvt-cancel-actions,
.pvt-cancel-detail,
.pvt-close-head,
.pvt-close-stats,
.pvt-close-table-wrap,
.pvt-close-deductions,
.pvt-close-deliver,
.pvt-cash-count,
.pvt-cash-sales,
.pvt-cash-total,
.pvt-cash-diff,
.pvt-placeholder {
  background: #f8f4ec;
  border-color: #c8bdab;
  color: #18202a;
}

.pvt-ticket {
  background: #fff8dc;
  border-color: #b9a66d;
  color: #18202a;
}

.pvt-ticket h2,
.pvt-ticket p,
.pvt-ticket span,
.pvt-ticket label,
.pvt-ticket strong {
  color: #18202a;
}

.pvt-ticket h2 {
  font-size: 17px;
}

.pvt-ticket p,
.pvt-ticket label {
  font-size: 13px;
}

.pvt-total-line {
  font-size: 15px;
}

.pvt-total-line strong {
  font-weight: 800;
}

.pvt-ticket input {
  font-size: 13px;
}

.pvt-total-line.total {
  font-size: 18px;
}

.pvt-selected {
  color: #008c9e;
  font-size: 1.15em;
}

.pvt-tab,
.pvt-action,
.pvt-search-btn,
.pvt-mini-btn,
.pvt-segment button,
.pvt-recepcion-submit,
.pvt-entrega-submit,
.pvt-cancel-submit,
.pvt-report-btn,
.pvt-link-btn {
  background: linear-gradient(#ffffff, #e7ded1);
  border-color: #a99f91;
  color: #18202a;
}

.pvt-tab,
.pvt-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.pvt-tab {
  flex-direction: column;
  min-width: 90px;
  min-height: 61px;
  padding: 9px 11px;
  line-height: 1.05;
}

.pvt-tab i {
  font-size: 22px;
  color: #2f6f9f;
}

.pvt-tab.active i {
  color: #ffffff;
}

.pvt-action i {
  font-size: 19px;
  color: #2f6f9f;
}

.pvt-tab.active,
.pvt-route.selected,
.pvt-destination.selected,
.pvt-segment button.activo,
.pvt-finish {
  background: #3d6f93;
  border-color: #315b79;
  color: #ffffff;
}

.pvt-tab.active i,
.pvt-finish i {
  color: #ffffff;
}

.pvt-root input,
.pvt-root select,
.pvt-root textarea {
  background: #ffffff;
  border-color: #b8ad9d;
  color: #18202a;
}

.pvt-root input::placeholder,
.pvt-root textarea::placeholder {
  color: #7b7368;
}

.pvt-root input.pvt-ticket-step:focus {
  background: #e2f1ff;
  border-color: #1976d2;
  outline: 2px solid #1976d2;
  outline-offset: 1px;
}

.pvt-root input.pvt-ticket-step::selection {
  background: #1976d2;
  color: #ffffff;
}

.pvt-root .pvt-print-options input:disabled {
  background: #e9ecef;
  color: #64717d;
  cursor: not-allowed;
}

.pvt-trip-box label,
.pvt-trip-box span,
.pvt-client-grid label,
.pvt-client-fields label,
.pvt-package-entry label,
.pvt-print-options label,
.pvt-close-head label,
.pvt-close-deductions label,
.pvt-cash-count label,
.pvt-cancel-toolbar label,
.pvt-recepcion-card label,
.pvt-entrega-grid label,
.pvt-fiscal-data label {
  color: #405160;
}

.pvt-client-grid > div label,
.pvt-client-grid > div .pvt-client-fields label,
.pvt-envio-totals,
.pvt-envio-totals span,
.pvt-envio-totals strong {
  color: #ffffff;
}

.pvt-route,
.pvt-destination,
.pvt-list button {
  background: #ffffff;
  border-color: #ddd3c2;
  color: #18202a;
}

.pvt-route:hover,
.pvt-destination:hover,
.pvt-list button:hover {
  background: #edf6fb;
}

.pvt-root table,
.pvt-root th,
.pvt-root td {
  border-color: #c8bdab;
  color: #18202a;
}

.pvt-root .pvt-boarding-summary strong,
.pvt-root .pvt-boarding-tables td {
  color: #ffffff;
}

.pvt-root .pvt-close-stats strong,
.pvt-root .pvt-close-totals strong,
.pvt-root .pvt-close-table td {
  color: #ffffff;
}

.pvt-root .pvt-close-deliver strong,
.pvt-root .pvt-close-deliver span {
  color: #000000;
}

.pvt-root .pvt-close-table tr.abordado td:last-child {
  color: #46c58f;
}

.pvt-root .pvt-close-table tr.no-abordado td:last-child {
  color: #ff727d;
}

.pvt-trip-close-screen .pvt-close-stats > div,
.pvt-trip-close-screen .pvt-close-totals > div,
.pvt-trip-close-screen .pvt-close-deliver {
  background: #eaf0f4;
  border-color: #ccd6df;
}

.pvt-root .pvt-trip-close-screen .pvt-close-stats span,
.pvt-root .pvt-trip-close-screen .pvt-close-totals span,
.pvt-root .pvt-trip-close-screen .pvt-close-deliver span,
.pvt-trip-close-screen .pvt-close-deductions h4 {
  color: #526273;
}

.pvt-root .pvt-trip-close-screen .pvt-close-stats strong,
.pvt-root .pvt-trip-close-screen .pvt-close-totals strong,
.pvt-root .pvt-trip-close-screen .pvt-close-deliver strong {
  color: #18202a;
}

.pvt-trip-close-screen .pvt-close-totals span {
  font-size: 14px;
}

.pvt-trip-close-screen .pvt-close-table,
.pvt-trip-close-screen .pvt-close-table table {
  background: #ffffff;
  border-color: #ccd6df;
}

.pvt-trip-close-screen .pvt-close-table tbody tr {
  background: #ffffff;
}

.pvt-trip-close-screen .pvt-close-table tbody tr:nth-child(even) {
  background: #f5f7fa;
}

.pvt-root .pvt-trip-close-screen .pvt-close-table td {
  color: #18202a;
  border-color: #ccd6df;
}

.pvt-root .pvt-trip-close-screen .pvt-close-table tr.abordado td:last-child {
  color: #1f7545;
}

.pvt-root .pvt-trip-close-screen .pvt-close-table tr.no-abordado td:last-child {
  color: #c5343c;
}

.pvt-lectura-screen .pvt-boarding-summary > div {
  background: #eaf0f4;
  border-color: #ccd6df;
}

.pvt-root .pvt-lectura-screen .pvt-boarding-summary span {
  color: #526273;
}

.pvt-root .pvt-lectura-screen .pvt-boarding-summary strong {
  color: #18202a;
}

.pvt-lectura-screen .pvt-boarding-tables table,
.pvt-lectura-screen .pvt-boarding-tables tbody tr {
  background: #ffffff;
  border-color: #ccd6df;
}

.pvt-lectura-screen .pvt-boarding-tables tbody tr:nth-child(even) {
  background: #f5f7fa;
}

.pvt-root .pvt-lectura-screen .pvt-boarding-tables td {
  color: #18202a;
  border-color: #ccd6df;
}

.pvt-root .pvt-lectura-screen .pvt-boarding-tables tr.abordado td {
  color: #1f7545;
}

.pvt-root .pvt-lectura-screen .pvt-boarding-tables tr.ya-abordado td {
  color: #c5343c;
}

.pvt-envio-screen .pvt-client-grid > div,
.pvt-envio-screen .pvt-envio-totals,
.pvt-recepcion-card > div,
.pvt-entrega-screen .pvt-envio-totals,
.pvt-entrega-detail,
.pvt-entrega-info,
.pvt-entrega-info > div {
  background: #eaf0f4;
  border-color: #ccd6df;
}

.pvt-envio-screen .pvt-client-grid h4,
.pvt-entrega-detail h4 {
  background: #eaf0f4;
  border-bottom: 1px solid #ccd6df;
  color: #18202a;
}

.pvt-root .pvt-envio-screen .pvt-client-fields label,
.pvt-root .pvt-recepcion-card span,
.pvt-root .pvt-envio-screen .pvt-envio-totals span,
.pvt-root .pvt-entrega-screen .pvt-envio-totals span,
.pvt-root .pvt-entrega-info span {
  color: #526273;
}

.pvt-root .pvt-envio-screen .pvt-client-fields input {
  border-color: #ccd6df;
}

.pvt-root .pvt-envio-screen .pvt-envio-totals,
.pvt-root .pvt-envio-screen .pvt-envio-totals strong,
.pvt-root .pvt-recepcion-card strong,
.pvt-root .pvt-envio-screen .pvt-envio-totals .total span,
.pvt-root .pvt-entrega-screen .pvt-envio-totals,
.pvt-root .pvt-entrega-screen .pvt-envio-totals strong,
.pvt-root .pvt-entrega-screen .pvt-envio-totals .total span,
.pvt-root .pvt-entrega-info strong {
  color: #18202a;
}

.pvt-root .pvt-entrega-info .pago-destino strong {
  color: #c5343c;
}

.pvt-envio-screen .pvt-envio-table-wrap,
.pvt-envio-screen .pvt-envio-table,
.pvt-envio-screen .pvt-envio-table tbody tr,
.pvt-fin-envios-screen .pvt-fin-envios-table,
.pvt-fin-envios-screen .pvt-fin-envios-table table,
.pvt-fin-envios-screen .pvt-fin-envios-table tbody tr,
.pvt-entrega-screen .pvt-entrega-table,
.pvt-entrega-screen .pvt-entrega-table table,
.pvt-entrega-screen .pvt-entrega-table tbody tr,
.pvt-cancel-screen .pvt-cancel-table,
.pvt-cancel-screen .pvt-cancel-table table,
.pvt-cancel-screen .pvt-cancel-table tbody tr {
  background: #ffffff;
  border-color: #ccd6df;
}

.pvt-envio-screen .pvt-envio-table tbody tr:nth-child(even),
.pvt-fin-envios-screen .pvt-fin-envios-table tbody tr:nth-child(even),
.pvt-entrega-screen .pvt-entrega-table tbody tr:nth-child(even),
.pvt-cancel-screen .pvt-cancel-table tbody tr:nth-child(even) {
  background: #f5f7fa;
}

.pvt-envio-screen .pvt-envio-table tbody tr.pvt-package-editing {
  background: #e6f1fa;
  box-shadow: inset 3px 0 #426f92;
}

.pvt-root .pvt-envio-screen .pvt-envio-table td,
.pvt-root .pvt-fin-envios-screen .pvt-fin-envios-table td,
.pvt-root .pvt-entrega-screen .pvt-entrega-table td,
.pvt-root .pvt-cancel-screen .pvt-cancel-table td {
  color: #18202a;
  border-color: #ccd6df;
}

.pvt-entrega-screen .pvt-entrega-table tr.selected td,
.pvt-cancel-screen .pvt-cancel-table tr.selected td {
  background: #e6f1fa;
}

.pvt-entrega-screen .pvt-entrega-table tr.selected td:first-child,
.pvt-cancel-screen .pvt-cancel-table tr.selected td:first-child {
  box-shadow: inset 3px 0 #426f92;
}

.pvt-root .pvt-cash-screen .pvt-cash-count,
.pvt-root .pvt-cash-screen .pvt-cash-sales {
  background: #f7f1e6;
  border-color: #c3b8a6;
  color: #18202a;
}

.pvt-root .pvt-cash-screen .pvt-cash-total,
.pvt-root .pvt-cash-screen .pvt-cash-diff {
  background: #fffaf0;
  border-color: #c3b8a6;
}

.pvt-root .pvt-cash-screen .pvt-cash-total {
  color: #001833;
}

.pvt-root .pvt-cash-screen .pvt-cash-sales .pvt-cash-sub {
  background: #777d83;
}

.pvt-root .pvt-cash-screen .pvt-cash-sales .pvt-cash-sub span,
.pvt-root .pvt-cash-screen .pvt-cash-sales .pvt-cash-sub strong {
  color: #ffffff;
}

.pvt-root th {
  background: #3d6f93;
  color: #ffffff;
}

.pvt-change {
  background: #ffffff;
  border-color: #c8bdab;
  color: #18202a;
}

.pvt-setup-overlay {
  background: rgba(48, 43, 36, 0.46);
}

@media screen and (max-width: 900px) {
  .pvt-root .pvt-entrega-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .pvt-grid-main,
  .pvt-ticket {
    grid-template-columns: 1fr;
  }

  .pvt-actions,
  .pvt-envio-trip-head,
  .pvt-trip-box,
  .pvt-client-grid,
  .pvt-client-fields,
  .pvt-envio-options,
  .pvt-package-entry,
  .pvt-destination-list.compact,
  .pvt-boarding-head,
  .pvt-boarding-summary,
  .pvt-boarding-tables,
  .pvt-recepcion-card,
  .pvt-entrega-grid,
  .pvt-entrega-info,
  .pvt-entrega-actions,
  .pvt-cancel-toolbar,
  .pvt-cancel-actions,
  .pvt-close-head,
  .pvt-close-stats,
  .pvt-close-grid,
  .pvt-cash-head,
  .pvt-cash-head-fields,
  .pvt-cash-grid,
  .pvt-pay-row,
  .pvt-denominations {
    grid-template-columns: repeat(2, 1fr);
  }

  .pvt-cash-head-actions {
    grid-template-columns: repeat(3, 1fr);
  }

  .pvt-envio-actions {
    grid-column: span 2;
  }

  .pvt-package-entry .wide {
    grid-column: span 2;
  }
}

@media screen and (max-width: 560px) {
  .pvt-actions,
  .pvt-envio-trip-head,
  .pvt-trip-box,
  .pvt-client-grid,
  .pvt-client-fields,
  .pvt-envio-options,
  .pvt-package-entry,
  .pvt-destination-list.compact,
  .pvt-recepcion-card,
  .pvt-entrega-grid,
  .pvt-entrega-info,
  .pvt-entrega-actions,
  .pvt-cancel-toolbar,
  .pvt-cancel-actions,
  .pvt-cash-head,
  .pvt-cash-head-fields,
  .pvt-cash-head-actions,
  .pvt-cash-grid,
  .pvt-pay-row,
  .pvt-denominations,
  .pvt-pay,
  .pvt-fiscal,
  .pvt-print-options,
  .pvt-print-options.envio {
    grid-template-columns: 1fr;
  }

  .pvt-package-entry .wide {
    grid-column: auto;
  }

  .pvt-envio-actions {
    grid-column: auto;
  }

  .pvt-recepcion-card div.wide {
    grid-column: auto;
  }

  .pvt-entrega-info .wide {
    grid-column: auto;
  }
}
</style>
